/* ==========================================================
   Jullens winkelmodule – tablet-shell + medewerkerscherm (fase 3)
   + weekreclame huidige week en vijf weken vooruit (fase 4)
   + Onze producten: de 12 hoofdblokken in 4 x 3 (fase 5)
   + subcategorieen en productoverzichten in 4 x 3 op elk niveau (fase 6)
   + aantalbediening (- / aantal / +) en productinformatie (fase 7)
   + vaste navigatie en winkelmandweergave (fase 8)
   + afronden via de bestaande Jullens-trechter /pages/bestelling-afronden (fase 9)
   + staffelkorting AAN/UIT per bestelling voor Vincent en Erica (fase 10)
   + v12: basisvariant met open reeks ("25+ stuks – normale prijs"); bij UIT
     blijft ieder aantal staan tegen normale prijs, er verdwijnt nooit een regel
   Alleen geladen door templates/page.winkelmodule.liquid.
   Aantallen gaan direct in de gewone Shopify-winkelwagen (/cart/*.js).
   v15: openstaande (geparkeerde) bestellingen via api.jullens.com (zie blok "v15").
   De trechter (v85) en BoomGate worden niet aangepast; de winkelmodule stuurt
   alleen door. Nog geen orderkoppeling (fase 11).

   Staffel (fase 10): uitsluitend de bestaande Shopify-staffelvarianten en
   hun prijzen. Het aantal bepaalt de variant: de reeks in de variantnaam
   ("50-99 stuks (10%)") moet het aantal bevatten, exact één treffer.
   Geen eigen kortingsberekening, geen vrije variantkeuze. Koud/Warm (en
   andere opties) zijn aparte families en worden niet opgeteld.

   Weekreclame-bron: dezelfde als de website (/pages/aanbiedingen):
   collectie aanbiedingen-1 + producttag reclame-JJJJ-MM-DD
   (= startdatum, geldig 7 dagen). Geen eigen reclameadministratie.

   Codes: worden NIET in dit bestand opgeslagen. Iedere medewerker kiest
   bij het eerste gebruik zelf een code (4-6 cijfers) op de tablet; alleen
   een SHA-256-hash staat in de opslag van de tablet zelf (localStorage).
   Dit is registratie van wie werkt, geen echte beveiliging.
   ========================================================== */
(function () {
  'use strict';

  var VERSIE = 32;   /* v32.4: zelfde hoofdversie; alleen productzoeken toegevoegd */

  /* ---------- Instellingen ---------- */
  /* v32: INACTIEF_MS (3 min) vervalt – de vijfminutenregeling (JullensSlot, fase 1b) regelt afmelden en vergrendelen */
  var WAARSCHUW_MS = 20000;        /* laatste 20 seconden melding tonen */
  var CODE_MIN = 4, CODE_MAX = 6;
  var MAX_POGINGEN = 5, BLOKKEER_MS = 30000;

  /* weergave: 'regulier' = dynamisch op laatst gebruikt, 'beheer' = klein achteraan
     staffel: recht op Staffelkorting AAN/UIT (pas gebruikt vanaf fase 10) */
  var MEDEWERKERS = [
    { id: 'vincent',  naam: 'Vincent',  rol: 'beheer',     weergave: 'regulier', staffel: true,  kleur: '#B8923A' },
    { id: 'erica',    naam: 'Erica',    rol: 'manager',    weergave: 'regulier', staffel: true,  kleur: '#C4735A' },
    { id: 'kimberly', naam: 'Kimberly', rol: 'medewerker', weergave: 'regulier', staffel: false, kleur: '#5E8C7F' },
    { id: 'yalenka',  naam: 'Yalenka',  rol: 'medewerker', weergave: 'regulier', staffel: false, kleur: '#7A6FB0' },
    { id: 'ryan',     naam: 'Ryan',     rol: 'beheer',     weergave: 'beheer',   staffel: false, kleur: '#4F6B65' },
    { id: 'bjorn',    naam: 'Bjorn',    rol: 'beheer',     weergave: 'beheer',   staffel: false, kleur: '#4F6B65' }
  ];

  var LS_LAATST = 'jwm_last_used', LS_CODES = 'jwm_codes', LS_BLOK = 'jwm_blokkade';

  /* ---------- v14: pc-modus + telefonische bestelling ----------
     IS_PC = apparaat met muis (fijne aanwijzer + hover); de winkeltablet valt hier nooit onder.
     De knop "Telefonisch" staat alleen op een pc. Aan = de volgende bestelling gaat naar de
     tablettrechter in telefonische modus (geen SMS, markering). Geldt voor één bestelling of
     tot de medewerker wisselt/afgemeld wordt. Opslag: sessionStorage (alleen dit tabblad). */
  var IS_PC = (function () { try { return window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { return false; } })();
  var SS_TELEFONISCH = 'jullens_telefonisch';
  var TABLETTRECHTER_URL = '/pages/tablettrechter';

  var doc = document.documentElement;
  var $ = function (id) { return document.getElementById(id); };

  /* ---------- Opslag ---------- */
  function lees(k, def) {
    try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : def; } catch (e) { return def; }
  }
  function schrijf(k, v) {
    try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {}
  }
  function hash(id, code) {
    var data = new TextEncoder().encode('jullens-winkelmodule|' + id + '|' + code);
    return crypto.subtle.digest('SHA-256', data).then(function (b) {
      return Array.prototype.map.call(new Uint8Array(b), function (x) {
        return ('0' + x.toString(16)).slice(-2);
      }).join('');
    });
  }
  function vind(id) {
    for (var i = 0; i < MEDEWERKERS.length; i++) if (MEDEWERKERS[i].id === id) return MEDEWERKERS[i];
    return null;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Volledig scherm ---------- */
  function isVolledig() {
    return !!(document.fullscreenElement || document.webkitFullscreenElement);
  }
  function naarVolledig() {
    if (isVolledig()) return Promise.resolve();
    var fn = doc.requestFullscreen || doc.webkitRequestFullscreen;
    if (!fn) return Promise.resolve();
    try {
      var p = fn.call(doc, { navigationUI: 'hide' });
      return Promise.resolve(p).then(vergrendelLiggend).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }
  function vergrendelLiggend() {
    try {
      if (screen.orientation && screen.orientation.lock) {
        screen.orientation.lock('landscape').catch(function () {});
      }
    } catch (e) {}
  }
  function wisselVolledig() {
    if (isVolledig()) {
      var ex = document.exitFullscreen || document.webkitExitFullscreen;
      if (ex) ex.call(document);
    } else {
      naarVolledig();
    }
  }
  document.addEventListener('pointerdown', function () { if (!IS_PC) naarVolledig(); houdSchermAan(); }, { once: true, capture: true });   /* v32.6 - 01-11-2026: op de pc geen automatisch volledig scherm (besluit Vincent); knop Volledig scherm blijft; tablet ongewijzigd */

  /* ---------- Scherm aan houden ---------- */
  var wakeLock = null;
  function houdSchermAan() {
    try {
      if ('wakeLock' in navigator && !wakeLock) {
        navigator.wakeLock.request('screen').then(function (wl) {
          wakeLock = wl;
          wl.addEventListener('release', function () { wakeLock = null; });
        }).catch(function () {});
      }
    } catch (e) {}
  }
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') houdSchermAan();
  });

  /* ---------- Ongewenst tabletgedrag ---------- */
  document.addEventListener('contextmenu', function (e) { e.preventDefault(); });
  document.addEventListener('gesturestart', function (e) { e.preventDefault(); });
  document.addEventListener('touchmove', function (e) {
    if (!e.target.closest || !e.target.closest('[data-wm-scroll]')) e.preventDefault();
  }, { passive: false });

  /* ==========================================================
     SESSIE
     ========================================================== */
  var sessie = null;            /* actieve medewerker of null */
  var bronGekozen = false;      /* v17: expliciete bronkeuze TELEFONISCH – WINKEL – PAPIER na aanmelden (ontwerp §2) */
  var recentWacht = null;       /* v17: bestelling uit de balk "Laatst afgerond" die na aanmelden geopend wordt */
  var laatsteActiviteit = Date.now();

  function startSessie(m) {
    sessie = m;
    staffelAan = false;            /* iedere sessie / bestelling begint met staffel UIT */
    staffelVraag = false;
    var laatst = lees(LS_LAATST, {});
    laatst[m.id] = Date.now();
    schrijf(LS_LAATST, laatst);
    laatsteActiviteit = Date.now();
    if (slot) slot.activiteit();   /* v32 */
    pkOnderbrokenGezien = false;    /* v32: na aanmelden eerst de niet-afgeronde bestellingen van deze werkplek */
    sluitPin();
    toonZijbalk();
    $('wm-start').hidden = true;
    $('wm-inhoud').hidden = false;
    recentTeken();                 /* v17: balk alleen op "Wie helpt er?" */
    meet();
    staffelSyncPlan().then(staffelBerichtTonen);
    meld('jwm:sessie-start', m);
    bronGekozen = false;
    if (recentWacht) { var rw = recentWacht; recentWacht = null; recentDetail(rw, pkNaLogin); }   /* v17 */
    else pkNaLogin();              /* v15: winkelwagen nog gevuld? openstaande bestellingen? */
  }

  /* reden: 'wissel' | 'inactief' | 'order' */
  function eindeSessie(reden) {
    var vorige = sessie;
    if (!(mand.aantal > 0)) actiefLoslaten('afmelden_lege_winkelwagen');   /* v32.3: lege winkelwagen = niet meer bezig met een bewaarde bestelling */
    persWis();                     /* v24: tabletmodus productpagina eindigt altijd met de sessie */
    ovVrijgeven('sessie_' + reden);   /* v29: lopende oproep-overname vrijgeven (vóór de backendsessie stopt) */
    bvSessieStop();                /* v24: backendsessie (bevoegdheid) eindigt bij afmelden, wissel en inactiviteit */
    sessie = null;
    zetKanaal(null);               /* v14/v15: telefonisch/papier nooit laten doorlopen naar een volgende medewerker */
    bronGekozen = false;           /* v17 */
    pkSluit();
    staffelAan = false;            /* sessie-einde, wissel, inactief, order: terug naar UIT */
    staffelVraag = false;
    sluitPin();
    sluitBeheer();
    sluitReclame();
    sluitInfo();
    sluitInvoer();
    sluitMand();
    $('wm-afmeld').hidden = true;
    stapel = [];
    toonNiveau();
    toonZijbalk();
    $('wm-inhoud').hidden = true;
    $('wm-start').hidden = false;
    bouwStart();
    staffelSyncPlan();
    if (vorige) meld('jwm:sessie-einde', { medewerker: vorige.id, reden: reden });
  }

  function meld(naam, detail) {
    try { document.dispatchEvent(new CustomEvent(naam, { detail: detail })); } catch (e) {}
  }

  function toonZijbalk() {
    var av = $('wm-medewerker-avatar');
    var nm = $('wm-medewerker-naam');
    var knop = $('wm-medewerker');
    if (sessie) {
      av.textContent = sessie.naam.charAt(0);
      av.style.background = sessie.kleur;
      av.style.color = '#fff';
      nm.textContent = sessie.naam;
      knop.disabled = sessie.rol !== 'beheer';       /* alleen beheer opent beheerpaneel */
      $('wm-wissel').disabled = false;
      werkNav();
      werkStaffelLabel();
      werkTelefonisch();
      zkKnop();   /* v32.4 */
    } else {
      av.textContent = '?';
      av.style.background = '';
      av.style.color = '';
      nm.textContent = 'Geen medewerker';
      knop.disabled = true;
      $('wm-wissel').disabled = true;
      werkNav();
      werkStaffelLabel();
      werkTelefonisch();
      zkKnop();   /* v32.4: knop weg en zoekvenster dicht */
    }
  }

  /* ---------- v14: telefonische bestelling (alleen pc) ---------- */
  function telefonischAan() { return kanaal() === 'telefoon'; }          /* v15: via kanaal() (telefoon | papier) */
  function zetTelefonisch(aan) { zetKanaal(aan ? 'telefoon' : null); }
  function telefoonStijl() {
    if ($('wm-tel-stijl')) return;
    var st = document.createElement('style');
    st.id = 'wm-tel-stijl';
    st.textContent =
      '.wm-telknop .wm-tel-ico{font-size:22px;line-height:1;display:block}' +
      '.wm-telknop.wm-tel-aan{background:#FFD700 !important;color:#1E2A27 !important}' +
      '#wm-tel-band{position:fixed;top:10px;left:50%;transform:translateX(-50%);z-index:900;background:#FFD700;color:#1E2A27;' +
      'font-weight:700;font-size:16px;padding:6px 16px;border-radius:18px;box-shadow:0 2px 8px rgba(0,0,0,.18);pointer-events:none}';
    document.head.appendChild(st);
  }
  function telefoonKnop() {
    var k = $('wm-telefonisch');
    if (k || !IS_PC) return k;
    var wissel = $('wm-wissel');
    if (!wissel || !wissel.parentNode) return null;
    telefoonStijl();
    k = document.createElement('button');
    k.type = 'button';
    k.id = 'wm-telefonisch';
    k.className = wissel.className + ' wm-telknop';
    k.setAttribute('data-wm-actie', 'telefonisch');
    k.innerHTML = '<span class="wm-tel-ico" aria-hidden="true">&#128222;</span><span>Telefonisch</span>';
    wissel.parentNode.insertBefore(k, wissel);
    return k;
  }
  function werkTelefonisch() {
    var kn = kanaal(), aan = kn === 'telefoon', pap = kn === 'papier';
    var k = telefoonKnop();
    if (k) {
      k.hidden = !sessie;
      k.disabled = !sessie;
      k.classList.toggle('wm-tel-aan', aan && !!sessie);
      k.setAttribute('aria-pressed', aan ? 'true' : 'false');
      k.title = aan ? 'Telefonische bestelling staat AAN – klik om uit te zetten' : 'Telefonische bestelling aanzetten';
    }
    var p = papierKnop();   /* v15 */
    if (p) {
      p.hidden = !sessie;
      p.disabled = !sessie;
      p.classList.toggle('wm-tel-aan', pap && !!sessie);
      p.setAttribute('aria-pressed', pap ? 'true' : 'false');
      p.title = pap ? 'Papierbestelling staat AAN – klik om uit te zetten' : 'Papierbestelling (later ingevoerd) aanzetten';
    }
    werkOpenKnop(pkInfo.totaal);
    var band = $('wm-tel-band');
    if ((aan || pap) && sessie && IS_PC) {
      if (!band) { telefoonStijl(); band = document.createElement('div'); band.id = 'wm-tel-band'; document.body.appendChild(band); }
      var ovb = aan ? ovLees() : null;   /* v29: oproep uit het belscherm */
      band.textContent = (aan ? '\uD83D\uDCDE TELEFONISCHE BESTELLING \u2013 ' + (ovb ? 'oproep ' + ovb.nummer + (ovb.naam ? ' ' + ovb.naam : '') + ' (' + ovb.lijn + ') \u2013 ' : '') : '\uD83D\uDCDD PAPIERBESTELLING \u2013 ') + sessie.naam;
      band.hidden = false;
    } else if (band) band.hidden = true;
  }

  /* ---------- Inactiviteit ---------- */
  ['pointerdown', 'keydown', 'wheel'].forEach(function (t) {
    document.addEventListener(t, function () {
      laatsteActiviteit = Date.now();
      if (!$('wm-afmeld').hidden) $('wm-afmeld').hidden = true;
    }, { capture: true, passive: true });
  });
  /* v32: de aftelling staat nu in de vijfminutenregeling (zie blok "v32 – VIJFMINUTENREGELING" onderaan) */

  /* ==========================================================
     MEDEWERKERSCHERM
     ========================================================== */
  function volgorde() {
    var laatst = lees(LS_LAATST, {});
    var regulier = MEDEWERKERS.filter(function (m) { return m.weergave === 'regulier'; });
    regulier.sort(function (a, b) {
      var ta = laatst[a.id] || 0, tb = laatst[b.id] || 0;
      if (tb !== ta) return tb - ta;
      return MEDEWERKERS.indexOf(a) - MEDEWERKERS.indexOf(b);
    });
    var beheer = MEDEWERKERS.filter(function (m) { return m.weergave === 'beheer'; });
    return { regulier: regulier, beheer: beheer, laatst: laatst };
  }

  function tijdTekst(ts) {
    if (!ts) return 'Nog niet gebruikt';
    var d = new Date(ts), nu = new Date();
    var hhmm = ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
    if (d.toDateString() === nu.toDateString()) return 'Vandaag ' + hhmm;
    var gisteren = new Date(nu); gisteren.setDate(nu.getDate() - 1);
    if (d.toDateString() === gisteren.toDateString()) return 'Gisteren ' + hhmm;
    return d.getDate() + '-' + (d.getMonth() + 1) + ' ' + hhmm;
  }

  function tegel(m, soort, laatst) {
    var sub = soort === 'klein' ? '' : '<span class="wm-mw-sub">' + esc(tijdTekst(laatst[m.id])) + '</span>';
    var label = soort === 'groot' && laatst[m.id] ? '<span class="wm-mw-label">Laatst gebruikt</span>' : '';
    return '<button type="button" class="wm-mw wm-mw--' + soort + '" data-mw="' + m.id + '">' +
      label +
      '<span class="wm-mw-av" style="background:' + m.kleur + '">' + esc(m.naam.charAt(0)) + '</span>' +
      '<span class="wm-mw-naam">' + esc(m.naam) + '</span>' + sub + '</button>';
  }

  function bouwStart() {
    var v = volgorde();
    var groot = v.regulier[0];
    var rest = v.regulier.slice(1);
    var html =
      '<div class="wm-start-kop"><h1>Wie helpt er?</h1><p>Tik op je naam</p></div>' +
      '<div class="wm-start-body">' +
        (groot ? tegel(groot, 'groot', v.laatst) : '') +
        '<div class="wm-start-rechts">' +
          '<div class="wm-mw-lijst" data-wm-scroll>' +
            rest.map(function (m) { return tegel(m, 'normaal', v.laatst); }).join('') +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="wm-start-voet">' +
        '<div class="wm-weekknoppen" id="wm-weekknoppen" aria-label="Weekreclame"></div>' +
        '<div class="wm-beheer-rij"><span>Beheer</span>' +
          v.beheer.map(function (m) { return tegel(m, 'klein', v.laatst); }).join('') +
        '</div>' +
      '</div>';
    $('wm-start').innerHTML = html;
    tekenWeekknoppen();
    maatStart();
    pkTekenStart();                /* v15: aantallen openstaande bestellingen */
    pkStartInfo();
    recentLaad();                  /* v17: balk Laatst afgerond */
  }

  /* Tegelmaat S zo kiezen dat alles zonder pagina-scroll past:
     breedte: groot (2S+gap) + 2 kolommen S + gaps; hoogte: kop + 2S+gap + voet */
  function maatStart() {
    var start = $('wm-start');
    if (!start || start.hidden) return;
    var b = start.getBoundingClientRect();
    var gap = 12, kop = 44, voet = 104;
    var sBreed = (b.width - 4 * gap) / 4;
    var sHoog = (b.height - kop - voet - 3 * gap) / 2;
    var s = Math.max(120, Math.floor(Math.min(sBreed, sHoog)));
    start.style.setProperty('--s', s + 'px');
  }
  window.addEventListener('resize', maatStart);

  /* ==========================================================
     PIN / CODE
     ========================================================== */
  var pin = { m: null, modus: 'login', invoer: '', eerste: '', lengte: 0 };

  function openPin(m) {
    var codes = lees(LS_CODES, {});
    pin.m = m;
    pin.invoer = '';
    pin.eerste = '';
    pin.lengte = codes[m.id] ? codes[m.id].n : 0;
    pin.modus = codes[m.id] ? 'login' : 'nieuw1';
    tekenPin('');
    $('wm-pin').hidden = false;
  }
  function sluitPin() {
    $('wm-pin').hidden = true;
    $('wm-pin').innerHTML = '';
    pin.m = null;
  }

  function uitleg() {
    if (pin.modus === 'nieuw1') return 'Eerste keer: kies je eigen code van ' + CODE_MIN + ' tot ' + CODE_MAX + ' cijfers.';
    if (pin.modus === 'nieuw2') return 'Herhaal je nieuwe code.';
    return 'Voer je code in.';
  }

  function geblokkeerdTot() {
    var blok = lees(LS_BLOK, {});
    var r = blok[pin.m.id];
    return r && r.tot > Date.now() ? r.tot : 0;
  }

  function tekenPin(fout) {
    var m = pin.m;
    var max = pin.modus === 'login' ? pin.lengte : CODE_MAX;
    var bol = '';
    for (var i = 0; i < max; i++) bol += '<i class="' + (i < pin.invoer.length ? 'vol' : '') + '"></i>';
    var okNodig = pin.modus !== 'login';
    var toetsen = '';
    ['1', '2', '3', '4', '5', '6', '7', '8', '9'].forEach(function (c) {
      toetsen += '<button type="button" class="wm-toets" data-toets="' + c + '">' + c + '</button>';
    });
    toetsen += '<button type="button" class="wm-toets wm-toets--klein" data-toets="wis">Wis</button>';
    toetsen += '<button type="button" class="wm-toets" data-toets="0">0</button>';
    toetsen += okNodig
      ? '<button type="button" class="wm-toets wm-toets--ok" data-toets="ok"' + (pin.invoer.length < CODE_MIN ? ' disabled' : '') + '>OK</button>'
      : '<button type="button" class="wm-toets wm-toets--klein" data-toets="terug">&#9003;</button>';
    $('wm-pin').innerHTML =
      '<div class="wm-pin-paneel" id="wm-pin-paneel">' +
        '<div class="wm-pin-links">' +
          '<span class="wm-mw-av" style="background:' + m.kleur + '">' + esc(m.naam.charAt(0)) + '</span>' +
          '<div class="wm-pin-naam">' + esc(m.naam) + '</div>' +
          '<div class="wm-pin-tekst">' + esc(uitleg()) + '</div>' +
          '<div class="wm-pin-bolletjes">' + bol + '</div>' +
          '<div class="wm-pin-fout">' + esc(fout || '') + '</div>' +
          '<button type="button" class="wm-pin-annuleer" data-toets="annuleer">Annuleren</button>' +
        '</div>' +
        '<div class="wm-pin-toetsen">' + toetsen + '</div>' +
      '</div>';
  }

  function schud(fout) {
    tekenPin(fout);
    var p = $('wm-pin-paneel');
    if (p) p.classList.add('schud');
  }

  function toets(t) {
    if (!pin.m) return;
    if (t === 'annuleer') { sluitPin(); return; }
    var tot = geblokkeerdTot();
    if (tot) { pin.invoer = ''; tekenPin('Te vaak fout. Probeer over ' + Math.ceil((tot - Date.now()) / 1000) + ' s opnieuw.'); return; }
    if (t === 'wis') { pin.invoer = ''; tekenPin(''); return; }
    if (t === 'terug') { pin.invoer = pin.invoer.slice(0, -1); tekenPin(''); return; }
    if (t === 'ok') { bevestigNieuw(); return; }
    if (t.length === 1 && '0123456789'.indexOf(t) !== -1) {
      var max = pin.modus === 'login' ? pin.lengte : CODE_MAX;
      if (pin.invoer.length >= max) return;
      pin.invoer += t;
      tekenPin('');
      if (pin.modus === 'login' && pin.invoer.length === pin.lengte) controleer();
    }
  }

  function controleer() {
    var m = pin.m, code = pin.invoer;
    var codes = lees(LS_CODES, {});
    hash(m.id, code).then(function (h) {
      if (!pin.m || pin.m.id !== m.id) return;
      if (codes[m.id] && codes[m.id].h === h) {
        var blok = lees(LS_BLOK, {}); delete blok[m.id]; schrijf(LS_BLOK, blok);
        startSessie(m);
        bvSessieStart(m, code);   /* v32: voor iedere medewerker op elk apparaat (gecontroleerde registratie, ontgrendelen na vergrendeling) */
                                     /* v24: Vincent/Erica – code ook door de backend laten controleren (bevoegdheid korting/op rekening).
                                                     v29: op een pc voor iedere medewerker – de telefonische overname vanuit het belscherm
                                                     is gebonden aan de medewerker met een gecontroleerde sessie (backend v1.12.0) */
      } else {
        var b = lees(LS_BLOK, {});
        var r = b[m.id] || { fout: 0, tot: 0 };
        r.fout = (r.fout || 0) + 1;
        if (r.fout >= MAX_POGINGEN) { r.fout = 0; r.tot = Date.now() + BLOKKEER_MS; }
        b[m.id] = r; schrijf(LS_BLOK, b);
        pin.invoer = '';
        schud(r.tot > Date.now() ? 'Te vaak fout. Even ' + (BLOKKEER_MS / 1000) + ' s wachten.' : 'Onjuiste code, probeer opnieuw.');
      }
    });
  }

  function bevestigNieuw() {
    if (pin.invoer.length < CODE_MIN) return;
    if (pin.modus === 'nieuw1') {
      pin.eerste = pin.invoer; pin.invoer = ''; pin.modus = 'nieuw2';
      tekenPin('');
      return;
    }
    if (pin.modus === 'nieuw2') {
      if (pin.invoer !== pin.eerste) {
        pin.invoer = ''; pin.eerste = ''; pin.modus = 'nieuw1';
        schud('Codes waren niet gelijk. Kies opnieuw.');
        return;
      }
      var m = pin.m, code = pin.invoer;
      hash(m.id, code).then(function (h) {
        var codes = lees(LS_CODES, {});
        codes[m.id] = { h: h, n: code.length, gezet: Date.now() };
        schrijf(LS_CODES, codes);
        startSessie(m);
      });
    }
  }

  /* ==========================================================
     BEHEER – code van een medewerker wissen (alleen rol beheer)
     ========================================================== */
  var bevestigId = null;
  function openBeheer() {
    if (!sessie || sessie.rol !== 'beheer') return;
    bevestigId = null;
    tekenBeheer();
    $('wm-beheer').hidden = false;
  }
  function sluitBeheer() {
    $('wm-beheer').hidden = true;
    $('wm-beheer').innerHTML = '';
    bevestigId = null;
  }
  function tekenBeheer() {
    var codes = lees(LS_CODES, {});
    var regels = MEDEWERKERS.map(function (m) {
      var heeft = !!codes[m.id];
      var knop = !heeft
        ? '<button type="button" disabled>Geen code</button>'
        : (bevestigId === m.id
            ? '<button type="button" class="bevestig" data-wis="' + m.id + '">Zeker? Tik nogmaals</button>'
            : '<button type="button" data-wis="' + m.id + '">Code wissen</button>');
      return '<div class="wm-beheer-regel"><span>' + esc(m.naam) + '</span>' + knop + '</div>';
    }).join('');
    $('wm-beheer').innerHTML =
      '<div class="wm-beheer-paneel"><h2>Beheer – codes</h2>' + regels +
      '<button type="button" class="wm-pin-annuleer" data-beheer-sluit>Sluiten</button></div>';
  }
  function wisCode(id) {
    if (bevestigId !== id) { bevestigId = id; tekenBeheer(); return; }
    var codes = lees(LS_CODES, {}); delete codes[id]; schrijf(LS_CODES, codes);
    var blok = lees(LS_BLOK, {}); delete blok[id]; schrijf(LS_BLOK, blok);
    bevestigId = null;
    tekenBeheer();
  }

  /* ==========================================================
     WEEKRECLAME (fase 4) – zonder inloggen te bekijken
     ========================================================== */
  var RECLAME_COLLECTIE = 'aanbiedingen-1';
  var RECLAME_WEKEN = 6;                      /* huidige week + 5 weken vooruit */
  var RECLAME_VERVERS_MS = 15 * 60 * 1000;    /* elke 15 minuten opnieuw ophalen */
  var reclame = { producten: [], status: 'laden' };
  var MAANDEN = ['jan', 'feb', 'mrt', 'apr', 'mei', 'jun', 'jul', 'aug', 'sep', 'okt', 'nov', 'dec'];

  function dagBegin(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function maandagVan(d) {
    var x = dagBegin(d);
    x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
    return x;
  }
  function plusDagen(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function isoWeek(d) {
    var t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    var dn = t.getUTCDay() || 7;
    t.setUTCDate(t.getUTCDate() + 4 - dn);
    var jan1 = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return Math.ceil(((t - jan1) / 86400000 + 1) / 7);
  }
  function kortDatum(d) { return d.getDate() + ' ' + MAANDEN[d.getMonth()]; }
  function euro(bedrag) {
    var n = parseFloat(bedrag);
    if (isNaN(n)) return '';
    return '€ ' + n.toFixed(2).replace('.', ',');
  }

  /* Zelfde regel als snippets/reclame-trechter.liquid:
     tag reclame-JJJJ-MM-DD = startdatum, periode loopt t/m start + 6 dagen */
  function reclamePerioden(p) {
    var tags = p.tags || [];
    if (typeof tags === 'string') tags = tags.split(',');
    var uit = [];
    tags.forEach(function (t) {
      var m = String(t).trim().match(/^reclame-([0-9]{4})-([0-9]{2})-([0-9]{2})$/);
      if (!m) return;
      var start = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
      var eind = plusDagen(start, 6);
      eind.setHours(23, 59, 59, 999);
      uit.push({ start: start, eind: eind });
    });
    return uit;
  }

  function reclameWeken() {
    var ma = maandagVan(new Date(Date.now()));
    var weken = [];
    for (var k = 0; k < RECLAME_WEKEN; k++) {
      var start = plusDagen(ma, 7 * k);
      var eind = plusDagen(start, 6); eind.setHours(23, 59, 59, 999);
      var acties = [];
      reclame.producten.forEach(function (p) {
        var gevonden = null;
        reclamePerioden(p).forEach(function (per) {
          if (!gevonden && per.start <= eind && per.eind >= start) gevonden = per;
        });
        if (gevonden) acties.push({ p: p, per: gevonden });
      });
      weken.push({ k: k, start: start, eind: eind, week: isoWeek(start), acties: acties });
    }
    return weken;
  }

  function weekLabel(w) {
    if (w.k === 0) return 'Deze week';
    if (w.k === 1) return 'Volgende week';
    return 'Week ' + w.week;
  }

  function tekenWeekknoppen() {
    var vak = $('wm-weekknoppen');
    if (!vak) return;
    var weken = reclameWeken();
    vak.innerHTML = weken.map(function (w) {
      var aantal = reclame.status === 'laden' ? 'laden…'
        : reclame.status === 'fout' ? 'niet geladen'
        : (w.acties.length === 0 ? 'geen actie' : w.acties.length + (w.acties.length === 1 ? ' actie' : ' acties'));
      var cls = 'wm-week' + (w.k === 0 ? ' wm-week--nu' : '') + (w.acties.length ? ' wm-week--vol' : ' wm-week--leeg');
      return '<button type="button" class="' + cls + '" data-week="' + w.k + '">' +
        '<span class="wm-week-titel">' + esc(weekLabel(w)) + '</span>' +
        '<span class="wm-week-datum">wk ' + w.week + ' · ' + esc(kortDatum(w.start)) + ' – ' + esc(kortDatum(w.eind)) + '</span>' +
        '<span class="wm-week-aantal">' + esc(aantal) + '</span>' +
      '</button>';
    }).join('');
  }

  function tekstUit(html) {
    try {
      var d = new DOMParser().parseFromString(String(html || ''), 'text/html');
      return (d.body.textContent || '').replace(/[ ]+/g, ' ').trim();
    } catch (e) { return ''; }
  }
  function fotoUrl(p) {
    var img = p.images && p.images[0] && p.images[0].src;
    if (!img) return '';
    return img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
  }

  function openReclame(k) {
    var w = reclameWeken()[k];
    if (!w) return;
    var kaarten = w.acties.map(function (a) {
      var p = a.p;
      var v = (p.variants && p.variants[0]) || {};
      var van = v.compare_at_price && parseFloat(v.compare_at_price) > parseFloat(v.price) ? euro(v.compare_at_price) : '';
      var meer = p.variants && p.variants.length > 1 ? '<span class="wm-rk-meer">vanaf</span> ' : '';
      var per = 'Geldig ' + kortDatum(a.per.start) + ' t/m ' + kortDatum(a.per.eind);
      var oms = tekstUit(p.body_html);
      if (oms.length > 160) oms = oms.slice(0, 157) + '…';
      var foto = fotoUrl(p);
      return '<div class="wm-rk">' +
        '<div class="wm-rk-foto">' + (foto ? '<img src="' + esc(foto) + '" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="wm-rk-info">' +
          '<div class="wm-rk-naam">' + esc(p.title) + '</div>' +
          '<div class="wm-rk-prijs">' + meer + '<b>' + esc(euro(v.price)) + '</b>' + (van ? ' <s>' + esc(van) + '</s>' : '') + '</div>' +
          '<div class="wm-rk-per">' + esc(per) + '</div>' +
          (oms ? '<div class="wm-rk-oms">' + esc(oms) + '</div>' : '') +
        '</div>' +
      '</div>';
    }).join('');
    var leeg = reclame.status === 'fout'
      ? '<div class="wm-reclame-leeg">De weekreclame kon niet worden geladen. Controleer de internetverbinding.</div>'
      : '<div class="wm-reclame-leeg">Voor deze week staat geen weekreclame gepland.</div>';
    var el = zorgReclameVenster();
    el.innerHTML =
      '<div class="wm-reclame-paneel">' +
        '<div class="wm-reclame-kop">' +
          '<div><h2>' + esc(weekLabel(w)) + '</h2>' +
          '<p>Week ' + w.week + ' · ' + esc(kortDatum(w.start)) + ' t/m ' + esc(kortDatum(w.eind)) +
          ' · ' + (w.acties.length === 1 ? '1 actie' : w.acties.length + ' acties') + '</p></div>' +
          '<button type="button" class="wm-reclame-sluit" data-reclame-sluit>Sluiten ✕</button>' +
        '</div>' +
        '<div class="wm-reclame-lijst" data-wm-scroll>' + (w.acties.length ? kaarten : leeg) + '</div>' +
        '<div class="wm-reclame-voet">Bron: aanbiedingen op jullens.com ' +
          '<a href="/pages/aanbiedingen" target="_blank" rel="noopener">Volledige reclamepagina openen</a></div>' +
      '</div>';
    el.hidden = false;
  }
  function zorgReclameVenster() {
    var el = $('wm-reclame');
    if (!el) {
      el = document.createElement('div');
      el.id = 'wm-reclame';
      el.className = 'wm-reclame';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.hidden = true;
      document.body.appendChild(el);
    }
    return el;
  }
  function sluitReclame() {
    var el = $('wm-reclame');
    if (el) { el.hidden = true; el.innerHTML = ''; }
  }

  function laadReclame() {
    return fetch('/collections/' + RECLAME_COLLECTIE + '/products.json?limit=250', { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.json(); })
      .then(function (j) {
        reclame.producten = (j && j.products) || [];
        reclame.status = 'ok';
        reclame.geladen = true;
      })
      .catch(function () {
        /* Eerder al geladen? Dan blijven de laatst bekende acties gewoon zichtbaar,
           zonder tegenstrijdige melding. Alleen zonder eerdere gegevens: 'fout'. */
        if (!reclame.geladen) reclame.status = 'fout';
      })
      .then(function () { if (!$('wm-start').hidden) tekenWeekknoppen(); });
  }
  laadReclame();
  setInterval(laadReclame, RECLAME_VERVERS_MS);
  /* weekwissel ook zonder herladen: elke minuut de knoppen bijwerken als het startscherm open is */
  setInterval(function () { if (!$('wm-start').hidden) tekenWeekknoppen(); }, 60000);

  /* ==========================================================
     ONZE PRODUCTEN – 12 hoofdblokken (fase 5)
     Bron: de bestaande pagina /collections (template list-collections,
     sectie collection-list-main met de 12 blokken). Naam, afbeelding en
     link worden daar letterlijk uit overgenomen; geen eigen structuur.
     ========================================================== */
  var HOOFD_BRON = '/collections';
  /* v25: rustige tegelfoto's alleen voor de tablet (Shopify Bestanden, naam eindigt op _tablet; §33.2). Verkleind via de CDN.
     Tegels zonder eigen tabletfoto houden de webshopfoto. Webshop-collectiefoto's blijven ongewijzigd. */
  var TABLET_FOTO = {
    '/collections/warme-produkten': 'hartige_produkten_tablet',   /* besluit Vincent 08-10: zelfde foto als Hartige producten */
    '/collections/brood-collectie': 'brood_collage_tablet',
    '/collections/gebak-punten-en-high-tea': 'gebak_en_punten_etc_colage_tablet',
    '/collections/standaard-taarten': 'Taarten_1_tablet',
    '/pages/foto-op-taart': 'logo_gebak_en_taarten_tablet',
    '/collections/sloffen': 'slof_schnit_rol_tablet',
    '/collections/cake': 'groningerkoek_en_cake_tablet',
    '/collections/chocolade-bonbons-en-truffels': 'CAT_7176_tablet',
    '/collections/hartige-producten-1': 'hartige_produkten_tablet',
    '/collections/zoete-koekjes-1': 'stukgoed_collectie_foto_tablet'
  };
  function tabletFoto(href) { var n = TABLET_FOTO[href]; return n ? '/cdn/shop/files/' + n + '.png?width=600' : null; }
  var HOOFD_VERVERS_MS = 30 * 60 * 1000;
  var hoofd = { blokken: [], status: 'laden', geladen: false };

  function schoon(s) {
    return String(s || '').split('').map(function (c) { return c <= ' ' ? ' ' : c; })
      .join('').replace(/ +/g, ' ').trim();
  }
  function kiesAfbeelding(img) {
    if (!img) return '';
    var beste = '', besteW = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (deel) {
      var p = schoon(deel).split(' ');
      var w = parseInt(p[1], 10);
      if (p[0] && w && w <= 600 && w > besteW) { besteW = w; beste = p[0]; }
    });
    var src = beste || img.getAttribute('src') || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src;
  }

  function laadHoofdblokken() {
    return fetch(HOOFD_BRON, { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.text(); })
      .then(function (html) {
        var d = new DOMParser().parseFromString(html, 'text/html');
        var sec = d.querySelector('[id*="collection-list-main"]') || d;
        var blokken = [];
        Array.prototype.forEach.call(sec.querySelectorAll('a.card[href]'), function (a) {
          var href = (a.getAttribute('href') || '').split('?')[0];
          if (!/^[/](collections|pages)[/]/.test(href)) return;
          if (blokken.some(function (b) { return b.href === href; })) return;
          var kop = a.querySelector('.card__heading, h3, h2');
          blokken.push({ href: href, naam: schoon((kop || a).textContent), img: tabletFoto(href) || kiesAfbeelding(a.querySelector('img')) });   /* v25 */
        });
        if (!blokken.length) throw new Error('geen blokken gevonden');
        hoofd.blokken = blokken;
        hoofd.status = 'ok';
        hoofd.geladen = true;
      })
      .catch(function () { if (!hoofd.geladen) hoofd.status = 'fout'; })
      .then(function () { if (!stapel.length) tekenHoofdblokken(); });
  }

  function tekenHoofdblokken() {
    var r = $('wm-raster');
    if (!r) return;
    if (meting) meting.hidden = true;           /* proefraster-meting vervalt vanaf fase 5 */
    if (hoofd.status === 'laden') {
      r.innerHTML = '<div class="wm-raster-melding">Onze producten laden…</div>';
      return;
    }
    if (hoofd.status === 'fout') {
      r.innerHTML = '<div class="wm-raster-melding">Onze producten konden niet worden geladen.' +
        '<button type="button" class="wm-opnieuw" data-hoofd-opnieuw>Opnieuw proberen</button></div>';
      return;
    }
    if (hoofd.blokken.length > 12) r.setAttribute('data-wm-scroll', ''); else r.removeAttribute('data-wm-scroll');
    r.classList.toggle('wm-raster--scroll', hoofd.blokken.length > 12);
    r.innerHTML = hoofd.blokken.map(function (b, i) {
      return '<button type="button" class="wm-tegel wm-cat" data-cat="' + i + '" data-href="' + esc(b.href) + '">' +
        '<span class="wm-cat-foto">' + (b.img ? '<img src="' + esc(b.img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="wm-cat-naam">' + esc(b.naam) + '</span>' +
      '</button>';
    }).join('');
  }

  var toastTimer = null;
  function toast(tekst, ms) {
    var el = $('wm-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'wm-toast';
      el.className = 'wm-toast';
      $('wm-werkvlak').appendChild(el);
    }
    el.textContent = tekst;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, ms || 2500);
  }

  function kiesCategorie(i) {
    var b = hoofd.blokken[i];
    if (!b) return;
    meld('jwm:categorie', { index: i, naam: b.naam, href: b.href });
    openNiveau(b.naam, function () { return laadHref(b.href); });
  }

  /* ==========================================================
     FASE 6 – subcategorieen en productoverzichten, 4 x 3 op elk niveau
     De structuur komt van de website zelf:
     - /collections/X zonder doorverwijzing  -> producten van collectie X
     - /collections/X met doorverwijzing (theme.liquid) -> volg die pagina
     - /pages/Y met CONFIG.categorieen        -> subcategorieen (collecties)
     - /pages/Y met CFG.collectie             -> producten van die collectie
     - /pages/Y met een lijst product-handles -> precies die producten
     ========================================================== */
  var NIVEAU_CACHE_MS = 30 * 60 * 1000;
  var niveauCache = {};
  var stapel = [];            /* leeg = hoofdniveau (12 hoofdgroepen) */
  var NL = String.fromCharCode(10);

  function haalTekst(url) {
    return fetch(url, { cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.text();
    });
  }
  function haalJson(url) {
    return fetch(url, { cache: 'no-store' }).then(function (r) {
      if (!r.ok) throw new Error('status ' + r.status);
      return r.json();
    });
  }
  function gecached(sleutel, maak) {
    var c = niveauCache[sleutel];
    if (c && Date.now() - c.t < NIVEAU_CACHE_MS) return Promise.resolve(c.v);
    return maak().then(function (v) { niveauCache[sleutel] = { t: Date.now(), v: v }; return v; });
  }

  /* ---------- bron lezen ---------- */
  function paginaScript(html) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var main = d.querySelector('main') || d.body;
    var s = Array.prototype.map.call(main.querySelectorAll('script'), function (x) { return x.textContent; }).join(NL);
    return s.replace(/[/][*][^]*?[*][/]/g, '');          /* blokcommentaar weg (bijv. reclame-voorbeeld) */
  }
  function tekstVeld(obj, naam) {
    var m = obj.match(new RegExp(naam + " *: *'([^']*)'")) || obj.match(new RegExp(naam + ' *: *"([^"]*)"'));
    return m ? m[1] : '';
  }
  function arrayNa(tekst, sleutel) {
    var i = tekst.search(new RegExp(sleutel + ' *: *[[]'));
    if (i < 0) return null;
    var start = tekst.indexOf('[', i), diepte = 0;
    for (var j = start; j < tekst.length; j++) {
      if (tekst[j] === '[') diepte++;
      else if (tekst[j] === ']') { diepte--; if (diepte === 0) return tekst.slice(start + 1, j); }
    }
    return null;
  }
  function platteObjecten(tekst) {
    return tekst.match(/[{][^{}]*[}]/g) || [];
  }

  function reclameZichtbaar(script) {
    if (!/reclameActief *: *true/.test(script)) return false;
    var nu = new Date(); nu.setHours(0, 0, 0, 0);
    var van = tekstVeld(script, 'reclameVanaf'), tot = tekstVeld(script, 'reclameTot');
    if (van && nu < new Date(van)) return false;
    if (tot && nu > new Date(tot)) return false;
    return true;
  }
  function dagenBadge(obj) {
    var i = obj.search(/dagen *: *[[]/);
    if (i < 0) return '';
    var start = obj.indexOf('[', i), eind = obj.indexOf(']', start);
    if (eind < 0) return '';
    var dagen = (obj.slice(start + 1, eind).match(/[a-z]+/g) || []);
    if (!dagen.length) return '';
    return 'Alleen ' + dagen.map(function (d) { return d.charAt(0).toUpperCase() + d.slice(1); }).join(' · ');
  }

  function laadHref(href) {
    return gecached('href:' + href, function () {
      return haalTekst(href).then(function (html) {
        if (href.indexOf('/collections/') === 0) {
          var m = html.match(/<body[^>]*>[^<]*<script>window[.]location[.]replace[(]'([^']+)'[)]/);
          if (m && m[1].indexOf('/pages/') === 0) return laadHref(m[1]);
          return laadCollectie(href.split('/')[2]);
        }
        var script = paginaScript(html);
        var cats = arrayNa(script, 'categorieen');
        if (cats !== null) {
          var metReclame = reclameZichtbaar(script);
          var subs = platteObjecten(cats).map(function (o) {
            return { naam: tekstVeld(o, 'naam'), handle: tekstVeld(o, 'handle'), badge: dagenBadge(o), reclame: /reclame *: *true/.test(o) };
          }).filter(function (s) { return s.handle && (!s.reclame || metReclame); });
          return laadSubs(subs);
        }
        /* v32.7 - 01-11-2026: Feestdagen & gelegenheden = hoofdingang; FEESTDAGEN-lijst bevat COLLECTIEhandles: alleen collecties die in de webshop aan staan en producten hebben, als tegel */ var feestLijst = arrayNa(script.replace(/FEESTDAGEN *= *[[]/, 'FEESTDAGEN: ['), 'FEESTDAGEN'); if (feestLijst !== null) { var feesten = platteObjecten(feestLijst).map(function (o) { return { naam: tekstVeld(o, 'naam'), handle: tekstVeld(o, 'handle'), badge: '' }; }).filter(function (f) { return f.handle; }); return Promise.all(feesten.map(function (f) { return haalJson('/collections/' + f.handle + '.json').then(function () { return f; }, function () { return null; }); })).then(function (aan) { return laadSubs(aan.filter(Boolean)); }).then(function (r) { return { soort: 'sub', items: r.items.filter(function (i) { return i.aantal === null || i.aantal > 0; }) }; }); } var coll = tekstVeld(script, 'collectie');
        if (coll) return laadCollectie(coll);
        var handles = [];
        platteObjecten(script).forEach(function (o) {
          var h = tekstVeld(o, 'handle');
          if (h && handles.indexOf(h) === -1) handles.push(h);
        });
        if (handles.length) return laadHandles(handles);
        throw new Error('onbekende paginavorm');
      });
    });
  }

  /* v27 (10-10-2026): Globo zet zijn optieset-lijst (productOptionSetMap) alleen op productpagina's, niet op deze
     paginatemplate. Zonder die lijst zag V26 bij geen enkel product Globo-opties en verscheen "Opties" nergens
     (taart met opschrift/voorgesneden niet te bestellen). Daarom: lijst eenmalig uit een productpagina lezen
     (de lijst is voor de hele winkel gelijk) en het scherm daarna opnieuw tekenen. Lukt het niet: gedrag als V26. */
  function heeftGpo(id) {
    var m = window.GPOConfigs && window.GPOConfigs.productOptionSetMap;
    return !!(m && id && m[String(id)]);
  }
  /* v28 (10-10-2026): heeft de Globo-optieset van dit product een ALTIJD verplicht veld (zonder voorwaarde), zoals de
     tekst van het marsepein schildje of de foto van de marsepeintaart vierkant met foto? Dan geen directe +/- of
     "Kies maat" (die zou de verplichte invoer overslaan), alleen "Opties" via de echte productpagina – net als de webshop. */
  var gpoVerplichtSets = {};
  function gpoVerplicht(id) {
    var m = window.GPOConfigs && window.GPOConfigs.productOptionSetMap;
    var set = m && id && m[String(id)];
    return !!(set && gpoVerplichtSets[set]);
  }
  function leesVerplicht(html) {
    var re = /GPOConfigs\.options\[(\d+)\]\s*=\s*\{/g, r;
    while ((r = re.exec(html))) {
      var start = r.index + r[0].length - 1, d = 0, inS = false, esc2 = false, j;
      for (j = start; j < html.length; j++) {
        var c = html.charAt(j);
        if (inS) { if (esc2) esc2 = false; else if (c === '\\') esc2 = true; else if (c === '"') inS = false; continue; }
        if (c === '"') { inS = true; continue; }
        if (c === '{') d++; else if (c === '}') { d--; if (!d) break; }
      }
      try {
        var set = JSON.parse(html.slice(start, j + 1));
        var plat = function (els) { return (els || []).reduce(function (a, e) { return a.concat(e.elements ? plat(e.elements) : [e]); }, []); };
        gpoVerplichtSets[r[1]] = plat(set.elements).some(function (e) { return e.required && !e.conditionalField; });
      } catch (e) { /* onleesbaar: niets markeren (gedrag als V27) */ }
    }
  }
  function laadGpoKaart() {
    if (window.GPOConfigs && window.GPOConfigs.productOptionSetMap) return Promise.resolve(true);
    return fetch('/products.json?limit=1', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var h = d && d.products && d.products[0] && d.products[0].handle;
        if (!h) throw new Error('geen product');
        return fetch('/products/' + encodeURIComponent(h), { credentials: 'same-origin' });
      })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var m = /productOptionSetMap\s*=\s*(\{[^}]*\})/.exec(html);
        if (!m) throw new Error('geen lijst');
        var kaart = JSON.parse(m[1]);
        leesVerplicht(html);   /* v28 */
        window.GPOConfigs = window.GPOConfigs || {};
        if (!window.GPOConfigs.productOptionSetMap) window.GPOConfigs.productOptionSetMap = kaart;
        if (stapel.length) toonNiveau();
        return true;
      })
      .catch(function () { return false; });
  }

  function productItem(p, prijsInCenten) {
    var varianten = p.variants || [];
    var prijzen = varianten.map(function (v) { return prijsInCenten ? v.price : Math.round(parseFloat(v.price) * 100); })
      .filter(function (x) { return !isNaN(x); });
    var laagste = prijzen.length ? Math.min.apply(null, prijzen) : null;
    var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
    var optieNamen = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
    var vars = varianten.map(function (v) {
      var opt = v.options || [v.option1, v.option2, v.option3].filter(function (x) { return x !== null && x !== undefined; });
      return {
        id: v.id,
        prijs: prijsInCenten ? v.price : Math.round(parseFloat(v.price) * 100),
        beschikbaar: v.available !== false,
        opties: opt
      };
    });
    var item = {
      soort: 'product', handle: p.handle, naam: p.title, img: img, id: p.id,   /* v24: id voor Globo-optieset (route a) */
      gpo: heeftGpo(p.id),
      prijs: laagste, vanaf: prijzen.length > 1 && Math.max.apply(null, prijzen) !== laagste,
      optieNamen: optieNamen, varianten: vars
    };
    registreerFamilies(item);
    bepaalBestelwijze(item);
    /* v13: tegelprijs uitsluitend uit de kiesbare (basis)varianten – nooit uit staffel-/kortingsvarianten */
    var basisPrijzen = (item.keuzeVarianten || []).map(function (v) { return v.prijs; })
      .filter(function (x) { return typeof x === 'number' && !isNaN(x); });
    if (basisPrijzen.length) {
      item.prijs = Math.min.apply(null, basisPrijzen);
      item.vanaf = basisPrijzen.length > 1 && Math.max.apply(null, basisPrijzen) !== item.prijs;
    }
    return item;
  }

  /* ---------- FASE 7: hoe kan dit product besteld worden? ----------
     - staffel-optie "Aantal" (Normaal / x stuks (y%)): altijd "Normaal"; de
       staffelkorting is voor normale winkelorders uit (fase 10 regelt Vincent/Erica)
     - "Foto op taart" / "Personalisatie": persoonlijke opties, niet vereenvoudigen
     - overblijvend 1 variant -> direct - / aantal / +
     - overblijvend meer varianten (maat, bereiding, chocolade, kleur...) -> kiezen */
  function bepaalBestelwijze(item) {
    var namen = item.optieNamen || [];
    /* fase 10: staffeloptie herkennen (ook zonder "Normaal", bijv. Petit fours per stuk);
       alleen de basisvariant per familie is kiesbaar – nooit een kortingsvariant */
    var staffelIdx = staffelOptieIndex(item);
    var persoonlijk = item.persoonlijk || namen.some(function (n) { return /foto op taart|personalisatie/i.test(n); });
    var keuze = item.varianten.filter(function (v) { return staffelIdx < 0 || !!fam[v.id]; });
    keuze.forEach(function (v) {
      v.label = v.opties.filter(function (x, i) { return i !== staffelIdx && x !== 'Default Title'; }).join(' · ');
    });
    item.staffelOptie = staffelIdx > -1;
    item.keuzeVarianten = keuze;
    if (persoonlijk) item.bestel = 'persoonlijk';
    else if (keuze.length === 1) { item.bestel = 'direct'; item.variant = keuze[0]; }
    else if (keuze.length > 1) item.bestel = 'keuze';
    else item.bestel = 'geen';
  }
  function laadCollectie(handle) {
    return gecached('coll:' + handle, function () {
      return haalJson('/collections/' + handle + '/products.json?limit=250').then(function (j) {
        return { soort: 'prod', items: (j.products || []).map(function (p) { return productItem(p, false); }) };
      });
    });
  }
  function laadHandles(handles) {
    return Promise.all(handles.map(function (h) {
      return haalJson('/products/' + h + '.js').then(function (p) {
        /* producten van een pagina met handle-lijst (Foto/logo) zijn persoonlijke producten */
        var it = productItem(p, true);
        it.persoonlijk = true;
        bepaalBestelwijze(it);
        return it;
      }, function () { return null; });
    })).then(function (lijst) {
      return { soort: 'prod', items: lijst.filter(Boolean) };
    });
  }
  function laadSubs(subs) {
    return Promise.all(subs.map(function (s) {
      return haalJson('/collections/' + s.handle + '/products.json?limit=250').then(function (j) {
        var p = (j.products || [])[0];
        var img = p && p.images && p.images[0] ? p.images[0].src : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
        return { soort: 'sub', handle: s.handle, naam: s.naam, badge: s.badge, aantal: (j.products || []).length, img: img };
      }, function () {
        return { soort: 'sub', handle: s.handle, naam: s.naam, badge: s.badge, aantal: null, img: '' };
      });
    })).then(function (items) { return { soort: 'sub', items: items }; });
  }

  /* ---------- navigatie ---------- */
  function openNiveau(titel, laad) {
    var niveau = { titel: titel, status: 'laden', items: [], laad: laad };
    stapel.push(niveau);
    toonNiveau();
    laadInNiveau(niveau);
  }
  function laadInNiveau(niveau) {
    niveau.status = 'laden';
    niveau.laad().then(function (res) {
      niveau.items = res.items;
      niveau.status = 'ok';
    }, function () {
      niveau.status = 'fout';
    }).then(function () {
      if (stapel[stapel.length - 1] === niveau) toonNiveau();
    });
  }
  function terug() {
    if (!stapel.length) return;
    stapel.pop();
    toonNiveau();
  }
  function naarHoofd() {
    stapel = [];
    toonNiveau();
  }
  function werkNav() {
    var t = document.querySelector('[data-wm-actie="terug"]');
    var o = document.querySelector('[data-wm-actie="onze-producten"]');
    var b = document.querySelector('[data-wm-actie="bestelling"]');
    if (t) t.disabled = !sessie || (!stapel.length && !mandOpen && !zkOpenIs());   /* v32.5: ook actief als het zoekvenster open is */
    if (o) o.disabled = !sessie;
    if (b) { b.disabled = !sessie; b.classList.toggle('wm-knop--open', !!mandOpen); }
  }

  function kruimelEl() {
    var k = $('wm-kruimel');
    if (!k) {
      k = document.createElement('div');
      k.id = 'wm-kruimel';
      k.className = 'wm-kruimel';
      $('wm-inhoud').insertBefore(k, $('wm-raster'));
    }
    return k;
  }

  function euroCent(c) {
    if (c === null || c === undefined || isNaN(c)) return '';
    return '€ ' + (c / 100).toFixed(2).replace('.', ',');
  }

  function toonNiveau() {
    var r = $('wm-raster');
    if (!r) return;
    var k = kruimelEl();
    werkNav();
    if (!stapel.length) {
      k.hidden = true;
      tekenHoofdblokken();
      return;
    }
    var n = stapel[stapel.length - 1];
    k.hidden = false;
    k.textContent = ['Onze producten'].concat(stapel.map(function (s) { return s.titel; })).join('  ›  ');
    r.classList.remove('wm-raster--scroll');
    r.removeAttribute('data-wm-scroll');
    if (n.status === 'laden') {
      r.innerHTML = '<div class="wm-raster-melding">' + esc(n.titel) + ' laden…</div>';
      return;
    }
    if (n.status === 'fout') {
      r.innerHTML = '<div class="wm-raster-melding">' + esc(n.titel) + ' kon niet worden geladen.' +
        '<button type="button" class="wm-opnieuw" data-niveau-opnieuw>Opnieuw proberen</button></div>';
      return;
    }
    if (!n.items.length) {
      r.innerHTML = '<div class="wm-raster-melding">Hier staan (nog) geen producten.</div>';
      return;
    }
    var veel = n.items.length > 12;
    r.classList.toggle('wm-raster--scroll', veel);
    if (veel) r.setAttribute('data-wm-scroll', '');
    r.scrollTop = 0;
    r.innerHTML = n.items.map(function (it, i) {
      var sub = it.soort === 'sub'
        ? (it.badge ? it.badge : (it.aantal === null ? '' : it.aantal + (it.aantal === 1 ? ' product' : ' producten')))
        : (it.prijs === null ? '' : (it.vanaf ? 'vanaf ' : '') + euroCent(it.prijs));
      var inhoud =
        '<span class="wm-cat-foto">' + (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') + '</span>' +
        '<span class="wm-cat-naam"><span class="wm-cat-titel">' + esc(it.naam) + '</span>' +
          (sub ? '<span class="wm-cat-sub">' + esc(sub) + '</span>' : '') + '</span>';
      if (it.soort === 'sub') {
        return '<button type="button" class="wm-tegel wm-cat wm-cat--sub" data-item="' + i + '">' + inhoud + '</button>';
      }
      return '<div class="wm-tegel wm-cat wm-cat--product">' +
        '<button type="button" class="wm-cat-info" data-info="' + i + '">' + inhoud + '</button>' +
        '<div class="wm-aantal">' + aantalBediening(it, i) + (heeftGpo(it.id) && it.bestel !== 'persoonlijk' && it.prijs > 0 ? '<button type="button" class="wm-aantal-kies wm-opties" data-pers-item="' + i + '">Opties (tekst, voorgesneden …)</button>' : '') + '</div>' +
      '</div>';
    }).join('');
    werkAantallen();
    zkNaTonen(r, n);   /* v32.4 */
  }

  /* ==========================================================
     v32.4 – PRODUCT ZOEKEN (opdracht Vincent 23-10-2026)
     Vergrootglas "Product zoeken" in de zijbalk direct onder "Bestelling". Aantikken = zoekvenster OVER de productgroepen
     (de groepen eronder blijven staan). Tijdens het typen suggesties; hoe meer letters, hoe minder suggesties.
     Vergevingsgezind: deel van de naam, hoofdletters/accenten maken niet uit, kleine tikfout (één letter) wordt gevonden.
     Veel treffers = lijst (fotootje, naam, prijs); 8 of minder = tegels met grote foto (tablet naar de klant draaien).
     Product kiezen = venster dicht en naar de productgroep waar het product staat (bijv. Appelpunt -> Gebak, punten en
     high-tea › Punten), product kort gemarkeerd; "Terug" werkt daarna gewoon. Bestellen gaat precies als nu (zelfde tegels,
     aantallen, varianten, staffel, Globo). Zoekbron = dezelfde productboom als "Onze producten" (alleen wat daar te kiezen is),
     eenmalig opgehaald en 30 minuten bewaard. Informatieve €0,00-producten worden niet getoond. Winkelwagen wordt niet aangeraakt.
     Verder ongewijzigd t.o.v. Versie 32.3 (geen onderdelen van de niet-geplaatste versies 33/34).
     v32.5 (na controle ChatGPT 23-10 20:16): Enter kiest nooit een resultaat van een eerdere zoektekst; een onvolledige
     productlijst (laadfout) wordt bij de volgende zoekactie aangevuld en zichtbaar gemeld; Terug sluit het zoekvenster ook
     vanaf het hoofdscherm. Tikfouttolerantie blijft: meer letters geeft MEESTAL minder suggesties (bij een tikfout kan de lijst wisselen).
     ========================================================== */
  var zkIndex = null, zkBezig = null, zkTimer = null, zkMarkeer = null, zkRes = [], zkVraag = '', zkResVoor = null;   /* v32.5: zkResVoor = zoektekst waar zkRes bij hoort */
  var ZK_GELDIG_MS = 30 * 60 * 1000, ZK_OPNIEUW_MS = 15000, ZK_MAX = 40, ZK_TEGELS = 8;   /* v32.5: onvolledige lijst na 15 s opnieuw aanvullen */
  function zkNorm(t) { return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim(); }
  function zkOpenIs() { var l = $('wm-zk'); return !!(l && !l.hidden); }
  function zkStijl() {
    if ($('wm-zk-stijl')) return;
    var st = document.createElement('style'); st.id = 'wm-zk-stijl';
    st.textContent =
      '#wm-zoekknop.wm-zk-compact{min-height:0;padding-top:4px;padding-bottom:4px}#wm-zoekknop.wm-zk-compact svg{width:20px;height:20px}' +
      '.wm-zk{position:absolute;inset:var(--wm-gap,12px);z-index:60;background:var(--wm-creme,#F7F3EA);border-radius:var(--wm-radius,14px);box-shadow:0 10px 34px rgba(0,0,0,.28);display:flex;flex-direction:column;padding:16px;gap:10px;min-height:0}' +
      '.wm-zk-kop{display:flex;gap:10px;align-items:center}' +
      '.wm-zk-kop svg{width:30px;height:30px;flex:0 0 auto;fill:none;stroke:var(--wm-groen,#384F4A);stroke-width:2.2;stroke-linecap:round}' +
      '.wm-zk-kop input{flex:1;min-width:0;font:inherit;font-size:24px;padding:12px 16px;border:2px solid var(--wm-groen,#384F4A);border-radius:12px;background:#fff;color:var(--wm-tekst,#1F2A28)}' +
      '.wm-zk-kop button{font:inherit;font-size:18px;font-weight:700;border:0;border-radius:12px;padding:14px 18px;background:var(--wm-groen,#384F4A);color:#fff;cursor:pointer}' +
      '.wm-zk-info{font-size:15px;color:#5b625f;min-height:20px}' +
      '.wm-zk-uit{flex:1;min-height:0;overflow-y:auto;-webkit-overflow-scrolling:touch}' +
      '.wm-zk-rij{display:grid;grid-template-columns:64px 1fr auto;gap:14px;align-items:center;width:100%;min-height:68px;padding:6px 12px;margin:0 0 6px;border:0;border-radius:12px;background:#fff;font:inherit;text-align:left;cursor:pointer;color:var(--wm-tekst,#1F2A28)}' +
      '.wm-zk-rij:active,.wm-zk-tegel:active{background:#efe6cf}' +
      '.wm-zk-foto{width:64px;height:56px;display:flex;align-items:center;justify-content:center;background:#f3efe6;border-radius:8px;overflow:hidden}.wm-zk-foto img{max-width:100%;max-height:100%;object-fit:contain}' +
      '.wm-zk-naam{font-size:20px;line-height:1.2}.wm-zk-naam b{background:#f3e3a8;font-weight:800;border-radius:3px}.wm-zk-pad{display:block;font-size:13px;color:#6b716e;margin-top:2px}' +
      '.wm-zk-prijs{font-size:18px;font-weight:700;white-space:nowrap}' +
      '.wm-zk-tegels{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:12px}' +
      '.wm-zk-tegel{display:flex;flex-direction:column;border:0;border-radius:var(--wm-radius,14px);background:#fff;padding:0;overflow:hidden;font:inherit;text-align:left;cursor:pointer;color:var(--wm-tegel,#1F2A28);box-shadow:0 1px 3px rgba(0,0,0,.08)}' +
      '.wm-zk-tegel .wm-zk-foto{width:100%;height:190px;border-radius:0;background:#fff;border-bottom:3px solid var(--wm-goud,#C8A84B)}' +
      '.wm-zk-tegel .wm-zk-naam{padding:10px 12px 2px;font-weight:700}.wm-zk-tegel .wm-zk-prijs{padding:0 12px 12px;font-size:16px}' +
      '.wm-zk-geen{width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#9aa09d;font-size:13px;text-align:center;padding:4px}' +
      '.wm-zk-melding{font-size:18px;color:#5b625f;padding:18px 4px}' +
      '@media (max-width:900px){.wm-zk-tegels{grid-template-columns:repeat(2,minmax(0,1fr))}.wm-zk-tegel .wm-zk-foto{height:150px}}' +
      '@keyframes wmZkPuls{0%,100%{box-shadow:0 0 0 0 rgba(200,168,75,0)}50%{box-shadow:0 0 0 6px rgba(200,168,75,.95)}}' +
      '.wm-zk-treffer{animation:wmZkPuls .9s ease-in-out 3;outline:3px solid var(--wm-goud,#C8A84B);outline-offset:-3px}';
    document.head.appendChild(st);
  }
  var ZK_ICO = '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5"></circle><line x1="15.5" y1="15.5" x2="21" y2="21"></line></svg>';
  function zkKnop() {
    var m = document.querySelector('[data-wm-actie="bestelling"]');
    var k = $('wm-zoekknop');
    if (!k && m && m.parentNode) {
      zkStijl();
      k = document.createElement('button');
      k.type = 'button'; k.id = 'wm-zoekknop'; k.className = 'wm-knop';   /* gewone zijbalkknop (niet de gouden winkelmandstijl) */
      k.setAttribute('data-wm-actie', 'zoeken'); k.setAttribute('aria-label', 'Product zoeken');
      k.innerHTML = ZK_ICO + '<span>Product zoeken</span>';
      m.parentNode.insertBefore(k, m.nextSibling);   /* direct onder "Bestelling" */
      /* past de zijbalk niet meer, dan compact – nooit bestaande knoppen wegdrukken */
      var past = function () { var z = k.parentNode; if (z && z.scrollHeight > z.clientHeight + 2) k.classList.add('wm-zk-compact'); };
      try { (window.requestAnimationFrame || setTimeout)(past); window.addEventListener('resize', function () { k.classList.remove('wm-zk-compact'); past(); }); } catch (e) {}
    }
    if (k) { k.hidden = !sessie; k.disabled = !sessie; }
    if (!sessie && zkOpenIs()) zkSluit();
    return k;
  }
  function zkLaag() {
    var l = $('wm-zk');
    if (l) return l;
    zkStijl();
    l = document.createElement('div');
    l.id = 'wm-zk'; l.className = 'wm-zk'; l.hidden = true;
    l.setAttribute('role', 'dialog'); l.setAttribute('aria-label', 'Product zoeken');
    l.innerHTML = '<div class="wm-zk-kop" role="search">' + ZK_ICO +
      '<input id="wm-zk-invoer" type="search" inputmode="search" enterkeyhint="search" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" ' +
      'aria-label="Product zoeken" placeholder="Typ een productnaam, bijv. appel">' +
      '<button type="button" data-zk-sluit>✕ Sluiten</button></div>' +
      '<div class="wm-zk-info" id="wm-zk-info"></div><div class="wm-zk-uit" id="wm-zk-uit"></div>';
    ($('wm-werkvlak') || document.body).appendChild(l);
    var inv = l.querySelector('input');
    inv.addEventListener('input', function () { clearTimeout(zkTimer); zkTimer = setTimeout(function () { zkZoek(inv.value); }, 150); });
    inv.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); zkSluit(); }
      else if (e.key === 'Enter') {   /* v32.5: alleen kiezen uit resultaten die bij de HUIDIGE tekst horen; anders eerst zoeken, dan pas kiezen */
        e.preventDefault(); clearTimeout(zkTimer);
        if (zkResVoor !== null && zkResVoor === zkNorm(inv.value)) { if (zkRes.length === 1) zkKies(0); else { try { inv.blur(); } catch (x) {} } }
        else zkZoek(inv.value, true);
      }
    });
    l.addEventListener('click', function (e) {
      if (e.target.closest('[data-zk-sluit]')) { zkSluit(); return; }
      if (e.target.closest('[data-zk-opnieuw]')) { zkIndex = null; var iv = $('wm-zk-invoer'); zkZoek(iv ? iv.value : zkVraag); return; }   /* v32.5 */
      var r = e.target.closest('[data-zk]');
      if (r) zkKies(parseInt(r.getAttribute('data-zk'), 10));
    });
    return l;
  }
  function zkOpen() {
    if (!sessie) return;
    if (mandOpen) sluitMand();   /* alleen het overzicht dicht; de winkelwagen zelf blijft zoals hij is */
    try { sluitInfo(); } catch (e) {}
    $('wm-start').hidden = true; $('wm-inhoud').hidden = false;
    var l = zkLaag(), inv = l.querySelector('input');
    l.hidden = false; inv.value = ''; zkRes = []; zkVraag = ''; zkResVoor = null;
    werkNav();   /* v32.5: Terug actief zolang het zoekvenster open is */
    zkTeken();
    try { inv.focus(); } catch (e) {}   /* tablet: het schermtoetsenbord opent */
    zkBouw().then(function () { if (zkOpenIs()) zkZoek(inv.value); });   /* alvast laden */
  }
  function zkSluit() {
    clearTimeout(zkTimer);
    var l = $('wm-zk'); if (!l) return;
    l.hidden = true;
    var inv = l.querySelector('input'); if (inv) { inv.value = ''; try { inv.blur(); } catch (e) {} }
    zkRes = []; zkVraag = ''; zkResVoor = null;
    werkNav();   /* v32.5: gewone stand van Terug terug */
  }
  /* ---------- index: alle producten uit de productboom, met de weg ernaartoe ---------- */
  function zkBouw() {
    if (zkIndex && Date.now() - zkIndex.t < (zkIndex.fouten ? ZK_OPNIEUW_MS : ZK_GELDIG_MS)) return Promise.resolve(zkIndex);   /* v32.5: onvolledig = snel opnieuw (geslaagde groepen uit de cache) */
    if (zkBezig) return zkBezig;
    var per = {}, lijst = [], fouten = 0;
    function voeg(items, pad, prio) {
      (items || []).forEach(function (it) {
        if (!it || it.soort === 'sub') return;
        if (!(it.prijs > 0)) return;   /* informatieve €0,00-producten (bijv. bruidstaarten) niet tonen */
        var sl = String(it.handle || it.id || it.naam);
        var oud = per[sl];
        if (oud && oud.prio <= prio) return;   /* staat al in een groep die minstens zo logisch is */
        var z = zkNorm(it.naam);
        var e = { it: it, z: z, w: z.split(' ').filter(Boolean), pad: pad, prio: prio };
        if (oud) lijst[lijst.indexOf(oud)] = e; else lijst.push(e);
        per[sl] = e;
      });
    }
    zkBezig = (hoofd.geladen ? Promise.resolve() : laadHoofdblokken()).then(function () {
      if (!hoofd.geladen || !(hoofd.blokken || []).length) { fouten++; return; }   /* v32.5: hoofdgroepen niet geladen = fout, nooit 'geen product gevonden' */
      return Promise.all((hoofd.blokken || []).map(function (b, bi) {
        /* de vaste groepen eerst; Aanbiedingen/Geslaagd/Feestdagen (tijdelijk of thema) alleen als het product nergens anders staat */
        var prio = (/aanbied|reclame|feest|geslaagd|actie/i.test(b.naam + ' ' + b.href) ? 100 : 0) + bi;
        return laadHref(b.href).then(function (res) {
          if (res && res.soort === 'sub') return Promise.all(res.items.map(function (s, si) {
            return laadCollectie(s.handle).then(function (r) {
              voeg(r.items, [{ titel: b.naam, href: b.href }, { titel: s.naam, handle: s.handle }], prio + si / 100);
            }, function () { fouten++; });
          }));
          voeg(res && res.items, [{ titel: b.naam, href: b.href }], prio);
        }, function () { fouten++; });
      }));
    }).then(function () { zkIndex = { items: lijst, t: Date.now(), fouten: fouten, hoofdFout: !hoofd.geladen }; zkBezig = null; return zkIndex; },
            function () { zkBezig = null; zkIndex = { items: lijst, t: Date.now(), fouten: fouten + 1 }; return zkIndex; });
    return zkBezig;
  }
  /* ---------- zoeken ---------- */
  function zkAfstand1(a, b) {   /* true als a en b hooguit één letter verschillen (vervangen, toevoegen of weglaten) */
    if (a === b) return true;
    var la = a.length, lb = b.length;
    if (Math.abs(la - lb) > 1) return false;
    var i = 0, j = 0, fout = 0;
    while (i < la && j < lb) {
      if (a.charAt(i) === b.charAt(j)) { i++; j++; continue; }
      if (++fout > 1) return false;
      if (la > lb) i++; else if (lb > la) j++; else { i++; j++; }
    }
    return fout + (la - i) + (lb - j) <= 1;
  }
  function zkWoordScore(e, d) {
    if (e.z.indexOf(d) === 0) return 0;                         /* naam begint ermee */
    if ((' ' + e.z).indexOf(' ' + d) !== -1) return 1;          /* een woord begint ermee */
    if (e.z.indexOf(d) !== -1) return 2;                        /* ergens in de naam (bijv. "punt" in appelpunt) */
    if (d.length >= 4) {                                        /* kleine tikfout: één letter verschil */
      for (var k = 0; k < e.w.length; k++) {
        var t = e.w[k];
        if (zkAfstand1(d, t) || zkAfstand1(d, t.slice(0, d.length)) || zkAfstand1(d, t.slice(0, d.length + 1)) || zkAfstand1(d, t.slice(0, d.length - 1))) return 3;
        for (var s = 1; s + d.length - 1 <= t.length; s++) {     /* ook midden in een samengesteld woord: "apelpunt" ~ "appelpunt" */
          if (zkAfstand1(d, t.substr(s, d.length)) || zkAfstand1(d, t.substr(s, d.length + 1))) return 3;
        }
      }
    }
    return -1;
  }
  function zkFilter(index, q) {
    var w = zkNorm(q).split(' ').filter(Boolean);
    if (!w.length || w.join('').length < 2) return null;
    var uit = [];
    index.items.forEach(function (e) {
      var tot = 0, f = false;
      for (var i = 0; i < w.length; i++) { var s = zkWoordScore(e, w[i]); if (s < 0) return; if (s === 3) f = true; tot += s; }
      uit.push({ e: e, s: tot, f: f });
    });
    /* tikfout-treffers alleen als er geen gewone treffers zijn – zo worden het bij meer letters altijd minder suggesties */
    if (uit.some(function (x) { return !x.f; })) uit = uit.filter(function (x) { return !x.f; });
    uit.sort(function (a, b) { return a.s - b.s || a.e.z.localeCompare(b.e.z, 'nl', { numeric: true }); });   /* soort 2 vóór soort 10 */
    return uit.map(function (x) { return x.e; });
  }
  function zkZoek(q, kiesAlsEen) {   /* v32.5: kiesAlsEen = Enter: na het zoeken kiezen als er precies één treffer is */
    zkVraag = String(q || '');
    if (zkNorm(q).replace(/ /g, '').length < 2) { zkRes = []; zkResVoor = zkNorm(q); return zkTeken(); }
    if (!zkIndex || zkBezig) zkTeken('laden');
    zkBouw().then(function (idx) {
      var inv = $('wm-zk-invoer');
      if (!zkOpenIs() || (inv && zkNorm(inv.value) !== zkNorm(q))) return;   /* intussen verder getypt of gesloten */
      zkRes = zkFilter(idx, q) || []; zkResVoor = zkNorm(q);
      zkTeken();
      if (kiesAlsEen && zkRes.length === 1) zkKies(0);
    });
  }
  /* het deel van de naam dat overeenkomt vet maken (accent- en hoofdletterongevoelig) */
  function zkVet(naam, q) {
    var w = zkNorm(q).split(' ').filter(function (x) { return x.length >= 2; });
    var kaart = [], plat = '';
    for (var i = 0; i < naam.length; i++) {
      var c = zkNorm(naam.charAt(i)) || ' ';
      for (var j = 0; j < c.length; j++) { plat += c.charAt(j); kaart.push(i); }
    }
    var aan = [];
    w.forEach(function (d) { var p = plat.indexOf(d); if (p > -1) for (var k = p; k < p + d.length; k++) aan[kaart[k]] = 1; });
    var uit = '', open = false;
    for (var n = 0; n < naam.length; n++) {
      if (aan[n] && !open) { uit += '<b>'; open = true; } else if (!aan[n] && open) { uit += '</b>'; open = false; }
      uit += esc(naam.charAt(n));
    }
    return uit + (open ? '</b>' : '');
  }
  function zkFoto(src, breed) {
    if (!src) return '<span class="wm-zk-foto"><span class="wm-zk-geen">geen foto</span></span>';
    var s = String(src).replace(/([?&])width=\d+/, '$1width=' + breed);
    return '<span class="wm-zk-foto"><img src="' + esc(s) + '" alt="" loading="lazy"></span>';
  }
  function zkTeken(stand) {
    var uit = $('wm-zk-uit'), info = $('wm-zk-info');
    if (!uit || !info) return;
    uit.scrollTop = 0;
    if (stand === 'laden') { info.textContent = ''; uit.innerHTML = '<div class="wm-zk-melding">Producten worden geladen…</div>'; return; }
    if (zkNorm(zkVraag).replace(/ /g, '').length < 2) {
      info.textContent = 'Typ minstens 2 letters van de productnaam.';
      uit.innerHTML = ''; return;
    }
    var opnieuw = '<button type="button" class="wm-opnieuw" data-zk-opnieuw>Opnieuw proberen</button>';   /* v32.5 */
    if (zkIndex && zkIndex.hoofdFout) {
      info.textContent = '';
      uit.innerHTML = '<div class="wm-zk-melding">De productgroepen konden niet worden geladen (verbinding?). Er is dus niet gezocht. ' + opnieuw + '</div>';
      return;
    }
    if (!zkRes.length) {
      info.textContent = '';
      uit.innerHTML = '<div class="wm-zk-melding">Geen product gevonden met "' + esc(zkVraag.trim().slice(0, 40)) + '".' +
        (zkIndex && zkIndex.fouten ? ' Let op: niet alle productgroepen konden worden geladen, het product kan er dus toch zijn. ' + opnieuw : ' Probeer een ander deel van de naam.') + '</div>';
      return;
    }
    var toon = zkRes.slice(0, ZK_MAX);
    info.textContent = zkRes.length + (zkRes.length === 1 ? ' product gevonden' : ' producten gevonden') +
      (zkRes.length > ZK_MAX ? ' – de eerste ' + ZK_MAX + ' staan hieronder; typ verder om te verfijnen' : '') + ' · tik aan om naar de productgroep te gaan' +
      (zkIndex && zkIndex.fouten ? ' · LET OP: niet alle productgroepen konden worden geladen – de lijst kan onvolledig zijn' : '');   /* v32.5 */
    var prijs = function (it) { return (it.vanaf ? 'vanaf ' : '') + euroCent(it.prijs); };
    var pad = function (e) { return e.pad.map(function (p) { return p.titel; }).join(' › '); };
    if (zkRes.length <= ZK_TEGELS) {
      uit.innerHTML = '<div class="wm-zk-tegels">' + toon.map(function (e, i) {
        return '<button type="button" class="wm-zk-tegel" data-zk="' + i + '">' + zkFoto(e.it.img, 400) +
          '<span class="wm-zk-naam">' + zkVet(e.it.naam, zkVraag) + '<span class="wm-zk-pad">' + esc(pad(e)) + '</span></span>' +
          '<span class="wm-zk-prijs">' + esc(prijs(e.it)) + '</span></button>';
      }).join('') + '</div>';
    } else {
      uit.innerHTML = toon.map(function (e, i) {
        return '<button type="button" class="wm-zk-rij" data-zk="' + i + '">' + zkFoto(e.it.img, 120) +
          '<span class="wm-zk-naam">' + zkVet(e.it.naam, zkVraag) + '<span class="wm-zk-pad">' + esc(pad(e)) + '</span></span>' +
          '<span class="wm-zk-prijs">' + esc(prijs(e.it)) + '</span></button>';
      }).join('');
    }
  }
  /* ---------- product gekozen: naar de productgroep waar het staat ---------- */
  function zkKies(i) {
    var e = zkRes[i];
    if (!e) return;
    meld('jwm:zoeken_gekozen', { handle: e.it.handle, vraag: zkVraag.slice(0, 40), groep: e.pad.map(function (p) { return p.titel; }).join(' › ') });
    zkSluit();
    if (mandOpen) sluitMand();
    stapel = [];
    var niveaus = e.pad.map(function (p) {
      return { titel: p.titel, status: 'laden', items: [],
               laad: p.href ? (function (h) { return function () { return laadHref(h); }; })(p.href)
                            : (function (h) { return function () { return laadCollectie(h); }; })(p.handle) };
    });
    niveaus.forEach(function (n) { stapel.push(n); });
    zkMarkeer = e.it.handle;
    toonNiveau();
    niveaus.forEach(function (n) { laadInNiveau(n); });   /* uit de cache: direct klaar; "Terug" toont daarna de bovenliggende groep */
  }
  /* aangeroepen aan het eind van toonNiveau: gezochte product in beeld brengen en kort markeren */
  function zkNaTonen(r, n) {
    if (!zkMarkeer || !n || n.status !== 'ok') return;
    var h = zkMarkeer, idx = -1;
    n.items.forEach(function (it, i) { if (idx < 0 && it && it.handle === h) idx = i; });
    zkMarkeer = null;
    if (idx < 0) return;
    var knop = r.querySelector('[data-info="' + idx + '"]');
    var tegel = knop && knop.closest ? knop.closest('.wm-tegel') : null;
    if (!tegel) return;
    tegel.classList.add('wm-zk-treffer');
    try { tegel.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (x) { try { tegel.scrollIntoView(); } catch (y) {} }
    setTimeout(function () { tegel.classList.remove('wm-zk-treffer'); }, 4000);
  }

  /* ==========================================================
     FASE 7 – aantalbediening, winkelwagen en productinformatie
     ========================================================== */
  function aantalBediening(it, i) {
    if (it.bestel !== 'persoonlijk' && gpoVerplicht(it.id)) return '';   /* v28: alleen via "Opties" (verplichte invoer) */
    if (it.bestel === 'direct') {
      var v = it.variant.id;
      return '<button type="button" class="wm-aantal-min" data-min="' + v + '" aria-label="Min">−</button>' +
        '<button type="button" class="wm-aantal-getal" data-typ="' + v + '" data-typ-item="' + i + '" data-vq="' + v + '">0</button>' +
        '<button type="button" class="wm-aantal-plus" data-plus="' + v + '" aria-label="Plus"' + (it.variant.beschikbaar ? '' : ' disabled') + '>+</button>';
    }
    if (it.bestel === 'keuze') {
      return '<button type="button" class="wm-aantal-kies" data-info="' + i + '" data-kies-item="' + i + '">Kies ' + esc(keuzeWoord(it)) + '</button>';
    }
    if (it.bestel === 'persoonlijk') {
      /* v24 route (a): personaliseren op de echte productpagina (Globo); €0-producten blijven niet bestelbaar */
      if (it.prijs > 0) return '<button type="button" class="wm-aantal-kies" data-pers-item="' + i + '">Personaliseren</button>';
      return '<span class="wm-aantal-nvt">Niet bestelbaar</span>';
    }
    return '<span class="wm-aantal-nvt">Niet bestelbaar</span>';
  }
  function keuzeWoord(it) {
    var namen = (it.optieNamen || []).filter(function (n) { return !/^aantal$/i.test(n) || !it.staffelOptie; });
    var n = (namen[0] || 'variant').toLowerCase();
    if (/personen/.test(n)) return 'maat';
    return n;
  }

  /* ---------- winkelwagen (dezelfde Shopify-winkelwagen als de webshop) ---------- */
  var mand = { regels: {}, aantal: 0, totaal: 0 };
  var wachtrij = {};
  var bezig = {};
  var mandTimer = null;
  var mandKeten = Promise.resolve();

  function laadMand() {
    return haalJson('/cart.js').then(function (c) {
      var regels = {};
      (c.items || []).forEach(function (it) {
        var props = it.properties || {};
        var heeftProps = Object.keys(props).some(function (k) { return props[k] !== null && props[k] !== ''; });
        if (!heeftProps && !regels[it.variant_id]) regels[it.variant_id] = { key: it.key, qty: it.quantity };
      });
      mand.regels = regels;
      mand.aantal = c.item_count || 0;
      mand.totaal = c.total_price || 0;
      mand.items = c.items || [];
      mand.fam = bouwMandFamilies(mand.items);
      werkMandInfo();
      werkAantallen();
      if (mandOpen) tekenMand();
      return c;
    });
  }
  function aantalVan(vid) {
    if (wachtrij.hasOwnProperty(vid)) return wachtrij[vid];
    if (bezig.hasOwnProperty(vid)) return bezig[vid];
    var fm = mand.fam && mand.fam[vid];
    if (fm) return fm.qty;
    var r = mand.regels[vid];
    return r ? r.qty : 0;
  }
  function werkAantallen() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vq]'), function (el) {
      var q = aantalVan(el.getAttribute('data-vq'));
      el.textContent = q;
      el.classList.toggle('heeft', q > 0);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-min]'), function (el) {
      el.disabled = aantalVan(el.getAttribute('data-min')) <= 0;
    });
    var n = stapel[stapel.length - 1];
    Array.prototype.forEach.call(document.querySelectorAll('[data-kies-item]'), function (el) {
      var it = n && n.items[parseInt(el.getAttribute('data-kies-item'), 10)];
      if (!it) return;
      var som = it.keuzeVarianten.reduce(function (s, v) { return s + aantalVan(v.id); }, 0);
      el.textContent = som > 0 ? som + ' in bestelling · wijzig' : 'Kies ' + keuzeWoord(it);
      el.classList.toggle('heeft', som > 0);
    });
  }
  function werkMandInfo() {
    var a = $('wm-mand-aantal'), t = $('wm-mand-totaal');
    if (a) a.textContent = mand.aantal;
    if (t) t.textContent = euroCent(mand.totaal);
  }

  /* ==========================================================
     FASE 10 – Staffelkorting AAN/UIT (alleen Vincent en Erica)
     Bron: uitsluitend de bestaande Shopify-staffelvarianten.
     Een familie = één product + dezelfde overige opties (bijv. Koud of Warm).
     Per familie is er één basisvariant ("Normaal", of bij Petit fours per stuk
     de variant zonder percentage "25+ stuks – normale prijs"). Bij UIT altijd de
     basisvariant. Bij AAN kiest het aantal de kortingsvariant waarvan de reeks
     het aantal bevat (exact één treffer); onder de eerste kortingsgrens de basis.
     ========================================================== */
  var staffelAan = false;
  var staffelVraag = false;
  var staffelBericht = '';      /* blijft in de winkelmand staan tot de volgende wijziging */
  var staffelBlokkeer = false;  /* true = winkelwagen niet eenduidig; afronden geblokkeerd */
  var STAFFEL_PROPS = ['_staffelkorting', 'Berekening', 'Staffelkorting', '_staffel_door'];
  var STAFFEL_ATTR = 'jullens_staffel_door';
  var fam = {};                 /* basisvariant-id -> familie */
  var famVan = {};              /* variant-id -> { f: familie, v: variantinfo } */
  var famHandles = {};          /* handle -> true als geregistreerd */

  function staffelWaarde(w) {
    w = String(w || '').trim();
    if (w === 'Normaal') return { normaal: true, lo: 0, hi: Infinity, pct: 0 };
    var m = /^(\d+)\s*(?:-\s*(\d+)|\+)\s*stuks(?:\s*\((\d+(?:[.,]\d+)?)%\))?(?:\s*[–-]\s*normale prijs)?$/i.exec(w);
    if (!m) return null;
    return { normaal: false, lo: parseInt(m[1], 10), hi: m[2] ? parseInt(m[2], 10) : Infinity,
      pct: m[3] ? parseFloat(m[3].replace(',', '.')) : 0 };
  }
  function staffelOptieIndex(item) {
    var idx = -1;
    (item.optieNamen || []).forEach(function (n, i) {
      if (!/^aantal$/i.test(n) || !item.varianten.length) return;
      var alle = item.varianten.every(function (v) { return !!staffelWaarde(v.opties[i]); });
      var korting = item.varianten.some(function (v) { var s = staffelWaarde(v.opties[i]); return s && s.pct > 0; });
      if (alle && korting) idx = i;
    });
    return idx;
  }
  function registreerFamilies(item) {
    var idx = staffelOptieIndex(item);
    if (idx < 0) return;
    var groepen = {};
    item.varianten.forEach(function (v) {
      var sleutel = item.handle + '|' + v.opties.filter(function (x, i) { return i !== idx; }).join('|');
      var s = staffelWaarde(v.opties[idx]);
      (groepen[sleutel] = groepen[sleutel] || []).push({ id: v.id, prijs: v.prijs, lo: s.lo, hi: s.hi, pct: s.pct, normaal: s.normaal });
    });
    Object.keys(groepen).forEach(function (sleutel) {
      var vs = groepen[sleutel];
      var normaal = vs.filter(function (v) { return v.normaal; });
      var zonder = vs.filter(function (v) { return !v.normaal && v.pct === 0; });
      var basis = normaal.length === 1 ? normaal[0] : (normaal.length === 0 && zonder.length === 1 ? zonder[0] : null);
      if (!basis) return;             /* geen eenduidige basis: niet als staffelfamilie gebruiken */
      var f = {
        sleutel: sleutel, handle: item.handle, naam: item.naam,
        basis: basis, basisNormaal: basis.normaal,
        reeksen: vs.filter(function (v) { return !v.normaal; }),
        min: basis.normaal ? 0 : basis.lo,
        maxUit: basis.normaal ? Infinity : basis.hi
      };
      fam[basis.id] = f;
      vs.forEach(function (v) { famVan[v.id] = { f: f, v: v }; });
    });
    famHandles[item.handle] = true;
  }
  /* uitkomst: { v: variant } of { fout: 'min' | 'maxUit' | 'geen' | 'meerdere', v: basis of null } */
  function kiesStaffel(f, q, aan) {
    if (q <= 0) return { v: f.basis };
    if (q < f.min) return { fout: 'min', v: null };
    if (!aan) return q > f.maxUit ? { fout: 'maxUit', v: null } : { v: f.basis };
    /* alleen varianten mét percentage zijn kortingsvarianten */
    var kort = f.reeksen.filter(function (r) { return r.pct > 0; });
    var treffers = kort.filter(function (r) { return q >= r.lo && q <= r.hi; });
    if (treffers.length === 1) return { v: treffers[0] };
    var laagste = Math.min.apply(null, kort.map(function (r) { return r.lo; }));
    var basisPast = q >= (f.basisNormaal ? 0 : f.basis.lo) && q <= f.basis.hi;
    if (treffers.length === 0 && q < laagste && basisPast) return { v: f.basis };
    return { fout: treffers.length ? 'meerdere' : 'geen', v: basisPast ? f.basis : null };
  }
  function staffelMelding(f, q, fout) {
    if (fout === 'min') return f.naam + ': minimaal ' + f.min + ' stuks (productiecharge). Kleinere aantallen via de gewone verkoop.';
    if (fout === 'maxUit') return f.naam + ': ' + q + ' stuks kan alleen met staffelkorting AAN (Vincent of Erica). Zonder staffel maximaal ' + f.maxUit + ' stuks.';
    if (fout === 'geen') return f.naam + ': geen geldige staffelvariant voor ' + q + ' stuks – staffelkorting NIET toegepast.';
    if (fout === 'meerdere') return f.naam + ': meerdere staffelvarianten passen bij ' + q + ' stuks – staffelkorting NIET toegepast.';
    return '';
  }
  /* mag dit aantal worden ingevoerd? (blokkeert alleen wat nooit geldig kan zijn) */
  function magAantal(basisId, q) {
    var f = fam[basisId];
    if (!f || q <= 0) return true;
    var k = kiesStaffel(f, q, staffelAan);
    if (k.fout && !k.v) { toast(staffelMelding(f, q, k.fout)); return false; }
    return true;
  }
  /* +/-: bij een minimum springt + van 0 direct naar het minimum en - onder het minimum naar 0 */
  function stapAantal(basisId, huidig, delta) {
    var nq = huidig + delta;
    var f = fam[basisId];
    if (f && f.min > 0) {
      if (delta > 0 && nq < f.min) nq = f.min;
      if (delta < 0 && nq < f.min) nq = 0;
    }
    return Math.max(0, nq);
  }
  function euroNbsp(c) { return '€\u00A0' + (c / 100).toFixed(2).replace('.', ','); }
  /* regel-eigenschappen exact in de vorm van de webshop-kortingstrechter */
  function staffelProps(f, v, q) {
    var korting = (f.basis.prijs - v.prijs) * q;
    return {
      '_staffelkorting': 'ja',
      'Berekening': q + ' x ' + euroNbsp(v.prijs) + ' per stuk = ' + euroNbsp(v.prijs * q),
      'Staffelkorting': String(v.pct).replace('.', ',') + '%' + (korting > 0 ? ' (\u2212\u00A0' + (korting / 100).toFixed(2).replace('.', ',') + ' EUR)' : ''),
      '_staffel_door': sessie ? sessie.id : ''
    };
  }
  function alleenStaffelProps(props) {
    return Object.keys(props || {}).every(function (k) {
      return STAFFEL_PROPS.indexOf(k) > -1 || props[k] === null || props[k] === '';
    });
  }
  function heeftStaffelProps(props) {
    return !!props && Object.keys(props).some(function (k) { return STAFFEL_PROPS.indexOf(k) > -1 && props[k]; });
  }
  /* families in de winkelwagen opbouwen (Koud en Warm blijven apart) */
  function bouwMandFamilies(items) {
    var r = {};
    (items || []).forEach(function (it) {
      var fv = famVan[it.variant_id];
      if (!fv || !alleenStaffelProps(it.properties)) return;
      var b = fv.f.basis.id;
      var x = r[b] = r[b] || { qty: 0, regels: [] };
      x.qty += it.quantity;
      x.regels.push(it);
    });
    return r;
  }
  /* producten van staffelregels die (nog) niet geladen zijn ophalen */
  function zorgFamilies(items) {
    var nodig = [];
    (items || []).forEach(function (it) {
      if (famVan[it.variant_id] || famHandles[it.handle] || nodig.indexOf(it.handle) > -1) return;
      var opt = (it.options_with_values || []).some(function (o) { return /^aantal$/i.test(o.name); });
      if (opt || heeftStaffelProps(it.properties)) nodig.push(it.handle);
    });
    return Promise.all(nodig.map(function (h) {
      return haalJson('/products/' + h + '.js').then(function (p) { productItem(p, true); famHandles[h] = true; }, function () {});
    }));
  }
  function post(url, body) {
    return fetch(url, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) { if (!res.ok) throw new Error('status ' + res.status); return res.json(); });
  }
  function zelfdeProps(a, b) {
    a = a || {}; b = b || {};
    var ka = Object.keys(a).filter(function (k) { return a[k] !== null && a[k] !== ''; }).sort();
    var kb = Object.keys(b).filter(function (k) { return b[k] !== null && b[k] !== ''; }).sort();
    return ka.length === kb.length && ka.every(function (k, i) { return k === kb[i] && String(a[k]) === String(b[k]); });
  }
  /* Kern: de winkelwagen laten overeenkomen met staffel AAN/UIT.
     Nieuwe regel eerst toevoegen, daarna oude regels op 0: er raakt nooit iets kwijt. */
  var staffelMeldingen = [];
  function staffelSync() {
    var cart;
    staffelBlokkeer = false;
    return haalJson('/cart.js').then(function (c) { cart = c; return zorgFamilies(c.items); }).then(function () {
      var fams = bouwMandFamilies(cart.items);
      var acties = [];
      var metKorting = false;
      Object.keys(fams).forEach(function (b) {
        var fl = fams[b], f = fam[b], q = fl.qty;
        var k = kiesStaffel(f, q, staffelAan && !!sessie);
        if (k.fout) staffelMeldingen.push(staffelMelding(f, q, k.fout));
        if (k.fout && !k.v) {
          /* v12: nooit een regel verwijderen – laten staan, melden en afronden blokkeren */
          staffelBlokkeer = true;
          staffelBericht = f.naam + ' (' + q + ' st.): geen geldige variant voor dit aantal. De regel blijft staan; pas het aantal aan. Afronden is geblokkeerd.';
          staffelMeldingen.push(staffelBericht);
          return;
        }
        var doel = k.v;
        var props = doel && doel.pct > 0 ? staffelProps(f, doel, q) : {};
        if (doel && doel.pct > 0) metKorting = true;
        var goed = doel && fl.regels.length === 1 && fl.regels[0].variant_id === doel.id &&
          fl.regels[0].quantity === q && zelfdeProps(fl.regels[0].properties, props);
        if (goed) return;
        if (doel) acties.push(function () { return post('/cart/add.js', { items: [{ id: doel.id, quantity: q, properties: props }] }); });
        fl.regels.forEach(function (it) {
          acties.push(function () {
            return haalJson('/cart.js').then(function (nu) {
              /* alleen verwijderen als de sleutel niet de zojuist toegevoegde doelregel is */
              var bestaat = (nu.items || []).filter(function (x) { return x.key === it.key; })[0];
              if (!bestaat) return;
              if (doel && bestaat.variant_id === doel.id && zelfdeProps(bestaat.properties, props)) {
                return bestaat.quantity === q ? null : post('/cart/change.js', { id: it.key, quantity: q });
              }
              return post('/cart/change.js', { id: it.key, quantity: 0 });
            });
          });
        });
      });
      var gewenst = metKorting && staffelAan && sessie ? sessie.id : '';
      var huidig = (cart.attributes || {})[STAFFEL_ATTR] || '';
      if (gewenst !== huidig) {
        acties.push(function () { var a = {}; a[STAFFEL_ATTR] = gewenst; return post('/cart/update.js', { attributes: a }); });
      }
      return acties.reduce(function (p, f) { return p.then(f); }, Promise.resolve());
    }).catch(function () {
      staffelMeldingen.push('Staffelcontrole mislukt – controleer de bestelling');
    }).then(function () {
      if (staffelMeldingen.length) {
        var uniek = staffelMeldingen.filter(function (x, i, a) { return x && a.indexOf(x) === i; });
        staffelMeldingen = [];
        if (uniek.length) toast(uniek.join(' · '), 7000);
      }
    });
  }
  function staffelSyncPlan() {
    mandKeten = mandKeten.then(staffelSync).then(laadMand).catch(function () {});
    return mandKeten;
  }
  function staffelBerichtTonen() {
    if (staffelBericht && sessie) toast(staffelBericht, 7000);
  }
  function zetStaffel(aan) {
    if (!sessie || !sessie.staffel) return;
    if (aan && !bvToken()) { toast('Korting geven kan alleen nadat de server uw code heeft gecontroleerd. Meld u opnieuw aan (code vastgelegd op BLAUW?).', 7000); return; }   /* v24 */
    staffelAan = !!aan;
    staffelVraag = false;
    werkStaffelLabel();
    tekenMand();
    toast(staffelAan ? 'Staffelkorting AAN voor deze bestelling (' + sessie.naam + ')' : 'Staffelkorting UIT');
    staffelSyncPlan();
  }
  function werkStaffelLabel() {
    var knop = $('wm-medewerker');
    if (!knop) return;
    var el = $('wm-staffel-label');
    if (!el) {
      el = document.createElement('span');
      el.id = 'wm-staffel-label';
      el.className = 'wm-staffel-label';
      el.textContent = 'STAFFEL AAN';
      knop.appendChild(el);
    }
    el.hidden = !(sessie && staffelAan);
  }
  function staffelBlok() {
    var bericht = staffelBericht ? '<div class="wm-staffel wm-staffel--bericht"><span>' + esc(staffelBericht) + '</span></div>' : '';
    if (!sessie || !sessie.staffel) return bericht;
    return bericht + staffelSchakelaar();
  }
  function staffelSchakelaar() {
    if (staffelAan) {
      return '<div class="wm-staffel wm-staffel--aan"><span>Staffelkorting <b>AAN</b></span>' +
        '<button type="button" class="wm-staffel-knop" data-staffel="uit">Zet UIT</button></div>';
    }
    if (staffelVraag) {
      return '<div class="wm-staffel wm-staffel--vraag"><span>Staffelkorting AAN voor deze bestelling?</span>' +
        '<button type="button" class="wm-staffel-knop wm-staffel-knop--ja" data-staffel="aan">Ja, AAN</button>' +
        '<button type="button" class="wm-staffel-knop" data-staffel="annuleer">Nee</button></div>';
    }
    return '<div class="wm-staffel"><span>Staffelkorting <b>UIT</b></span>' +
      '<button type="button" class="wm-staffel-knop" data-staffel="vraag">Zet AAN</button></div>';
  }

  function zetAantal(vid, q) {
    q = Math.max(0, Math.min(999, parseInt(q, 10) || 0));
    if (!magAantal(vid, q)) { werkAantallen(); return; }
    staffelBericht = '';
    wachtrij[vid] = q;
    werkAantallen();
    clearTimeout(mandTimer);
    mandTimer = setTimeout(verwerkWachtrij, 350);
  }
  function verwerkWachtrij() {
    var werk = wachtrij;
    wachtrij = {};
    Object.keys(werk).forEach(function (k) { bezig[k] = werk[k]; });
    mandKeten = mandKeten.then(function () {
      var stappen = Object.keys(werk).map(function (vid) {
        return function () {
          var q = werk[vid];
          var r = mand.regels[vid];
          var verzoek = null;
          /* fase 10: staffelfamilie – aantal op de bestaande familieregel zetten;
             de juiste variant wordt daarna door staffelSync bepaald */
          var fm = mand.fam && mand.fam[vid];
          if (fm && fm.regels.length) {
            return fm.regels.reduce(function (p, it, i) {
              return p.then(function () { return post('/cart/change.js', { id: it.key, quantity: i === 0 ? q : 0 }); });
            }, Promise.resolve());
          }
          if (vid.indexOf('k:') === 0) verzoek = { url: '/cart/change.js', body: { id: vid.slice(2), quantity: q } };
          else if (r) verzoek = { url: '/cart/change.js', body: { id: r.key, quantity: q } };
          else if (q > 0) verzoek = { url: '/cart/add.js', body: { items: [{ id: parseInt(vid, 10), quantity: q }] } };
          if (!verzoek) return Promise.resolve();
          return fetch(verzoek.url, {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(verzoek.body)
          }).then(function (res) { if (!res.ok) throw new Error('status ' + res.status); });
        };
      });
      return stappen.reduce(function (p, f) { return p.then(f); }, Promise.resolve())
        .catch(function () { toast('Winkelwagen kon niet worden bijgewerkt – probeer opnieuw'); })
        .then(staffelSync)
        .then(laadMand)
        .then(function () { Object.keys(werk).forEach(function (k) { if (bezig[k] === werk[k]) delete bezig[k]; }); werkAantallen(); },
              function () { Object.keys(werk).forEach(function (k) { delete bezig[k]; }); werkAantallen(); });
    });
  }

  /* ---------- directe numerieke invoer ---------- */
  var invoer = { vid: null, tekst: '' };
  function openInvoer(vid, naam) {
    invoer.vid = vid;
    invoer.tekst = '';
    invoer.naam = naam;
    var el = zorgVenster('wm-invoer', 'wm-pin');
    tekenInvoer();
    el.hidden = false;
  }
  function sluitInvoer() {
    var el = $('wm-invoer');
    if (el) { el.hidden = true; el.innerHTML = ''; }
    invoer.vid = null;
  }
  function tekenInvoer() {
    var toetsen = '';
    ['1', '2', '3', '4', '5', '6', '7', '8', '9'].forEach(function (c) {
      toetsen += '<button type="button" class="wm-toets" data-inv="' + c + '">' + c + '</button>';
    });
    toetsen += '<button type="button" class="wm-toets wm-toets--klein" data-inv="wis">Wis</button>';
    toetsen += '<button type="button" class="wm-toets" data-inv="0">0</button>';
    toetsen += '<button type="button" class="wm-toets wm-toets--klein" data-inv="terug">&#9003;</button>';
    var nu = aantalVan(invoer.vid);
    if (String(invoer.vid).indexOf('k:') === 0) {
      var ri = (mand.items || []).filter(function (x) { return 'k:' + x.key === invoer.vid; })[0];
      nu = ri ? regelAantal(ri) : 0;
    }
    $('wm-invoer').innerHTML =
      '<div class="wm-pin-paneel">' +
        '<div class="wm-pin-links">' +
          '<div class="wm-pin-tekst">Aantal voor</div>' +
          '<div class="wm-pin-naam wm-invoer-naam">' + esc(invoer.naam) + '</div>' +
          '<div class="wm-invoer-getal">' + esc(invoer.tekst === '' ? String(nu) : invoer.tekst) + '</div>' +
          '<div class="wm-snel">' + [10, 25, 50, 100].map(function (x) {
            return '<button type="button" class="wm-toets wm-toets--klein" data-inv-snel="' + x + '">' + x + '</button>';
          }).join('') + '</div>' +
          '<button type="button" class="wm-toets wm-toets--ok wm-invoer-ok" data-inv="ok">OK</button>' +
          '<button type="button" class="wm-pin-annuleer" data-inv="annuleer">Annuleren</button>' +
        '</div>' +
        '<div class="wm-pin-toetsen">' + toetsen + '</div>' +
      '</div>';
  }
  function invoerToets(t) {
    if (!invoer.vid) return;
    if (t === 'annuleer') { sluitInvoer(); return; }
    if (t === 'ok') {
      if (invoer.tekst !== '') {
        if (String(invoer.vid).indexOf('k:') === 0) zetRegel(String(invoer.vid).slice(2), invoer.tekst);
        else zetAantal(invoer.vid, invoer.tekst);
      }
      sluitInvoer();
      return;
    }
    if (t === 'wis') invoer.tekst = '';
    else if (t === 'terug') invoer.tekst = invoer.tekst.slice(0, -1);
    else if (t.length === 1 && '0123456789'.indexOf(t) !== -1 && invoer.tekst.length < 3) invoer.tekst = (invoer.tekst + t).replace(/^0+(?=[0-9])/, '');
    tekenInvoer();
  }

  function zorgVenster(id, klasse) {
    var el = $(id);
    if (!el) {
      el = document.createElement('div');
      el.id = id;
      el.className = klasse;
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.hidden = true;
      document.body.appendChild(el);
    }
    return el;
  }

  /* ---------- productinformatie (bron: de productpagina van de website) ---------- */
  var infoCache = {};
  var infoItem = null;
  function laadInfo(handle) {
    if (infoCache[handle]) return Promise.resolve(infoCache[handle]);
    return haalTekst('/products/' + handle).then(function (html) {
      var d = new DOMParser().parseFromString(html, 'text/html');
      var info = { ingredienten: '', allergenen: [], omschrijving: '' };
      Array.prototype.forEach.call(d.querySelectorAll('main details'), function (det) {
        var kop = schoon((det.querySelector('summary') || {}).textContent || '');
        var inhoud = det.querySelector('.accordion__content') || det;
        if (/^ingredi/i.test(kop) && !info.ingredienten) info.ingredienten = schoon(inhoud.textContent);
        if (/^allergen/i.test(kop) && !info.allergenen.length) {
          var li = inhoud.querySelectorAll('li');
          info.allergenen = li.length
            ? Array.prototype.map.call(li, function (x) { return schoon(x.textContent); }).filter(Boolean)
            : schoon(inhoud.textContent).split(',').map(schoon).filter(Boolean);
        }
      });
      var oms = d.querySelector('main .product__description');
      info.omschrijving = oms ? schoon(oms.textContent) : '';
      infoCache[handle] = info;
      return info;
    });
  }
  function openInfo(i) {
    var n = stapel[stapel.length - 1];
    var it = n && n.items[i];
    if (!it) return;
    infoItem = it;
    meld('jwm:product', { handle: it.handle, naam: it.naam });
    var el = zorgVenster('wm-info', 'wm-info');
    tekenInfo(null);
    el.hidden = false;
    laadInfo(it.handle).then(function (info) {
      if (infoItem === it) tekenInfo(info);
    }, function () {
      if (infoItem === it) tekenInfo({ fout: true });
    });
  }
  function sluitInfo() {
    var el = $('wm-info');
    if (el) { el.hidden = true; el.innerHTML = ''; }
    infoItem = null;
  }
  function tekenInfo(info) {
    var it = infoItem;
    if (!it) return;
    var bestel = '';
    if (it.bestel !== 'persoonlijk' && gpoVerplicht(it.id)) {   /* v28 */
      bestel = '<div class="wm-info-let">Dit product heeft verplichte opties (bijvoorbeeld een foto of een opschrift). Kies op het overzicht de knop "Opties".</div>';
    } else if (it.bestel === 'direct') {
      bestel = '<div class="wm-info-regel"><span>Aantal</span><div class="wm-aantal">' + aantalBedieningVariant(it.variant, it.naam) + '</div></div>';
    } else if (it.bestel === 'keuze') {
      bestel = '<div class="wm-info-kop2">Kies ' + esc(keuzeWoord(it)) + ' en aantal</div>' +
        it.keuzeVarianten.map(function (v) {
          return '<div class="wm-info-regel"><span>' + esc(v.label || it.naam) + ' <b>' + esc(euroCent(v.prijs)) + '</b></span>' +
            '<div class="wm-aantal">' + aantalBedieningVariant(v, it.naam + (v.label ? ' – ' + v.label : '')) + '</div></div>';
        }).join('');
    } else if (it.bestel === 'persoonlijk') {
      bestel = '<div class="wm-info-let">Dit product heeft persoonlijke opties (foto, logo of tekst). Kies op het overzicht de knop "Personaliseren".</div>';   /* v28: route (a) bestaat sinds V24 */
    }
    var ingr, allerg;
    if (!info) {
      ingr = '<div class="wm-info-leeg">Productinformatie laden…</div>'; allerg = '';
    } else if (info.fout) {
      ingr = '<div class="wm-info-leeg">Productinformatie kon niet worden geladen.</div>'; allerg = '';
    } else {
      ingr = info.ingredienten
        ? '<p class="wm-info-ingr">' + esc(info.ingredienten) + '</p>'
        : '<div class="wm-info-leeg">Geen ingrediëntendeclaratie ingevuld voor dit product.</div>';
      allerg = info.allergenen.length
        ? '<div class="wm-info-allerg">' + info.allergenen.map(function (a) { return '<span>' + esc(a) + '</span>'; }).join('') + '</div>'
        : '<div class="wm-info-leeg">Geen allergenen ingevuld voor dit product.</div>';
    }
    $('wm-info').innerHTML =
      '<div class="wm-info-paneel">' +
        '<div class="wm-info-kop"><div><h2>' + esc(it.naam) + '</h2><p>' +
          (it.prijs === null ? '' : (it.vanaf ? 'vanaf ' : '') + esc(euroCent(it.prijs))) + '</p></div>' +
          '<button type="button" class="wm-reclame-sluit" data-info-sluit>Sluiten ✕</button></div>' +
        '<div class="wm-info-lijf" data-wm-scroll>' +
          '<div class="wm-info-foto">' + (it.img ? '<img src="' + esc(it.img.replace('width=400', 'width=600')) + '" alt="">' : '') + '</div>' +
          '<div class="wm-info-tekst">' +
            '<div class="wm-info-kop2">Allergenen</div>' + allerg +
            '<div class="wm-info-kop2">Ingrediënten</div>' + ingr +
            bestel +
            (info && info.omschrijving ? '<div class="wm-info-kop2 wm-info-sec">Omschrijving</div><p class="wm-info-oms">' + esc(info.omschrijving) + '</p>' : '') +
          '</div>' +
        '</div>' +
      '</div>';
    werkAantallen();
  }
  function aantalBedieningVariant(v, naam) {
    return '<button type="button" class="wm-aantal-min" data-min="' + v.id + '" aria-label="Min">−</button>' +
      '<button type="button" class="wm-aantal-getal" data-typ="' + v.id + '" data-typ-naam="' + esc(naam) + '" data-vq="' + v.id + '">0</button>' +
      '<button type="button" class="wm-aantal-plus" data-plus="' + v.id + '" aria-label="Plus"' + (v.beschikbaar ? '' : ' disabled') + '>+</button>';
  }

  /* ==========================================================
     FASE 8 – winkelmandweergave binnen de module
     Toont de gewone Shopify-winkelwagen (/cart.js). Aanpassen per regel via
     /cart/change.js op regelsleutel. Het productoverzicht eronder blijft
     ongemoeid, zodat sluiten exact terugkeert naar dezelfde plek.
     ========================================================== */
  var mandOpen = false;
  var BEZORG_HANDLES = ['starttarief-bezorging', 'kilometertoeslag-bezorging', 'bezorgkosten'];

  function openMand() {
    sluitInfo();
    sluitInvoer();
    var el = $('wm-mandvenster');
    if (!el) {
      el = document.createElement('div');
      el.id = 'wm-mandvenster';
      el.className = 'wm-mandvenster';
      el.setAttribute('role', 'dialog');
      $('wm-werkvlak').appendChild(el);
    }
    mandOpen = true;
    tekenMand();
    el.hidden = false;
    werkNav();
    laadMand().catch(function () {});
  }
  function sluitMand() {
    var el = $('wm-mandvenster');
    if (el) { el.hidden = true; el.innerHTML = ''; }
    mandOpen = false;
    werkNav();
  }
  function regelAantal(it) {
    var k = 'k:' + it.key;
    if (wachtrij.hasOwnProperty(k)) return wachtrij[k];
    if (bezig.hasOwnProperty(k)) return bezig[k];
    return it.quantity;
  }
  function zetRegel(key, q) {
    q = Math.max(0, Math.min(999, parseInt(q, 10) || 0));
    var ri = (mand.items || []).filter(function (x) { return x.key === key; })[0];
    var fv = ri && famVan[ri.variant_id];
    if (fv && !magAantal(fv.f.basis.id, q)) { tekenMand(); return; }
    staffelBericht = '';
    wachtrij['k:' + key] = q;
    tekenMand();
    clearTimeout(mandTimer);
    mandTimer = setTimeout(verwerkWachtrij, 350);
  }
  function variantTekst(it) {
    var v = String(it.variant_title || '');
    if (!v || v === 'Default Title') return '';
    return v.split(' / ').filter(function (x) { return x !== 'Normaal' && x !== 'Default Title'; }).join(' · ');
  }
  function tekenMand() {
    var el = $('wm-mandvenster');
    if (!el || !mandOpen) return;
    var items = mand.items || [];
    var aantal = 0, totaal = 0;
    var rijen = items.map(function (it) {
      var q = regelAantal(it);
      aantal += q;
      var regelBedrag = (it.final_price || it.price) * q;
      totaal += regelBedrag;
      var props = it.properties || {};
      var zichtbaar = Object.keys(props).filter(function (k) { return k.charAt(0) !== '_' && props[k] !== null && props[k] !== ''; })
        .map(function (k) { return k + ': ' + props[k]; });
      var vt = variantTekst(it);
      var bezorg = BEZORG_HANDLES.indexOf(it.handle) > -1;
      var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      var bediening = bezorg
        ? '<span class="wm-mand-vast">wordt bepaald in de trechter</span>'
        : '<div class="wm-aantal">' +
            '<button type="button" class="wm-aantal-min" data-rmin="' + esc(it.key) + '"' + (q <= 0 ? ' disabled' : '') + ' aria-label="Min">−</button>' +
            '<button type="button" class="wm-aantal-getal' + (q > 0 ? ' heeft' : '') + '" data-rtyp="' + esc(it.key) + '" data-rnaam="' + esc(it.product_title + (vt ? ' – ' + vt : '')) + '">' + q + '</button>' +
            '<button type="button" class="wm-aantal-plus" data-rplus="' + esc(it.key) + '" aria-label="Plus">+</button>' +
          '</div>' +
          '<button type="button" class="wm-mand-weg" data-rweg="' + esc(it.key) + '" aria-label="Verwijderen">✕</button>';
      return '<div class="wm-mand-regel' + (q <= 0 ? ' wm-mand-regel--weg' : '') + '">' +
        '<span class="wm-mand-foto">' + (img ? '<img src="' + esc(img) + '" alt="">' : '') + '</span>' +
        '<span class="wm-mand-naam"><b>' + esc(it.product_title) + '</b>' +
          (vt ? '<span class="wm-mand-var">' + esc(vt) + '</span>' : '') +
          (zichtbaar.length ? '<span class="wm-mand-prop">' + esc(zichtbaar.join(' · ')) + '</span>' : '') +
          '<span class="wm-mand-stuk">' + esc(euroCent(it.final_price || it.price)) + ' per stuk</span></span>' +
        '<span class="wm-mand-bed">' + bediening + '</span>' +
        '<span class="wm-mand-bedrag">' + esc(euroCent(regelBedrag)) + '</span>' +
      '</div>';
    }).join('');
    el.innerHTML =
      '<div class="wm-mand-kop"><div><h2>Bestelling</h2><p>' + aantal + (aantal === 1 ? ' artikel' : ' artikelen') + '</p></div>' +
        '<button type="button" class="wm-reclame-sluit" data-mand-sluit>Verder bestellen ✕</button></div>' +
      '<div class="wm-mand-lijst" data-wm-scroll>' +
        (items.length ? rijen : '<div class="wm-mand-leeg">De bestelling is nog leeg.</div>') +
      '</div>' +
      staffelBlok() +
      '<div class="wm-mand-voet"><span class="wm-mand-totaal-l">Totaal</span><span class="wm-mand-totaal">' + esc(euroCent(totaal)) + '</span>' +
        (aantal > 0 && pkSleutel() ? '<button type="button" class="wm-mand-afronden wm-mand-later" data-pk="later" style="background:#fff;color:#3A524B;border:2px solid #3A524B;margin-right:10px">Later afronden</button>' : '') +   /* v15 */
        '<button type="button" class="wm-mand-afronden" data-afronden' + (aantal > 0 && !staffelBlokkeer ? '' : ' disabled') + '>Bestelling afronden ›</button></div>';
  }

  /* ---------- FASE 9: door naar de bestaande Jullens-trechter ----------
     Eerst wachten tot openstaande aantal-wijzigingen in de winkelwagen staan,
     dan dezelfde pagina openen als de webshop gebruikt. Afhalen/bezorgen,
     datum, tijdslot, adrescontrole, bezorgkosten en jullens_fulfilment
     komen volledig uit de trechter; BoomGate bewaakt de checkout. */
  var TRECHTER_URL = '/pages/bestelling-afronden';
  function naarTrechter() {
    var knop = document.querySelector('[data-afronden]');
    if (knop) { knop.disabled = true; knop.textContent = 'Bezig…'; }
    clearTimeout(mandTimer);
    if (Object.keys(wachtrij).length) verwerkWachtrij();
    mandKeten.then(laadMand).then(function (c) {
      if (staffelBlokkeer) {
        toast(staffelBericht || 'Bestelling niet eenduidig – controleer de aantallen');
        if (knop) { knop.disabled = false; knop.textContent = 'Bestelling afronden ›'; }
        return;
      }
      if (!c || !c.item_count) {
        toast('De bestelling is leeg');
        if (knop) { knop.disabled = false; knop.textContent = 'Bestelling afronden ›'; }
        return;
      }
      if (sessie && !bronGekozen) { if (knop) { knop.disabled = false; knop.textContent = 'Bestelling afronden ›'; } bronKeuze(naarTrechter); return; }   /* v17 */
      var kn = IS_PC && sessie ? kanaal() : null;   /* v15: telefoon of papier */
      var tel = true;   /* v16: interne route altijd eerst naar de tablettrechter (keuze Afhalen/Bezorgen gebeurt daar, één keer) */
      meld('jwm:naar-trechter', { artikelen: c.item_count, totaal: c.total_price, telefonisch: kn === 'telefoon', kanaal: kn });
      if (tel) {   /* v14–v16: via de tablettrechter (medewerker + eventueel nep doorgeven) */
        var nep = new URLSearchParams(location.search).get('nep') === '1';
        window.location.href = TABLETTRECHTER_URL + '?mw=' + encodeURIComponent(sessie.naam) + (nep ? '&nep=1' : '');
        return;
      }
      window.location.href = TRECHTER_URL;
    }, function () {
      toast('Winkelwagen kon niet worden gecontroleerd – probeer opnieuw');
      if (knop) { knop.disabled = false; knop.textContent = 'Bestelling afronden ›'; }
    });
  }

  function kiesItem(i) {
    var n = stapel[stapel.length - 1];
    if (!n || !n.items[i]) return;
    var it = n.items[i];
    if (it.soort === 'sub') {
      openNiveau(it.naam, function () { return laadCollectie(it.handle); });
      return;
    }
    openInfo(i);
  }

  tekenHoofdblokken();
  laadHoofdblokken();
  setInterval(laadHoofdblokken, HOOFD_VERVERS_MS);

  /* ==========================================================
     v14: TOETSENBORD (pc) – code en aantal-invoer
     Cijfers = cijfertoets, Backspace = laatste weg, Delete = wissen,
     Enter = OK, Escape = annuleren. Zelfde functies als de knoppen.
     ========================================================== */
  document.addEventListener('keydown', function (e) {
    if (e.ctrlKey || e.altKey || e.metaKey) return;
    var k = e.key, cijfer = /^[0-9]$/.test(k);
    var pinVenster = $('wm-pin');
    if (pin.m && pinVenster && !pinVenster.hidden) {
      if (cijfer) toets(k);
      else if (k === 'Backspace') toets('terug');
      else if (k === 'Delete') toets('wis');
      else if (k === 'Enter') { if (pin.modus !== 'login') toets('ok'); }
      else if (k === 'Escape') toets('annuleer');
      else if (k === 'Tab') { /* v21: Tab blijft in het codevenster */ }
      else return;
      e.preventDefault();
      return;
    }
    var iv = $('wm-invoer');
    if (invoer.vid && iv && !iv.hidden) {
      if (cijfer) invoerToets(k);
      else if (k === 'Backspace') invoerToets('terug');
      else if (k === 'Delete') invoerToets('wis');
      else if (k === 'Enter' || k === 'Tab') invoerToets('ok');   /* v21: Tab = aantal verwerken, zoals Enter */
      else if (k === 'Escape') invoerToets('annuleer');
      else return;
      e.preventDefault();
    }
  });

  /* ==========================================================
     KLIKKEN
     ========================================================== */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var t = e.target.closest('[data-toets]');
    if (t && !t.disabled) { toets(t.getAttribute('data-toets')); return; }

    var rc = e.target.closest('[data-recent]');   /* v17 */
    if (rc) { recentTik(rc.getAttribute('data-recent')); return; }

    var mw = e.target.closest('[data-mw]');
    if (mw && !sessie) { var m = vind(mw.getAttribute('data-mw')); if (m) openPin(m); return; }

    var cat = e.target.closest('[data-cat]');
    if (cat && sessie) { kiesCategorie(parseInt(cat.getAttribute('data-cat'), 10)); return; }
    if (e.target.closest('[data-hoofd-opnieuw]')) { hoofd.status = 'laden'; tekenHoofdblokken(); laadHoofdblokken(); return; }
    if (sessie) {
      if (e.target.closest('[data-mand-sluit]')) { sluitMand(); return; }
      var afr = e.target.closest('[data-afronden]');
      if (afr) { if (!afr.disabled) naarTrechter(); return; }
      var rmin = e.target.closest('[data-rmin]');
      if (rmin) { if (!rmin.disabled) { var ki = rmin.getAttribute('data-rmin'); var ri = (mand.items || []).filter(function (x) { return x.key === ki; })[0]; if (ri) { var fvm = famVan[ri.variant_id]; zetRegel(ki, fvm ? stapAantal(fvm.f.basis.id, regelAantal(ri), -1) : regelAantal(ri) - 1); } } return; }
      var rplus = e.target.closest('[data-rplus]');
      if (rplus) { var kp = rplus.getAttribute('data-rplus'); var rp = (mand.items || []).filter(function (x) { return x.key === kp; })[0]; if (rp) { var fvp = famVan[rp.variant_id]; zetRegel(kp, fvp ? stapAantal(fvp.f.basis.id, regelAantal(rp), 1) : regelAantal(rp) + 1); } return; }
      var stk = e.target.closest('[data-staffel]');
      if (stk) {
        var sa = stk.getAttribute('data-staffel');
        if (sa === 'vraag') { if (sessie.staffel) { staffelVraag = true; tekenMand(); } }
        else if (sa === 'annuleer') { staffelVraag = false; tekenMand(); }
        else if (sa === 'aan') zetStaffel(true);
        else if (sa === 'uit') zetStaffel(false);
        return;
      }
      var rweg = e.target.closest('[data-rweg]');
      if (rweg) { zetRegel(rweg.getAttribute('data-rweg'), 0); return; }
      var rtyp = e.target.closest('[data-rtyp]');
      if (rtyp) { openInvoer('k:' + rtyp.getAttribute('data-rtyp'), rtyp.getAttribute('data-rnaam')); return; }
      var inv = e.target.closest('[data-inv]');
      if (inv) { invoerToets(inv.getAttribute('data-inv')); return; }
      var snel = e.target.closest('[data-inv-snel]');
      if (snel) { invoer.tekst = snel.getAttribute('data-inv-snel'); invoerToets('ok'); return; }
      var mn = e.target.closest('[data-min]');
      if (mn) { if (!mn.disabled) { var vm = mn.getAttribute('data-min'); zetAantal(vm, stapAantal(vm, aantalVan(vm), -1)); } return; }
      var pl = e.target.closest('[data-plus]');
      if (pl) { if (!pl.disabled) { var vp = pl.getAttribute('data-plus'); zetAantal(vp, stapAantal(vp, aantalVan(vp), 1)); } return; }
      var ty = e.target.closest('[data-typ]');
      if (ty) {
        var nm = ty.getAttribute('data-typ-naam');
        if (!nm) { var nn = stapel[stapel.length - 1]; var ii = nn && nn.items[parseInt(ty.getAttribute('data-typ-item'), 10)]; nm = ii ? ii.naam : ''; }
        openInvoer(ty.getAttribute('data-typ'), nm);
        return;
      }
      var pers = e.target.closest('[data-pers-item]');   /* v24 route (a) */
      if (pers) { var np = stapel[stapel.length - 1]; var ip = np && np.items[parseInt(pers.getAttribute('data-pers-item'), 10)]; if (ip && sessie) persStart(ip); return; }
      var inf = e.target.closest('[data-info]');
      if (inf) { openInfo(parseInt(inf.getAttribute('data-info'), 10)); return; }
      if (e.target.closest('[data-info-sluit]')) { sluitInfo(); return; }
    }
    var item = e.target.closest('[data-item]');
    if (item && sessie) { kiesItem(parseInt(item.getAttribute('data-item'), 10)); return; }
    if (e.target.closest('[data-niveau-opnieuw]')) {
      var top = stapel[stapel.length - 1];
      if (top) { toonNiveau(); laadInNiveau(top); }
      return;
    }

    var wk = e.target.closest('[data-week]');
    if (wk) { openReclame(parseInt(wk.getAttribute('data-week'), 10)); return; }
    if (e.target.closest('[data-reclame-sluit]')) { sluitReclame(); return; }

    var w = e.target.closest('[data-wis]');
    if (w) { wisCode(w.getAttribute('data-wis')); return; }
    if (e.target.closest('[data-beheer-sluit]')) { sluitBeheer(); return; }

    var knop = e.target.closest('[data-wm-actie]');
    if (!knop || knop.disabled) return;
    var actie = knop.getAttribute('data-wm-actie');
    if (zkOpenIs() && actie !== 'volledig-scherm') { zkSluit(); if (actie === 'zoeken' || actie === 'terug') return; }   /* v32.4: zoekvenster eerst dicht */
    if (actie === 'volledig-scherm') wisselVolledig();
    else if (actie === 'wissel-medewerker') wisselVeilig();   /* v32: lopende bestelling eerst bewaren */
    else if (actie === 'telefonisch') {   /* v14 */
      var nu = !telefonischAan();
      if (!nu) ovVrijgeven('handmatig_uit');   /* v29 */
      zetTelefonisch(nu); bronGekozen = true;   /* v17 */
      toast(nu ? 'Telefonische bestelling AAN – afronden gaat via de tablettrechter, zonder SMS' : 'Telefonische bestelling UIT', 3500);
    }
    else if (actie === 'papier') {   /* v15 */
      var pa = kanaal() !== 'papier';
      if (pa) ovVrijgeven('papier');   /* v29 */
      zetKanaal(pa ? 'papier' : null); bronGekozen = true;   /* v17 */
      toast(pa ? 'Papierbestelling AAN – later ingevoerd, afronden via de tablettrechter, zonder SMS' : 'Papierbestelling UIT', 3500);
    }
    else if (actie === 'openstaand') pkOverzicht(false);   /* v15 */
    else if (actie === 'medewerker') openBeheer();
    else if (actie === 'terug') { if (mandOpen) sluitMand(); else terug(); }
    else if (actie === 'onze-producten') { sluitMand(); naarHoofd(); }
    else if (actie === 'bestelling') { if (mandOpen) sluitMand(); else openMand(); }
    else if (actie === 'zoeken') zkOpen();   /* v32.4 */
  });

  /* ---------- Meting (proefraster, tijdelijk tot fase 5) ---------- */
  var meting = $('wm-meting');
  var raster = $('wm-raster');
  function meet() {
    if (!meting || $('wm-inhoud').hidden) return;
    var tegelEl = raster ? raster.firstElementChild : null;
    var r = tegelEl ? tegelEl.getBoundingClientRect() : null;
    var scroll = (document.scrollingElement.scrollHeight > window.innerHeight + 1) ? 'JA' : 'nee';
    meting.textContent = 'Proefraster · viewport ' + window.innerWidth + '×' + window.innerHeight +
      ' · tegel ' + (r ? Math.round(r.width) + '×' + Math.round(r.height) : '-') +
      ' · dpr ' + (window.devicePixelRatio || 1) +
      ' · volledig scherm ' + (isVolledig() ? 'ja' : 'nee') + ' · pagina-scroll ' + scroll;
  }
  window.addEventListener('resize', meet);
  document.addEventListener('fullscreenchange', function () { meet(); maatStart(); });
  document.addEventListener('webkitfullscreenchange', function () { meet(); maatStart(); });

  /* ==========================================================
     v15: OPENSTAANDE (GEPARKEERDE) BESTELLINGEN + bron Telefonisch/Papier
     Architectuur Openstaande Bestellingen v4, backend v1.5.1 (api.jullens.com/tablet/v1/geparkeerd/*).
     - "Wie helpt er?": groot het aantal niet-afgeronde bestellingen + per medewerker een teller (geen klantnamen).
     - Na aanmelden: staat er nog iets in de winkelwagen -> Afmaken | Later afronden | Verwijderen;
       anders de eigen openstaande bestellingen (en die van collega's) met Verdergaan.
     - Later afronden: winkelwagen + gegevens centraal bewaren, winkelwagen leeg, werkplek vrij.
     - Verdergaan: vergrendelen, winkelwagen terugzetten en controleren, prijswijziging melden, verder vanaf de laatste stap.
     - Shopify blijft de prijsbron; de referentieprijs dient alleen om een wijziging te melden.
     De apparaatsleutel is dezelfde als die van de tablettrechter (zelfde website, zelfde browser).
     ========================================================== */
  var PK_API = 'https://api.jullens.com/tablet/v1';
  var LS_SLEUTEL = 'jullens_tablet_apparaatsleutel';
  var SS_KANAAL = 'jullens_kanaal';            /* 'telefoon' | 'papier' – alleen pc, alleen dit tabblad */
  var SS_ACTIEF = 'jullens_actief_parkeer';    /* id van de hervatte bestelling waaraan in dit tabblad gewerkt wordt */
  var SS_HERVAT = 'jullens_hervat';            /* overdracht naar de tablettrechter (stap + gegevens) */
  var PK_STAPPEN = { mand: 'Winkelwagen', A1: 'Klant', A2a: 'Klant', A2b: 'Klant', A2d: 'Bezorgadres en ontvanger', A3: 'Datum en tijd',
    A3b: 'Datum (brood)', A3c: 'Datum (brood)', A3d: 'Datum (brood)', A3e: 'Datum (brood)', A4: 'Tijd (spoed)', A5: 'Kaartje en opmerking',
    A6: 'Opmerking', A8: 'Betaling', A7: 'E-mail', A9: 'Betalen en afronden', v88: 'Bezorgroute (onderbroken)' };   /* v18: schermnamen tablettrechter Versie 15 */
  var pkInfo = { totaal: 0, per: {}, geladen: false };
  var pkHartslag = null;

  function pkSleutel() { try { return localStorage.getItem(LS_SLEUTEL) || ''; } catch (e) { return ''; } }
  function pkVraag(methode, pad, body, mw) {
    var s = pkSleutel();
    if (!s) return Promise.reject(new Error('geen_apparaatsleutel'));
    var h = { Authorization: 'Bearer ' + s };
    if (body) h['Content-Type'] = 'application/json';
    var naam = mw || (sessie && sessie.naam);
    if (naam) h['X-Jullens-Medewerker'] = naam;
    var tok = bvToken(); if (tok) h['X-Jullens-Sessie'] = tok;   /* v32: registratie begonnen/overgenomen uit de gecontroleerde sessie (backend v1.18.0) */
    /* v32.1 (backend v1.18.1): claimbewijs van dit tabblad (gedeeld met de tablettrechter). Bewaren/verlengen/vrijgeven/afronden sturen het
       mee; claimen alleen bij een stilzwijgende voortzetting (doorgaan: true, bijv. Ja na vergrendeling) – een bewuste overname via
       Openstaand/Overnemen niet. De server weigert dan zelf een verouderde bewerking (409 verouderd / tussentijds_geopend). */
    var ct = null; try { ct = JSON.parse(sessionStorage.getItem('jullens_claim_v1') || 'null'); } catch (e) { ct = null; }
    if (body && body.doorgaan !== undefined) { var door = body.doorgaan === true; body = Object.assign({}, body); delete body.doorgaan; if (door && ct && ct.id === body.id) body.vorigeClaim = ct.token; }
    else if (body && ct && ct.id === body.id && /\/geparkeerd\/(parkeer|verleng|vrijgeven|prijs-gezien|afronden)$/.test(pad)) body = Object.assign({}, body, { claimToken: ct.token });
    return fetch(PK_API + pad, { method: methode, headers: h, body: body ? JSON.stringify(body) : undefined })
      .then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) {
          if (!r.ok) { var code = (j && j.fout) || ('http_' + r.status);
            var f = new Error(code === 'verouderd' || code === 'tussentijds_geopend' ? 'in_behandeling_elders' : code); f.status = r.status; f.origineel = code; f.details = j && j.details; throw f; }
          if (j && typeof j.claimToken === 'string' && /^ct_[0-9a-f]{32}$/.test(j.claimToken)) { var pid = j.id || (body && body.id); if (/^pk_[0-9a-f]{16}$/.test(pid || '')) try { sessionStorage.setItem('jullens_claim_v1', JSON.stringify({ id: pid, token: j.claimToken })); } catch (e) {} }
          return j;
        });
      });
  }
  function ssLees(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssZet(k, v) { try { if (v === null || v === undefined) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function actiefId() { var v = ssLees(SS_ACTIEF); return /^pk_[0-9a-f]{16}$/.test(v || '') ? v : null; }
  /* v32.3 (werkdag-simulatie 18-10): de winkelwagen is leeg (artikelen los weggehaald i.p.v. "Winkelwagen leegmaken") maar het tabblad wijst nog
     naar een hervatte bewaarde bestelling. Zonder dit zou de VOLGENDE bestelling (andere klant, andere medewerker) in de tablettrechter als die
     bewaarde bestelling worden geplaatst en zou de bewaarde bestelling als afgerond verdwijnen. Nu: claim op de server vrijgeven (de bewaarde
     bestelling blijft bij Openstaande bestellingen staan voor een collega) en de verwijzing + het claimbewijs in dit tabblad wissen. */
  function actiefLoslaten(reden) {
    var id = actiefId(); if (!id) return;
    try { pkVraag('POST', '/geparkeerd/vrijgeven', { id: id, reden: reden }).catch(function () {}); } catch (e) {}   /* claimbewijs gaat mee (synchroon gelezen) */
    ssZet(SS_ACTIEF, null);
    try { var ct = JSON.parse(sessionStorage.getItem('jullens_claim_v1') || 'null'); if (ct && ct.id === id) sessionStorage.removeItem('jullens_claim_v1'); } catch (e) {}
    lopendZet(null);
  }

  /* ---------- bron: Telefonisch / Papier (alleen pc) ---------- */
  function kanaal() {
    var k = ssLees(SS_KANAAL);
    if (k === 'telefoon' || k === 'papier') return k;
    return ssLees(SS_TELEFONISCH) === '1' ? 'telefoon' : null;
  }
  function zetKanaal(k) {
    if (k !== 'telefoon' && ovLees()) ovVrijgeven('kanaal_' + (k || 'uit'));   /* v32.2: een gekoppelde oproep loopt nooit door naar een volgende bestelling (bijv. na Winkelwagen leegmaken) */
    ssZet(SS_KANAAL, k || null);
    ssZet(SS_TELEFONISCH, k === 'telefoon' ? '1' : null);   /* blijft werken met tablettrechter Versie 7 */
    werkTelefonisch();
  }
  function papierKnop() {
    var k = $('wm-papier');
    if (k || !IS_PC) return k;
    var tel = telefoonKnop();
    if (!tel || !tel.parentNode) return null;
    k = document.createElement('button');
    k.type = 'button';
    k.id = 'wm-papier';
    k.className = tel.className.replace(' wm-tel-aan', '');
    k.setAttribute('data-wm-actie', 'papier');
    k.innerHTML = '<span class="wm-tel-ico" aria-hidden="true">&#128221;</span><span>Papier</span>';
    tel.parentNode.insertBefore(k, tel.nextSibling);
    return k;
  }
  function openKnop() {
    var k = $('wm-openstaand');
    if (k) return k;
    var wissel = $('wm-wissel');
    if (!wissel || !wissel.parentNode) return null;
    pkStijl();
    k = document.createElement('button');
    k.type = 'button';
    k.id = 'wm-openstaand';
    k.className = wissel.className + ' wm-telknop';
    k.setAttribute('data-wm-actie', 'openstaand');
    k.innerHTML = '<span class="wm-tel-ico" aria-hidden="true">&#128203;</span><span>Openstaand</span>';
    var tel = $('wm-telefonisch');
    wissel.parentNode.insertBefore(k, tel || wissel);
    return k;
  }

  /* ---------- opmaak ---------- */
  function pkStijl() {
    if ($('wm-pk-stijl')) return;
    var st = document.createElement('style');
    st.id = 'wm-pk-stijl';
    st.textContent =
      '.wm-pk-band{display:inline-block;margin-left:16px;background:#B3261E;color:#fff;font-weight:800;font-size:18px;padding:6px 14px;border-radius:10px;letter-spacing:.3px}' +
      '.wm-pk-badge{position:absolute;top:8px;right:8px;background:#B3261E;color:#fff;font-weight:700;font-size:13px;padding:3px 8px;border-radius:10px}' +
      '.wm-mw{position:relative}' +
      '#wm-pk{position:fixed;inset:0;z-index:950;background:rgba(20,30,27,.55);display:flex;align-items:center;justify-content:center}' +
      '#wm-pk[hidden]{display:none}' +
      '#wm-pk .pk-doos{background:#fff;border-radius:14px;max-width:760px;width:calc(100% - 40px);max-height:calc(100% - 40px);overflow:auto;padding:22px 24px;box-shadow:0 10px 40px rgba(0,0,0,.3);color:#1E2A27}' +
      '#wm-pk h2{margin:0 0 6px;font-size:24px}#wm-pk p{margin:4px 0 12px;color:#4F6B65}' +
      '#wm-pk .pk-rij{display:flex;align-items:center;gap:12px;border:1px solid #DCE3E0;border-radius:10px;padding:10px 12px;margin:8px 0}' +
      '#wm-pk .pk-rij b{font-size:18px}#wm-pk .pk-rij .pk-sub{color:#4F6B65;font-size:14px}#wm-pk .pk-rij .pk-tekst{flex:1}' +
      '#wm-pk .pk-let{color:#9A5B00;font-weight:700}' +
      '#wm-pk button{font:inherit;font-weight:700;border-radius:10px;border:2px solid #3A524B;background:#fff;color:#3A524B;padding:10px 16px;cursor:pointer;min-height:48px}' +
      '#wm-pk button.pk-hoofd{background:#3A524B;color:#fff}#wm-pk button.pk-rood{border-color:#B3261E;color:#B3261E}' +
      '#wm-pk button[disabled]{opacity:.45;cursor:default}' +
      '#wm-pk .pk-knoppen{display:flex;gap:10px;flex-wrap:wrap;margin-top:14px}' +
      '#wm-pk input{font:inherit;font-size:20px;width:100%;box-sizing:border-box;padding:10px 12px;border:2px solid #3A524B;border-radius:10px}' +
      '#wm-pk .pk-prijs{background:#FFF4E5;border:2px solid #E08A00;border-radius:10px;padding:12px 14px;margin:8px 0}' +
      '#wm-pk .pk-prijs h3{margin:0 0 8px;color:#B3261E;font-size:18px}' +
      '#wm-pk .pk-bronnen{display:grid;grid-template-columns:repeat(3,1fr);gap:12px;margin-top:8px}' +
      '#wm-pk button.pk-bron{display:flex;flex-direction:column;align-items:center;gap:6px;min-height:150px;padding:14px 10px}' +
      '#wm-pk .pk-bron-ico{font-size:40px;line-height:1}#wm-pk .pk-bron-titel{font-size:22px;font-weight:800}#wm-pk .pk-bron-uitleg{font-size:14px;font-weight:600;opacity:.85}' +
      '#wm-recent{position:fixed;top:12px;right:16px;max-width:64vw;z-index:800;display:flex;gap:8px;align-items:center;overflow-x:auto;white-space:nowrap;padding:2px}' +
      '#wm-recent[hidden]{display:none}#wm-recent .wm-recent-kop{font-weight:800;color:#3A524B;font-size:14px;margin-right:2px}' +
      '#wm-recent .wm-recent-blok{font:inherit;font-size:14px;display:inline-flex;gap:6px;align-items:center;background:#fff;border:2px solid #DCE3E0;border-radius:10px;padding:5px 9px;color:#1E2A27;cursor:pointer}' +
      '#wm-recent .wm-recent-wacht{border-color:#FFD700;box-shadow:0 0 0 3px #FFF6BF}' +
      '.wm-recent-status{color:#fff;font-weight:800;border-radius:6px;padding:2px 7px;font-size:13px}.wm-recent-ok{background:#2E7D32}.wm-recent-niet{background:#B3261E}' +
      '#wm-pk .wm-recent-groot{display:flex;justify-content:space-between;align-items:center;font-size:24px;font-weight:800;margin:10px 0}#wm-pk .wm-recent-groot .wm-recent-status{font-size:18px;padding:4px 12px}';
    document.head.appendChild(st);
  }
  function pkVenster(html) {
    pkStijl();
    var el = $('wm-pk');
    if (!el) { el = document.createElement('div'); el.id = 'wm-pk'; el.setAttribute('role', 'dialog'); document.body.appendChild(el); }
    el.innerHTML = '<div class="pk-doos">' + html + '</div>';
    el.hidden = false;
    var inv = el.querySelector('input');
    if (inv) { try { inv.focus(); } catch (e) {} }
  }
  function pkSluit() { var el = $('wm-pk'); if (el) { el.hidden = true; el.innerHTML = ''; } }
  function pkTijd(iso) {
    var d = new Date(iso), n = new Date();
    var t = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    return d.toDateString() === n.toDateString() ? t : d.getDate() + ' ' + MAANDEN[d.getMonth()] + ' ' + t;
  }
  function bronTekst(b) { return b === 'telefoon' ? '&#128222; telefonisch' : b === 'papier' ? '&#128221; papier' : 'winkel'; }

  /* ---------- "Wie helpt er?": aantallen (geen klantnamen) ---------- */
  function pkStartInfo() {
    if (!pkSleutel()) return;
    pkVraag('GET', '/geparkeerd/aantal', null, '').then(function (a) {
      pkInfo = { totaal: a.totaal || 0, per: a.perMedewerker || {}, geladen: true };
      pkTekenStart();
    }, function () { pkInfo.geladen = false; pkTekenStart(); });
  }
  function pkAantalVoor(naam) {
    var n = 0;
    Object.keys(pkInfo.per).forEach(function (k) { if (k.toLowerCase() === String(naam).toLowerCase()) n += pkInfo.per[k]; });
    return n;
  }
  function pkTekenStart() {
    var start = $('wm-start');
    if (!start || start.hidden) return;
    pkStijl();
    var kop = start.querySelector('.wm-start-kop h1');
    var band = start.querySelector('.wm-pk-band');
    if (pkInfo.geladen && pkInfo.totaal > 0) {
      if (!band && kop) { band = document.createElement('span'); band.className = 'wm-pk-band'; kop.appendChild(band); }
      if (band) band.textContent = pkInfo.totaal + (pkInfo.totaal === 1 ? ' NIET-AFGERONDE BESTELLING' : ' NIET-AFGERONDE BESTELLINGEN');
    } else if (band) band.parentNode.removeChild(band);
    Array.prototype.forEach.call(start.querySelectorAll('[data-mw]'), function (t) {
      var m = vind(t.getAttribute('data-mw')), n = m ? pkAantalVoor(m.naam) : 0;
      var b = t.querySelector('.wm-pk-badge');
      if (n > 0) { if (!b) { b = document.createElement('span'); b.className = 'wm-pk-badge'; t.appendChild(b); } b.textContent = n + ' open'; }
      else if (b) b.parentNode.removeChild(b);
    });
  }
  setInterval(function () { if ($('wm-start') && !$('wm-start').hidden) { pkStartInfo(); recentLaad(); } }, 60000);   /* v17: ook de balk */

  /* ---------- na aanmelden ---------- */
  function pkNaLogin() {
    werkTelefonisch();
    pkHartslagStart();
    if (!pkSleutel()) { bronKeuze(); return; }   /* v17 */
    mandKeten = mandKeten.then(function () { return afgerondSignaal() ? wmNaAfronden() : null; }).catch(function () {});   /* v20: eerst een afgeronde mand */
    mandKeten.then(laadMand).then(function (c) {
      if (c && c.item_count > 0) { if (afgerondSignaal()) pkAfgerondNietLeeg(); else lopendControle(c); }   /* v32 */
      else { lopendZet(null); actiefLoslaten('aanmelden_lege_winkelwagen'); pkOverzicht(true); }   /* v32.3 */
    }, function () { bronKeuze(); });
  }

  /* ---------- v17: bronkeuze TELEFONISCH – WINKEL – PAPIER (Definitief ontwerp interne bezorgroute §2) ----------
     Altijd zichtbaar bij een nieuwe bestelling na aanmelden; nooit automatisch overgeslagen. Op de tablet staan
     TELEFONISCH en PAPIER grijs (de server staat ze alleen op een pc toe). Bij hervatten geldt de opgeslagen bron. */
  var bronNa = null;
  function bronKeuze(daarna) {
    bronNa = typeof daarna === 'function' ? daarna : null;
    /* v18 (Aanvulling 2, besluit 3): op de tablet is de bron altijd WINKEL – geen keuzescherm, geen extra tik.
       Op de pc blijft de keuze TELEFONISCH / WINKEL / PAPIER. */
    if (!IS_PC) { bronGekozenDoor('winkel', true); return; }
    var knop = function (b, ico, titel, uitleg) {
      var uit = (b === 'telefoon' || b === 'papier') && !IS_PC;
      return '<button type="button" class="pk-bron' + (b === 'winkel' ? ' pk-hoofd' : '') + '" data-pk="bron" data-bron="' + b + '"' + (uit ? ' disabled' : '') + '>' +
        '<span class="pk-bron-ico" aria-hidden="true">' + ico + '</span><span class="pk-bron-titel">' + titel + '</span>' +
        '<span class="pk-bron-uitleg">' + (uit ? 'alleen op de pc' : uitleg) + '</span></button>';
    };
    pkVenster('<h2>Wat voor bestelling?</h2><p>Kies de bron van deze bestelling.</p>' +
      '<div class="pk-bronnen">' + knop('telefoon', '&#128222;', 'TELEFONISCH', 'wordt nu telefonisch aangenomen') +
      knop('winkel', '&#127978;', 'WINKEL', 'klant staat nu aan de balie') +
      knop('papier', '&#128221;', 'PAPIER', 'eerder of elders genoteerd, nu ingevoerd') + '</div>');
  }
  function bronGekozenDoor(b, stil) {
    if ((b === 'telefoon' || b === 'papier') && !IS_PC) return;
    zetKanaal(b === 'telefoon' || b === 'papier' ? b : null);
    bronGekozen = true;
    if (!stil) { pkSluit(); toast(b === 'telefoon' ? 'Telefonische bestelling' : b === 'papier' ? 'Papierbestelling' : 'Winkelbestelling', 2000); }   /* v18: tablet stil */
    var f = bronNa; bronNa = null; if (f) f();
  }

  /* ---------- v17: balk "Laatst afgerond" (Aanvulling 1, hoofdstuk 2; backend v1.6.1 /recent/*) ----------
     Laatste 5 afgeronde bestellingen van vandaag: tijd · ordernummer · achternaam · bedrag · betaalstatus.
     Ook vóór aanmelden zichtbaar (alleen achternaam, besluit Vincent). Aantikken = na aanmelden de bestelling bekijken. */
  var recentLijst = [];
  function isNep() { return new URLSearchParams(location.search).get('nep') === '1'; }
  function recentLaad() {
    if (!pkSleutel()) return;
    pkVraag('POST', '/recent/lijst', { nep: isNep() }, '').then(function (r) { recentLijst = r.bestellingen || []; recentTeken(); },
      function () { recentLijst = []; recentTeken(); });
  }
  function recentTeken() {
    var start = $('wm-start'), el = $('wm-recent');
    if (!start || start.hidden || !recentLijst.length) { if (el) el.hidden = true; return; }
    pkStijl();
    if (!el) { el = document.createElement('div'); el.id = 'wm-recent'; el.setAttribute('aria-label', 'Laatst afgerond'); document.body.appendChild(el); }
    el.innerHTML = '<span class="wm-recent-kop">Laatst afgerond</span>' + recentLijst.map(function (b) {
      var betaald = b.betaalstatus === 'betaald';
      return '<button type="button" class="wm-recent-blok' + (recentWacht === b.id ? ' wm-recent-wacht' : '') + '" data-recent="' + esc(b.id) + '">' +
        '<span>' + esc(pkTijd(b.tijd)) + '</span><b>' + esc(b.ordernummer) + '</b><span>' + esc(b.achternaam) + '</span>' +
        (b.route === 'bezorgen' ? '<span title="Bezorgen">&#128666;</span>' : '') + '<b>' + esc(euroCent(b.bedragCent)) + '</b>' +
        '<span class="wm-recent-status ' + (betaald ? 'wm-recent-ok' : 'wm-recent-niet') + '">' + betaalLabel(b, false) + '</span></button>';
    }).join('');
    el.hidden = false;
  }
  /* v22: een betaalafspraak is geen betaling – "PIN OP LOCATIE" / "BIJ AFHALEN" blijven rood (nog niet betaald). */
  function betaalLabel(b, lang) {
    if (b.betaalstatus === 'betaald') return 'BETAALD' + (lang ? (b.methode === 'pin' ? ' · PIN' : b.methode === 'contant' ? ' · CONTANT' : '') : '');
    if (b.afspraak === 'pin_op_locatie') return lang ? 'NOG NIET BETAALD · PIN OP LOCATIE' : 'PIN OP LOCATIE';
    if (b.afspraak === 'bij_afhalen') return lang ? 'NIET BETAALD · BIJ AFHALEN' : 'NIET BETAALD';
    if (b.afspraak === 'op_rekening') return lang ? 'NOG NIET BETAALD · OP REKENING' : 'OP REKENING';   /* v23 */
    return 'NIET BETAALD';
  }
  function recentTik(id) {
    if (sessie) { recentDetail(id); return; }
    recentWacht = id; recentTeken();
    toast('Tik op je naam – daarna opent de bestelling', 3500);
  }
  function recentDetail(id, daarna) {
    recentNa = typeof daarna === 'function' ? daarna : null;
    pkVraag('POST', '/recent/detail', { id: id }).then(function (d) {
      var betaald = d.betaalstatus === 'betaald';
      pkVenster('<h2>Bestelling ' + esc(d.ordernummer) + ' – ' + esc(d.achternaam) + '</h2>' +
        '<p>' + (d.route === 'bezorgen' ? '&#128666; Bezorgen' : 'Afhalen') + ' · ' + esc(d.leverdatum || '') + (d.tijdslot ? ' · ' + esc(d.tijdslot) : '') +
        ' · afgerond door ' + esc(d.medewerker || '') + ' om ' + esc(pkTijd(d.tijd)) + '</p>' +
        '<div class="pk-rij" style="display:block">' + (d.regels || []).map(function (r) { return '<div>' + r.aantal + '&times; ' + esc(r.titel) + '</div>'; }).join('') + '</div>' +
        '<div class="wm-recent-groot"><span>Totaal ' + esc(euroCent(d.bedragCent)) + '</span><span class="wm-recent-status ' + (betaald ? 'wm-recent-ok' : 'wm-recent-niet') + '">' +
        betaalLabel(d, true) + '</span></div>' +
        '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="recentsluit">Sluiten</button>' +
        '<button disabled title="Komt bij A11: nabestelling als aparte, gekoppelde bestelling">Iets toevoegen (volgt bij A11)</button></div>');
    }, function (e) {
      toast(e.message === 'onbekend_of_verlopen' ? 'Deze bestelling staat niet meer in de lijst' : 'Bestelling niet bereikbaar: ' + pkFoutTekst(e), 3500);
      var f = recentNa; recentNa = null; if (f) f();
    });
  }
  var recentNa = null;
  function recentSluit() { pkSluit(); var f = recentNa; recentNa = null; if (f) f(); }
  function pkWinkelwagenVraag(c) {
    var id = actiefId();
    pkVenster('<h2>Er staat nog een bestelling in de winkelwagen</h2>' +
      '<p>' + c.item_count + (c.item_count === 1 ? ' artikel' : ' artikelen') + ' · ' + esc(euroCent(c.total_price)) +
      (id ? ' · hervatte bestelling' : '') + '. Wat wil je ermee doen?</p>' +
      '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="afmaken">Afmaken</button>' +
      '<button data-pk="later">Later afronden</button>' +
      '<button class="pk-rood" data-pk="wagenweg">Verwijderen</button></div>');
  }
  function pkOverzicht(alleenEigen) {
    if (!sessie || !pkSleutel()) return;
    pkVraag('POST', '/geparkeerd/lijst', {}).then(function (r) {
      var alle = r.bestellingen || [];
      var eigen = alle.filter(function (b) { return String(b.geparkeerd.medewerker || '').toLowerCase() === sessie.naam.toLowerCase(); });
      var lijst = alleenEigen ? eigen : alle;
      var onderbr = alleenEigen && !pkOnderbrokenGezien ? alle.filter(function (b) { return b.onderbroken && b.vanDitApparaat && !b.inBehandeling; }) : [];
      if (onderbr.length) { werkOpenKnop(alle.length); pkOnderbrokenVenster(onderbr); return; }   /* v32: eerst bewust kiezen, daarna pas de bronknoppen */
      if (alleenEigen && !eigen.length) { werkOpenKnop(alle.length); if (!bronGekozen) bronKeuze(); return; }   /* v17 */
      werkOpenKnop(alle.length);
      pkVenster('<h2>' + (alleenEigen ? 'Jouw openstaande bestellingen' : 'Alle openstaande bestellingen') + '</h2>' +
        '<p>Kies een bestelling om verder te gaan, of begin een nieuwe.</p>' +
        (lijst.length ? lijst.map(pkRij).join('') : '<p>Er staan geen bestellingen open.</p>') +
        '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="nieuw">Nieuwe bestelling</button>' +
        (alleenEigen && alle.length > eigen.length ? '<button data-pk="alle">Alle openstaande bestellingen (' + alle.length + ')</button>' : '') + '</div>');
    }, function (e) { toast('Openstaande bestellingen niet bereikbaar: ' + pkFoutTekst(e), 3500); if (alleenEigen && !bronGekozen) bronKeuze(); });
  }
  function pkRij(b) {
    var bezet = b.inBehandeling && !(actiefId() === b.id);
    var omzetten = IS_PC && b.bron === 'winkel' && !b.smsGeverifieerd;
    return '<div class="pk-rij"><div class="pk-tekst"><b>' + esc(b.klantLabel || '(geen naam)') + '</b>' +
      '<div class="pk-sub">' + bronTekst(b.bron) + (b.bronOorspronkelijk !== b.bron ? ' (begonnen als ' + esc(b.bronOorspronkelijk) + ')' : '') +
      ' · ' + esc(b.geparkeerd.medewerker || '') + ' · ' + esc(pkTijd(b.geparkeerd.tijd)) +
      ' · laatste stap: ' + esc(PK_STAPPEN[b.laatsteStap] || b.laatsteStap) +
      (b.refTotaalCent != null ? ' · ' + esc(euroCent(b.refTotaalCent)) : '') + '</div>' +
      (b.onderbroken ? '<div class="pk-let">Niet afgerond: ' + esc(b.onderbroken.medewerker || '') + ' om ' + esc(pkTijd(b.onderbroken.tijd)) + ' (' +
        esc(b.onderbroken.reden === 'wissel' ? 'medewerkerwissel' : b.onderbroken.reden === 'vergrendeld' ? 'scherm vergrendeld' : 'andere medewerker') + ') – ' + esc(b.onderbroken.apparaatNaam || '') + '</div>' : '') +   /* v32 */
      (bezet ? '<div class="pk-let">In behandeling op ' + esc(b.inBehandeling.apparaatNaam) + ' (' + esc(b.inBehandeling.medewerker) + ')</div>' : '') +
      (b.verlooptBinnen24u ? '<div class="pk-let">Verloopt binnen 24 uur</div>' : '') +
      (b.staffelWas ? '<div class="pk-let">Staffelkorting stond aan – opnieuw toe te kennen door Vincent of Erica</div>' : '') + '</div>' +
      (omzetten ? '<button data-pk="papier" data-id="' + b.id + '"' + (bezet ? ' disabled' : '') + '>Omzetten naar Papier</button>' : '') +
      '<button class="pk-rood" data-pk="weg" data-id="' + b.id + '"' + (bezet ? ' disabled' : '') + '>Verwijderen</button>' +
      '<button class="pk-hoofd" data-pk="verder" data-id="' + b.id + '"' + (bezet ? ' disabled' : '') + '>Verdergaan</button></div>';
  }
  function werkOpenKnop(n) {
    var k = openKnop();
    if (!k) return;
    k.hidden = !sessie || !pkSleutel();
    k.disabled = !sessie;
    k.querySelector('span:last-child').textContent = n ? 'Openstaand (' + n + ')' : 'Openstaand';
  }

  /* ---------- Later afronden (vanuit de winkelwagen) ---------- */
  function pkVraagNaam() {
    pkVenster('<h2>Later afronden</h2><p>Naam van de klant, zodat de bestelling straks terug te vinden is.</p>' +
      '<input id="pk-naam" type="text" maxlength="60" autocomplete="off" placeholder="bijv. dhr. Pietersen">' +
      '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="parkeer">Bewaren en werkplek vrijgeven</button><button data-pk="sluit">Annuleren</button></div>');
  }
  function pkMandRegels(c) {
    return (c.items || []).map(function (it) {
      var props = {}, p = it.properties || {};
      Object.keys(p).forEach(function (k) { if (p[k] !== null && p[k] !== '') props[k] = String(p[k]); });
      var vt = variantTekst(it);
      return { variant_id: it.variant_id, aantal: it.quantity, handle: it.handle, titel: it.product_title + (vt ? ' – ' + vt : ''),
               eigenschappen: props, refStukprijsCent: it.final_price != null ? it.final_price : it.price,
               refRegelCent: it.final_line_price != null ? it.final_line_price : (it.final_price || it.price) * it.quantity };
    });
  }
  function pkParkeer(klantLabel) {
    var knop = document.querySelector('[data-pk="parkeer"]');
    if (knop) { knop.disabled = true; knop.textContent = 'Bezig…'; }
    clearTimeout(mandTimer);
    if (Object.keys(wachtrij).length) verwerkWachtrij();
    var id = actiefId();
    mandKeten.then(laadMand).then(function (c) {
      if (!c || !c.item_count) { pkSluit(); toast('De winkelwagen is leeg – niets te bewaren'); return; }
      var body = { bron: kanaal() || 'winkel', klantLabel: klantLabel, laatsteStap: 'mand', trechter: {},
        mand: { regels: pkMandRegels(c), staffel: staffelAan, staffelDoor: staffelAan && sessie ? sessie.id : null, refTotaalCent: c.total_price } };
      if (id) { body.id = id; delete body.bron; }
      var ovP = ovLees(); if (ovP) body.overnameId = ovP.id;   /* v29: bewaarde bestelling houdt haar oproep; de pc komt vrij (backend v1.12.1) */
      var opslaan = function () { return pkVraag('POST', '/geparkeerd/parkeer', body); };
      return opslaan().catch(function (e) {
        if (id && e.message === 'geen_claim') return pkVraag('POST', '/geparkeerd/claim', { id: id }).then(opslaan);
        throw e;
      }).then(function (r) {
        return post('/cart/clear.js', {}).then(function () { return r; });
      }).then(function (r) {
        ssZet(SS_ACTIEF, null); lopendZet(null);   /* v32 */
        ssZet(OV_SLEUTEL, null); ssZet(OV_LIJN, null);   /* v29: overname hoort nu bij de bewaarde bestelling (server) */
        pkSluit();
        toast('Bewaard: ' + (r.klantLabel || 'bestelling') + ' – werkplek is vrij', 3500);
        eindeSessie('geparkeerd');
      });
    }).catch(function (e) {
      if (knop) { knop.disabled = false; knop.textContent = 'Bewaren en werkplek vrijgeven'; }
      toast('Bewaren mislukt: ' + pkFoutTekst(e), 4500);
    });
  }
  function pkFoutTekst(e) {
    var m = e && e.message;
    return m === 'geen_apparaatsleutel' ? 'dit apparaat is niet gekoppeld' : m === 'alleen_pc' ? 'telefonisch/papier kan alleen op een pc'
      : m === 'in_behandeling_elders' ? 'in behandeling op ' + ((e.details && e.details.apparaatNaam) || 'een ander apparaat')
      : m === 'opslag_bezet' ? 'server even bezet, probeer opnieuw'
      : m === 'staffel_niet_bevoegd' ? 'staffelkorting staat aan; alleen Vincent of Erica (die hem aanzette) kan deze bestelling zo bewaren – zet staffel eerst UIT'
      /* v32.3: gewone taal in plaats van technische codes (controle werkvloer 18-10) */
      : m === 'niet_meer_actief' ? 'deze bestelling is al afgerond of verwijderd'
      : m === 'niet_gevonden' || m === 'onbekend_of_verlopen' ? 'deze bestelling staat niet meer in de lijst'
      : m === 'plaatsen_bezig' ? 'deze bestelling wordt nu in Shopify geplaatst – wacht even en kijk dan opnieuw bij Openstaande bestellingen'
      : m === 'geen_claim' ? 'deze bestelling is niet (meer) door u geopend – open haar opnieuw via Openstaande bestellingen'
      : m === 'mand_leeg' ? 'de winkelwagen is leeg'
      : m === 'medewerker_verplicht' ? 'meld u eerst aan met uw naam'
      : m === 'omzetting_niet_toegestaan' || m === 'bron_wijzigen_via_omzetten' ? 'het soort bestelling kan hier niet worden gewijzigd'
      : /^http_5|fetch|network|netwerk|load failed/i.test(m || '') ? 'geen verbinding met de server – probeer het zo opnieuw'
      : (m ? 'onbekende fout (' + m + ') – meld dit aan Vincent' : 'onbekende fout – meld dit aan Vincent');
  }

  /* ---------- Verdergaan (hervatten) ---------- */
  function pkHervat(id, mandIsDeze) {   /* v32: mandIsDeze = de winkelwagen bevat precies deze bewaarde bestelling (markering na vergrendelen) */
    var knop = document.querySelector('[data-pk="verder"][data-id="' + id + '"]');
    if (knop) { knop.disabled = true; knop.textContent = 'Bezig…'; }
    var rec = null;
    mandKeten.then(laadMand).then(function (c) {
      if (c && c.item_count > 0 && actiefId() !== id && !mandIsDeze) { pkWinkelwagenVraag(c); throw new Error('stil'); }
      return pkVraag('POST', '/geparkeerd/claim', { id: id });
    }).then(function (r) {
      rec = r;
      pkActief = { id: rec.id, label: rec.klantLabel || '' };   /* v32 */
      var items = (rec.mand.regels || []).map(function (g) {
        var it = { id: g.variant_id, quantity: g.aantal };
        if (g.eigenschappen && Object.keys(g.eigenschappen).length) it.properties = g.eigenschappen;
        return it;
      });
      return post('/cart/clear.js', {}).then(function () { return post('/cart/add.js', { items: items }); });
    }).then(function () {
      staffelAan = false;
      return staffelSyncPlan();
    }).then(laadMand).then(function (c) {
      var mis = pkVergelijkMand(rec.mand.regels, c, rec.mand.staffel);
      if (mis.length) {
        return post('/cart/clear.js', {}).then(laadMand).then(function () {
          return pkVraag('POST', '/geparkeerd/vrijgeven', { id: id, reden: 'mand terugzetten mislukt' }).catch(function () {});
        }).then(function () {
          pkVenster('<h2>Bestelling kon niet worden teruggezet</h2><p>Deze producten zijn niet (meer) beschikbaar of anders: <b>' +
            esc(mis.join(', ')) + '</b>. De bewaarde bestelling is niet veranderd.</p>' +
            '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="sluit">Sluiten</button></div>');
          throw new Error('stil');
        });
      }
      ssZet(SS_ACTIEF, id);
      zetKanaal(rec.bron === 'telefoon' || rec.bron === 'papier' ? rec.bron : null); bronGekozen = true;   /* v17: opgeslagen bron */
      var p = pkPrijsVerschil(rec.mand, c);
      if (p.regels.length || p.totaalAnders) { pkToonPrijs(rec, p); return; }
      if (rec.staffelHerkeuring || (rec.mand && rec.mand.staffel)) { pkToonStaffel(rec); return; }   /* staffel nooit automatisch terug */
      pkGaVerder(rec);
    }).catch(function (e) {
      if (e && e.message === 'stil') return;
      if (mandIsDeze) lopendZet(null);   /* v32: markering niet bruikbaar (bv. elders afgerond) – gewone keuze */
      if (knop) { knop.disabled = false; knop.textContent = 'Verdergaan'; }
      toast('Verdergaan lukt niet: ' + pkFoutTekst(e), 4500);
    });
  }
  /* controle na terugzetten: elk bewaard product moet met het juiste aantal in de winkelwagen staan
     (staffelvarianten worden bij UIT teruggezet naar de basis; die tellen per productfamilie) */
  function pkVergelijkMand(regels, c, staffelWas) {
    var per = {}, perHandle = {};
    (c.items || []).forEach(function (it) { per[it.variant_id] = (per[it.variant_id] || 0) + it.quantity; perHandle[it.handle] = (perHandle[it.handle] || 0) + it.quantity; });
    var nodig = {}, nodigHandle = {};
    regels.forEach(function (g) { nodig[g.variant_id] = (nodig[g.variant_id] || 0) + g.aantal; nodigHandle[g.handle] = (nodigHandle[g.handle] || 0) + g.aantal; });
    var mis = [];
    regels.forEach(function (g) {
      var ok = per[g.variant_id] === nodig[g.variant_id] || (staffelWas && perHandle[g.handle] === nodigHandle[g.handle]);
      if (!ok && mis.indexOf(g.titel) === -1) mis.push(g.titel || String(g.variant_id));
    });
    return mis;
  }
  function pkPrijsVerschil(m, c) {
    var regels = [];
    m.regels.forEach(function (g) {
      if (g.refStukprijsCent == null) return;
      var it = (c.items || []).filter(function (x) { return x.variant_id === g.variant_id; })[0];
      if (!it) return;
      var nu_ = it.final_price != null ? it.final_price : it.price;
      if (nu_ !== g.refStukprijsCent) regels.push({ variant_id: g.variant_id, titel: g.titel, oudCent: g.refStukprijsCent, nieuwCent: nu_ });
    });
    var totaalAnders = m.refTotaalCent != null && m.refTotaalCent !== c.total_price;
    return { regels: regels, totaalAnders: totaalAnders, oudTotaal: m.refTotaalCent, nieuwTotaal: c.total_price, staffelWas: !!m.staffel };
  }
  var pkPrijsWacht = null;
  function pkToonPrijs(rec, p) {
    pkPrijsWacht = { rec: rec, p: p };
    pkVenster('<h2>' + esc(rec.klantLabel || 'Bestelling') + '</h2>' +
      '<div class="pk-prijs"><h3>PRIJS GEWIJZIGD SINDS DEZE BESTELLING WERD GEPARKEERD</h3>' +
      p.regels.map(function (r) { return '<div>' + esc(r.titel) + ': ' + esc(euroCent(r.oudCent)) + ' → <b>' + esc(euroCent(r.nieuwCent)) + '</b></div>'; }).join('') +
      '<div style="margin-top:8px">Nieuw bestellingstotaal: <b>' + esc(euroCent(p.nieuwTotaal)) + '</b>' +
      (p.oudTotaal != null ? ' (was ' + esc(euroCent(p.oudTotaal)) + ')' : '') + '</div>' +
      (p.staffelWas ? '<div style="margin-top:6px;font-weight:700">' + esc(pkStaffelTekst(rec)) + '</div>' : '') +
      '</div><p>Bespreek het nieuwe bedrag met de klant voordat je verder gaat.</p>' +
      '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="gezien">Gezien</button></div>');
  }
  /* Staffelkorting: standaard UIT; alleen Vincent en Erica mogen hem toekennen (zetStaffel controleert sessie.staffel,
     de backend controleert bij parkeren en bij /controle). Bij hervatten nooit automatisch aan – alleen deze melding. */
  function pkStaffelTekst(rec) {
    var door = rec && rec.mand && rec.mand.staffelDoor ? vind(rec.mand.staffelDoor) : null;
    return 'Er was eerder staffelkorting actief' + (door ? ' (toegekend door ' + door.naam + ')' : '') +
      '. Staffelkorting staat nu UIT en moet opnieuw worden gecontroleerd en toegekend door Vincent of Erica.';
  }
  function pkToonStaffel(rec) {
    pkPrijsWacht = { rec: rec, p: null };
    pkVenster('<h2>' + esc(rec.klantLabel || 'Bestelling') + '</h2>' +
      '<div class="pk-prijs"><h3>STAFFELKORTING OPNIEUW CONTROLEREN</h3><div>' + esc(pkStaffelTekst(rec)) + '</div>' +
      (sessie && sessie.staffel ? '<div style="margin-top:6px">Jij mag de staffelkorting in de winkelwagen opnieuw aanzetten als die nog van toepassing is.</div>'
        : '<div style="margin-top:6px">Jij kunt de staffelkorting niet aanzetten; vraag Vincent of Erica.</div>') + '</div>' +
      '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="gezien">Begrepen</button></div>');
  }
  function pkPrijsGezien() {
    var w = pkPrijsWacht; pkPrijsWacht = null;
    if (!w) return;
    if (!w.p) { pkGaVerder(w.rec); return; }   /* alleen staffelmelding */
    var wijz = w.p.regels.length ? w.p.regels.map(function (r) { return { variant_id: r.variant_id, oudCent: r.oudCent, nieuwCent: r.nieuwCent }; })
      : [{ variant_id: null, oudCent: w.p.oudTotaal, nieuwCent: w.p.nieuwTotaal }];
    pkVraag('POST', '/geparkeerd/prijs-gezien', { id: w.rec.id, wijzigingen: wijz, nieuwTotaalCent: w.p.nieuwTotaal })
      .catch(function () {}).then(function () { pkGaVerder(w.rec); });
  }
  function pkGaVerder(rec) {
    pkSluit();
    var trechterStap = (/^A/.test(rec.laatsteStap || '') && (rec.bron === 'telefoon' || rec.bron === 'papier') && IS_PC) ||
      rec.laatsteStap === 'v88' ||
      (/^A/.test(rec.laatsteStap || '') && rec.bron === 'winkel' && rec.trechter && rec.trechter.trechterVersie);   /* v32: winkelbestelling die in de tablettrechter werd vergrendeld/onderbroken – klant en keuzes gaan mee */   /* v18: onderbroken bezorgroute (automatisch bewaard vóór v88) – klant en keuzes gaan mee, bezorgdeel opnieuw via v88 */
    if (trechterStap) {
      /* v18: alleen de verwijzing naar het versleutelde serverrecord in de sessie; de tablettrechter haalt de gegevens zelf op (claim) */
      ssZet(SS_HERVAT, JSON.stringify({ id: rec.id, laatsteStap: rec.laatsteStap, bron: rec.bron, smsGeverifieerd: !!rec.smsGeverifieerd }));
      var nep = new URLSearchParams(location.search).get('nep') === '1';
      window.location.href = TABLETTRECHTER_URL + '?mw=' + encodeURIComponent(sessie.naam) + '&hervat=' + rec.id + (nep ? '&nep=1' : '');
      return;
    }
    toast('Verder met ' + (rec.klantLabel || 'de bestelling'), 3000);
    openMand();
  }

  /* ---------- verwijderen / omzetten ---------- */
  function pkVerwijderVraag(id, wagen) {
    pkVenster('<h2>Weet je het zeker?</h2><p>' + (wagen ? 'De winkelwagen wordt leeggemaakt' : 'De bewaarde bestelling wordt verwijderd') +
      (wagen && actiefId() ? ' en de bewaarde bestelling wordt verwijderd' : '') + '. Dit kan niet ongedaan worden gemaakt.</p>' +
      '<div class="pk-knoppen"><button class="pk-rood" data-pk="' + (wagen ? 'wagenwegja' : 'wegja') + '"' + (id ? ' data-id="' + id + '"' : '') + '>Ja, verwijderen</button>' +
      '<button data-pk="sluit">Nee</button></div>');
  }
  function pkVerwijder(id) {
    return pkVraag('POST', '/geparkeerd/verwijder', { id: id, reden: 'verwijderd in winkelmodule' });
  }
  function pkWagenWeg() {
    var id = actiefId();
    (id ? pkVerwijder(id).catch(function () {}) : Promise.resolve()).then(function () {
      return post('/cart/clear.js', {});
    }).then(laadMand).then(function () {
      ssZet(SS_ACTIEF, null); lopendZet(null); zetKanaal(null); bronGekozen = false; pkSluit(); toast('Winkelwagen leeggemaakt'); pkOverzicht(true);   /* v17: nieuwe bestelling = nieuwe bronkeuze */
    }, function (e) { toast('Leegmaken mislukt: ' + pkFoutTekst(e)); });
  }
  function pkOmzetten(id) {
    pkVraag('POST', '/geparkeerd/bron-omzetten', { id: id, naar: 'papier' }).then(function () {
      toast('Omgezet naar Papier – geen SMS meer nodig'); pkOverzicht(false);
    }, function (e) { toast('Omzetten mislukt: ' + pkFoutTekst(e)); });
  }

  /* ---------- vergrendeling vasthouden zolang in dit tabblad aan een hervatte bestelling wordt gewerkt ---------- */
  function pkHartslagStart() {
    clearInterval(pkHartslag);
    pkHartslag = setInterval(function () {
      var id = actiefId();
      if (id && sessie) pkVraag('POST', '/geparkeerd/verleng', { id: id }).catch(function () {});
    }, 240000);
  }

  /* ---------- v19: terugkomst na een AFGERONDE bestelling: mand leeg voor de volgende klant ----------
     De tablettrechter (Versie 17+) zet na een geplaatste bestelling jullens_afgerond = { ordernummer, mand, tijdstip, nep }.
     Alleen als de mand nog exact die bestelling bevat (zelfde vingerafdruk als de tablettrechter: variant:aantal, zonder
     bezorgkosten en kaartje) en het signaal vers is (60 min), wordt de mand leeggemaakt. Anders blijft alles staan:
     een werkelijk onafgemaakte bestelling gaat nooit verloren. Laatst afgerond blijft als geschiedenis zichtbaar. */
  var SS_AFGEROND = 'jullens_afgerond';
  /* v20: vingerafdruk v2 (zelfde code als tablettrechter Versie 18): variant, aantal én alle gevulde eigenschappen. */
  function mandRegelsCanon(items) {   // variant | aantal | alle gevulde eigenschappen (tekst, foto/logo, opties), gesorteerd
    var uit = ['starttarief-bezorging', 'kilometertoeslag-bezorging', 'bezorgkosten', 'kaartje-met-persoonlijke-boodschap'];
    return (items || []).filter(function (i) { return uit.indexOf(i.handle) === -1; }).map(function (i) {
      var p = i.properties || {}, e = Object.keys(p).filter(function (k) { return p[k] !== null && p[k] !== undefined && p[k] !== ''; }).sort()
        .map(function (k) { return [k, String(p[k])]; });
      return i.variant_id + '|' + i.quantity + '|' + JSON.stringify(e);
    }).sort().join('\n');
  }
  function mandHashV2(items) {   // SHA-256; leeg = '' (geen klantgegevens leesbaar in de sessie)
    var t = mandRegelsCanon(items); if (!t) return Promise.resolve('');
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(t)).then(function (b) {
      return Array.prototype.map.call(new Uint8Array(b), function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); });
  }
  function afgerondSignaal() { try { return JSON.parse(ssLees(SS_AFGEROND) || 'null'); } catch (e) { return null; } }
  /* v20: het signaal wordt pas verwijderd als (a) de mand bevestigd leeg is, (b) de mand een andere bestelling bevat, of
     (c) het signaal ongeldig/verlopen is. Mislukt het leegmaken (netwerk, Shopify-fout, mand na leegmaken niet leeg), dan
     blijft het signaal staan: automatisch nog twee pogingen (na 5 en 15 s) en opnieuw bij aanmelden. */
  var afgerondPogingen = 0, afgerondTimer = null;
  function wmNaAfronden() {
    var a = afgerondSignaal();
    if (!a) return Promise.resolve('geen');
    if (a.versie !== 2 || typeof a.mandV2 !== 'string' || !(Date.now() - a.tijdstip < 60 * 60 * 1000)) { ssZet(SS_AFGEROND, null); return Promise.resolve('ongeldig'); }
    afgerondPogingen++;
    return haalJson('/cart.js').then(function (c) {
      return mandHashV2(c.items).then(function (h) {
        if (!h) { ssZet(SS_AFGEROND, null); return laadMand().then(function () { return 'leeg'; }); }                 /* al leeg */
        if (h !== a.mandV2) { ssZet(SS_AFGEROND, null); meld('jwm:afgerond-mand-anders', { ordernummer: a.ordernummer }); return 'anders'; }   /* andere/gewijzigde bestelling: nooit wissen */
        ssZet(SS_ACTIEF, null); zetKanaal(null);
        return post('/cart/clear.js', {}).then(function () { return haalJson('/cart.js'); }).then(function (c2) {
          if (c2 && c2.item_count > 0) throw new Error('mand_niet_leeg');
          ssZet(SS_AFGEROND, null); afgerondPogingen = 0; lopendZet(null);   /* v32 */
          return laadMand().then(function () {
            toast('Bestelling ' + (a.ordernummer || '') + ' afgerond – winkelwagen is leeg voor de volgende klant', 3500);
            meld('jwm:afgerond-mand-leeg', { ordernummer: a.ordernummer, nep: !!a.nep });
            return 'leeg';
          });
        });
      });
    }).catch(function (e) {
      meld('jwm:afgerond-leegmaken-mislukt', { ordernummer: a.ordernummer, poging: afgerondPogingen, fout: String(e && e.message) });
      if (afgerondPogingen < 3) { clearTimeout(afgerondTimer); afgerondTimer = setTimeout(function () { mandKeten = mandKeten.then(wmNaAfronden).catch(function () {}); }, afgerondPogingen === 1 ? 5000 : 15000); }
      return 'mislukt';
    });
  }
  function pkAfgerondNietLeeg() {   /* v20: na aanmelden staat het signaal er nog – geen "Afmaken", maar eerlijk melden */
    var a = afgerondSignaal() || {};
    pkVenster('<h2>Afgeronde bestelling nog in de winkelwagen</h2><p>Bestelling <b>' + esc(a.ordernummer || '') + '</b> is afgerond, maar de winkelwagen kon nog niet worden leeggemaakt (geen verbinding met de webshop?).</p>' +
      '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="afgerondopnieuw">Opnieuw leegmaken</button><button data-pk="sluit">Later</button></div>');
  }
  function pkAfgerondOpnieuw() {
    afgerondPogingen = 0; clearTimeout(afgerondTimer);
    mandKeten = mandKeten.then(wmNaAfronden).then(function (r) { if (r === 'leeg' || r === 'anders' || r === 'ongeldig') { pkSluit(); pkOverzicht(true); } else pkAfgerondNietLeeg(); }).catch(function () {});
  }

  /* ---------- terugkomst uit de tablettrechter na "Later afronden" ---------- */
  function pkNaTrechter() {
    var q = new URLSearchParams(location.search), id = q.get('geparkeerd'), mw = q.get('mw') || '';
    if (!/^pk_[0-9a-f]{16}$/.test(id || '')) return;
    q.delete('geparkeerd'); q.delete('mw');
    try { history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q.toString() : '')); } catch (e) {}
    pkVraag('POST', '/geparkeerd/logboek', { id: id }, mw).then(function (r) {
      if (r.status !== 'open') return;
      ssZet(SS_ACTIEF, null); zetKanaal(null); lopendZet(null);   /* v32 */
      return post('/cart/clear.js', {}).then(laadMand).then(function () { toast('Bestelling bewaard – werkplek is vrij', 3500); pkStartInfo(); });
    }).catch(function () {});
  }

  /* ---------- v32.1: terug uit de tablettrechter met "elders" – de bewaarde bestelling is intussen door een collega geopend,
     afgerond of verwijderd (bijv. na 10 minuten in de bezorgroute). De winkelwagen hier is dan een kopie.
     Leegmaken gebeurt ALLEEN als de server dat bevestigt én de winkelwagen precies de gemarkeerde mand is (vingerafdruk).
     Anders blijft alles staan, met uitleg. Er wordt op de server nooit iets gewijzigd. ---------- */
  function pkNaElders() {
    var q = new URLSearchParams(location.search), id = q.get('elders'), mw = q.get('mw') || '';
    if (!/^pk_[0-9a-f]{16}$/.test(id || '')) return;
    q.delete('elders'); q.delete('mw');
    try { history.replaceState(null, '', location.pathname + (q.toString() ? '?' + q.toString() : '')); } catch (e) {}
    ssZet(SS_ACTIEF, null); zetKanaal(null); bronGekozen = false;
    var lp = lopendLees(), uitleg = 'Deze bestelling is intussen door een collega geopend of afgerond. Voer haar hier niet opnieuw in.';
    pkVraag('POST', '/geparkeerd/lijst', {}, mw).then(function (r) {
      if (!r || !Array.isArray(r.bestellingen)) throw new Error('onverwacht_antwoord');   /* nooit leegmaken op een onduidelijk antwoord */
      var rec = r.bestellingen.filter(function (x) { return x.id === id; })[0];
      var ov = rec && rec.overgenomen ? String(rec.overgenomen.sessie || rec.overgenomen.medewerker || '').toLowerCase() : '';
      var elders = !rec || !!rec.inBehandeling || !!(lp && lp.hervat && rec.laatstHervat && rec.laatstHervat.tijd !== lp.hervat) ||
                   !!(lp && ov && ov !== String(lp.medewerker || '').toLowerCase());
      if (!elders) { toast('Controleer de bestelling bij Openstaande bestellingen – de winkelwagen is niet gewijzigd.', 7000); return; }
      return haalJson('/cart.js').then(function (c) {
        if (!c || !c.item_count) { lopendZet(null); return; }
        return mandHashV2(c.items).then(function (h) {
          if (!lp || lp.parkeerId !== id || !h || h !== lp.mandV2) {
            pkVenster('<h2>Bestelling elders verder</h2><p>' + esc(uitleg) + ' De winkelwagen hier wijkt af van de bewaarde bestelling en is daarom niet automatisch leeggemaakt. ' +
              'Kijk bij Openstaande bestellingen en maak de winkelwagen zelf leeg als hij niet meer nodig is.</p><div class="pk-knoppen"><button data-pk="sluit">Sluiten</button></div>');
            return;
          }
          return post('/cart/clear.js', {}).then(laadMand).then(function () {
            lopendZet(null);
            toast((rec ? 'Deze bestelling wordt door een collega afgemaakt' : 'Deze bestelling is al afgerond of verwijderd') + ' – winkelwagen hier leeggemaakt', 7000);
            pkStartInfo();
          });
        });
      });
    }).catch(function (e) { toast('Controle lukt nog niet (' + pkFoutTekst(e) + '). ' + uitleg + ' Kijk bij Openstaande bestellingen.', 8000); });
  }

  /* ---------- klikken in de vensters ---------- */
  document.addEventListener('click', function (e) {
    var k = e.target.closest && e.target.closest('[data-pk]');
    if (!k || k.disabled) return;
    var a = k.getAttribute('data-pk'), id = k.getAttribute('data-id');
    if (a === 'sluit') pkSluit();
    else if (a === 'nieuw') { pkSluit(); bronGekozen = false; bronKeuze(); }   /* v17 */
    else if (a === 'bron') bronGekozenDoor(k.getAttribute('data-bron'));      /* v17 */
    else if (a === 'recentsluit') recentSluit();                                /* v17 */
    else if (a === 'alle') pkOverzicht(false);
    else if (a === 'afmaken') { pkSluit(); if (!actiefId() && !bronGekozen) bronKeuze(openMand); else openMand(); }   /* v17 */
    else if (a === 'later') pkVraagNaam();
    else if (a === 'parkeer') { var n = $('pk-naam'); pkParkeer(n ? n.value.replace(/\s+/g, ' ').trim() : ''); }
    else if (a === 'wagenweg') pkVerwijderVraag(null, true);
    else if (a === 'wagenwegja') pkWagenWeg();
    else if (a === 'afgerondopnieuw') pkAfgerondOpnieuw();   /* v20 */
    else if (a === 'verder') pkHervat(id);
    else if (a === 'weg') pkVerwijderVraag(id, false);
    else if (a === 'wegja') pkVerwijder(id).then(function () { toast('Verwijderd'); pkOverzicht(false); }, function (er) { toast('Verwijderen mislukt: ' + pkFoutTekst(er)); });
    else if (a === 'papier') pkOmzetten(id);
    else if (a === 'gezien') pkPrijsGezien();
    else if (a === 'lpover') { pkSluit(); pkHervat(id, true); }        /* v32 */
    else if (a === 'lpstaan') lopendLatenStaan(id);                    /* v32 */
    else if (a === 'onderbrokenstaan') { pkSluit(); pkOnderbrokenGezien = true; pkOverzicht(true); }   /* v32 */
  });
  document.addEventListener('keydown', function (e) {
    var v = $('wm-pk');
    if (!v || v.hidden) return;
    if (e.key === 'Enter' && e.target && e.target.id === 'pk-naam') { e.preventDefault(); var b = v.querySelector('[data-pk="parkeer"]'); if (b) b.click(); }
    else if (e.key === 'Escape') { var s = v.querySelector('[data-pk="sluit"],[data-pk="nieuw"],[data-pk="recentsluit"]'); if (s) s.click(); }
  }, true);




  /* ==========================================================
     v29/v30 – TELEFONISCHE OVERNAME VANUIT HET BELSCHERM (backend v1.12.2, tablettrechter Versie 28)
     Besluit Vincent 11-10-2026 (keuze B): de medewerker selecteert in het belscherm een oproep (Klantenlijn/Zakelijk) en kiest
     "Telefonische bestelling". Deze al geopende, aangemelde winkelmodule op dezelfde pc haalt die oproep op – één keer – en zet
     de telefonische bestelling klaar met het nummer (de tablettrechter zoekt daarmee de klant en vult het nummer in).
     Alleen op een pc, alleen met een gecontroleerde backendsessie (dezelfde medewerker als bij het aanmaken), alleen als er geen
     bestelling loopt: lege winkelwagen, geen hervatte/bewaarde bestelling, geen papierbestelling, geen overname in dit tabblad.
     Zo kan een tweede oproep een lopende bestelling nooit van klant laten wisselen (de server weigert hem ook: pc_bezig).
     Wordt de bestelling niet afgerond (uitloggen, wissel, inactief, Telefonisch uit, papier) dan wordt de overname vrijgegeven;
     bij Bewaren gaat de oproep mee met de bewaarde bestelling (na hervatten en plaatsen komt de terugmelding bij die oproep); na een geplaatste bestelling wist de tablettrechter hem (de server heeft hem dan al aan de order gekoppeld).
     ========================================================== */
  var OV_SLEUTEL = 'jullens_overname', OV_LIJN = 'jullens_lijn', OV_INTERVAL_MS = 3000, OV_MAX_MS = 60 * 60000;
  var ovBezig = false;
  function ovLees() {
    try { var x = JSON.parse(sessionStorage.getItem(OV_SLEUTEL) || 'null');
          if (!x || !/^ov_[0-9a-f]{20}$/.test(x.id)) return null;
          if (Date.now() - (x.tijd || 0) > OV_MAX_MS) { ssZet(OV_SLEUTEL, null); ssZet(OV_LIJN, null); return null; }   /* server: vervalt na 60 min */
          return x; } catch (e) { return null; }
  }
  function ovVraag(pad, body) {
    var s = pkSleutel(), tok = bvToken();
    if (!s || !tok) return Promise.reject(new Error('geen_sessie'));
    return fetch(PK_API + pad, { method: 'POST', headers: { Authorization: 'Bearer ' + s, 'Content-Type': 'application/json', 'X-Jullens-Sessie': tok },
      body: JSON.stringify(body || {}) }).then(function (r) {
        return r.json().catch(function () { return null; }).then(function (j) { if (!r.ok) throw new Error((j && j.fout) || ('http_' + r.status)); return j; });
      });
  }
  function ovVrijgeven(reden) {
    var x = ovLees(); if (!x) return;
    ssZet(OV_SLEUTEL, null); ssZet(OV_LIJN, null);
    var s = pkSleutel();
    if (s) fetch(PK_API + '/overname/vrijgeven', { method: 'POST', headers: { Authorization: 'Bearer ' + s, 'Content-Type': 'application/json' },
      body: JSON.stringify({ overnameId: x.id, reden: String(reden || '').slice(0, 40) }) }).catch(function () {});
  }
  /* v30 (voorstel Vincent 12-10-2026 – er komen ook andere telefoontjes tussendoor): NIET automatisch overnemen. De winkelmodule
     toont een balk "Oproep 06-… (naam, lijn)" met de knop "Oproep overnemen"; pas die klik koppelt de oproep aan deze bestelling
     (alleen precies de getoonde oproep – backend v1.12.2). "Niet nu" geeft de oproep vrij. */
  var ovGetoond = null;
  function ovMagOvernemen() { return mand.aantal === 0 && kanaal() !== 'papier' && !actiefId(); }
  function ovBalk(o) {
    var b = $('wm-ov-balk');
    if (!o) { if (b) b.hidden = true; ovGetoond = null; return; }
    if (!b) {
      var st = document.createElement('style');
      st.textContent = '#wm-ov-balk{position:fixed;left:50%;bottom:14px;transform:translateX(-50%);z-index:950;background:#1E2A27;color:#fff;border:3px solid #FFD700;' +
        'border-radius:14px;padding:10px 14px;display:flex;align-items:center;gap:12px;font-size:17px;box-shadow:0 6px 22px rgba(0,0,0,.35);max-width:94vw}' +
        '#wm-ov-balk b{color:#FFD700}#wm-ov-balk button{font:inherit;font-weight:700;border:0;border-radius:10px;padding:9px 16px;cursor:pointer}' +
        '#wm-ov-balk .ov-ja{background:#FFD700;color:#1E2A27}#wm-ov-balk .ov-ja:disabled{opacity:.45;cursor:default}#wm-ov-balk .ov-nee{background:#4A5A56;color:#fff}' +
        '#wm-ov-balk .ov-hint{font-size:13px;color:#ffd7a0}';
      document.head.appendChild(st);
      b = document.createElement('div'); b.id = 'wm-ov-balk'; b.setAttribute('role', 'alert');
      document.body.appendChild(b);
      b.addEventListener('click', function (e) {
        var k = e.target.closest('button'); if (!k || k.disabled || !ovGetoond) return;
        if (k.getAttribute('data-ov') === 'ja') ovNeemOver(ovGetoond); else ovNietNu(ovGetoond);
      });
    }
    var mag = ovMagOvernemen(), sec = o.verlooptOver || 0;
    b.innerHTML = '<span>📞 Oproep <b>' + esc(o.nummer || '') + '</b>' + (o.naam ? ' – ' + esc(o.naam) : '') + ' (' + esc(o.lijn) + ')' +
      ' <span class="ov-hint">nog ' + Math.floor(sec / 60) + ':' + ('0' + (sec % 60)).slice(-2) + '</span>' +
      (mag ? '' : '<br><span class="ov-hint">Rond eerst de huidige bestelling af of maak de winkelwagen leeg.</span>') + '</span>' +
      '<button type="button" class="ov-ja" data-ov="ja"' + (mag ? '' : ' disabled') + '>Oproep overnemen</button>' +
      '<button type="button" class="ov-nee" data-ov="nee">Niet nu</button>';
    b.hidden = false; ovGetoond = o;
  }
  function ovPeil() {
    if (!IS_PC || !sessie || !bvToken() || ovLees() || !$('wm-start') || !$('wm-start').hidden) { ovBalk(null); return; }
    if (ovBezig) return;
    ovBezig = true;
    ovVraag('/overname/kijk', {}).then(function (r) { ovBezig = false; ovBalk(r && r.overname ? r.overname : null); },
                                      function () { ovBezig = false; });
  }
  function ovNeemOver(o) {
    if (ovBezig) return;
    ovBezig = true;
    laadMand().then(function (c) {
      if (c && c.item_count > 0) { toast('De winkelwagen is niet leeg. Rond eerst de huidige bestelling af.', 5000); return null; }
      if (!ovMagOvernemen()) return null;
      return ovVraag('/overname/ophalen', { overnameId: o.id });
    }).then(function (r) {
      ovBezig = false;
      if (!r) return;
      var x = r.overname;
      if (!x) { toast(r.reden === 'vervangen' ? 'Er is intussen een andere oproep gekozen in het belscherm.' : 'Deze oproep is niet meer beschikbaar.', 4500); ovPeil(); return; }
      ssZet(OV_SLEUTEL, JSON.stringify({ id: x.id, oproepId: x.oproepId, nummer: x.nummer, naam: x.naam || '', lijn: x.lijn, medewerker: sessie && sessie.id, tijd: Date.now() }));
      ssZet(OV_LIJN, x.lijn);
      ovBalk(null);
      zetKanaal('telefoon'); bronGekozen = true;
      toast('📞 Oproep ' + x.nummer + (x.naam ? ' (' + x.naam + ')' : '') + ' overgenomen – kies de producten.', 5000);
      meld('jwm:overname', { oproep: x.oproepId, lijn: x.lijn });
    }, function (e) { ovBezig = false; toast('Overnemen mislukt: ' + pkFoutTekst(e) + '.', 4500); });
  }
  function ovNietNu(o) {
    var s2 = pkSleutel(); ovBalk(null);
    if (s2) fetch(PK_API + '/overname/vrijgeven', { method: 'POST', headers: { Authorization: 'Bearer ' + s2, 'Content-Type': 'application/json' },
      body: JSON.stringify({ overnameId: o.id, reden: 'niet_nu' }) }).catch(function () {});
  }
  if (IS_PC) {
    setInterval(ovPeil, OV_INTERVAL_MS);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) ovPeil(); });
    window.addEventListener('focus', ovPeil);
  }

  /* ==========================================================
     v24 – backendcontrole van de persoonlijke code (backend v1.10.0)
     Alleen voor medewerkers met staffelrecht (Vincent, Erica): na een juiste code op de tablet gaat dezelfde code (alleen in
     het geheugen, via HTTPS) naar de backend. Die geeft een kortlevende, apparaatgebonden sessie terug. Alleen het token
     staat in sessionStorage van dit tabblad – nooit de code. Korting en "op rekening" werken alleen met die sessie.
     ========================================================== */
  var BV_SLEUTEL = 'jullens_mw_sessie';
  function bvToken() {
    try { var x = JSON.parse(sessionStorage.getItem(BV_SLEUTEL) || 'null'); return x && sessie && x.medewerker === sessie.id && /^jms_[0-9a-f]{64}$/.test(x.token) ? x.token : null; } catch (e) { return null; }
  }
  function bvSessieStart(m, code) {
    var s = null; try { s = localStorage.getItem('jullens_tablet_apparaatsleutel'); } catch (e) {}
    if (!s) return Promise.resolve(null);
    return fetch('https://api.jullens.com/tablet/v1/sessie/start', { method: 'POST', headers: { Authorization: 'Bearer ' + s, 'Content-Type': 'application/json' },
      body: JSON.stringify({ medewerker: m.id, code: String(code) }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (x) {
        if (x.ok && x.j && x.j.token && sessie && sessie.id === m.id) { try { sessionStorage.setItem(BV_SLEUTEL, JSON.stringify({ token: x.j.token, medewerker: m.id })); } catch (e) {} bvZetStatus(m.id, true); return x.j.token; }
        try { sessionStorage.removeItem(BV_SLEUTEL); } catch (e) {}
        if (x.j && x.j.fout === 'geen_servercode') bvZetStatus(m.id, false);   /* v32: na vergrendeling dan alleen "Nee, andere medewerker" */
        if (x.j && x.j.fout === 'te_veel_pogingen') toast('Server: te veel foute codes – korting even niet mogelijk.', 6000);
        if (x.j && x.j.fout === 'geen_servercode' && IS_PC) toast(m.naam + ' heeft nog geen servercode. Telefonische overname vanuit het belscherm werkt pas als de code op de server is vastgelegd; gewoon bestellen gaat door.', 8000);   /* v29 (backend v1.12.1) */
        return null;
      }, function () { return null; });
  }
  function bvSessieStop() {
    var tok = null; try { var x = JSON.parse(sessionStorage.getItem(BV_SLEUTEL) || 'null'); tok = x && x.token; sessionStorage.removeItem(BV_SLEUTEL); } catch (e) {}
    var s = null; try { s = localStorage.getItem('jullens_tablet_apparaatsleutel'); } catch (e) {}
    if (tok && s) fetch('https://api.jullens.com/tablet/v1/sessie/stop', { method: 'POST', headers: { Authorization: 'Bearer ' + s, 'Content-Type': 'application/json', 'X-Jullens-Sessie': tok }, body: '{}' }).catch(function () {});
  }

  /* ==========================================================
     v24 – ROUTE (a): personaliseren op de echte productpagina (Globo)
     De medewerker kiest hier het aantal; daarna opent de productpagina in tabletmodus (assets/jullens-tablet-product.js),
     alleen met een ticket in sessionStorage van dit tabblad. Globo zet de keuzes/tekst/upload in de winkelwagen (aantal 1).
     Bij terugkomst controleert de winkelmodule de winkelwagen tegen de momentopname van vóór vertrek:
     - precies één nieuwe regel van dat product met aantal 1 (of één bestaande identieke regel +1);
     - alle andere regels ongewijzigd.
     Klopt het: de regel krijgt het gekozen aantal (eigenschappen blijven). Klopt het niet: de winkelwagen wordt teruggezet
     naar de momentopname (alleen wat er sinds vertrek bij kwam of veranderde) en er volgt een melding.
     Staffel: nooit automatisch; alleen de bestaande schakelaar van Vincent/Erica (backend controleert de bevoegdheid).
     ========================================================== */
  var PERS_TICKET = 'jullens_tablet_product', PERS_HERVAT = 'jullens_wm_pers_hervat', PERS_MS = 15 * 60000;
  function persLees(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function persZet(k, v) { try { if (v) sessionStorage.setItem(k, JSON.stringify(v)); else sessionStorage.removeItem(k); } catch (e) {} }
  function persWis() { persZet(PERS_TICKET, null); persZet(PERS_HERVAT, null); }
  function persNonce() { var a = new Uint8Array(8); crypto.getRandomValues(a); return Array.prototype.map.call(a, function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); }
  function persMinimum(it) {   /* kleinste ondergrens uit de variantnamen ("25-49 stuks", "25+ stuks"); anders 1 */
    var grenzen = [];
    (it.varianten || []).forEach(function (v) { (v.opties || []).forEach(function (o) { var r = /^(\d+)\s*(-|\+)/.exec(String(o)); if (r) grenzen.push(parseInt(r[1], 10)); }); });
    return grenzen.length ? Math.min.apply(null, grenzen) : 1;
  }
  function persStart(it) {
    var min = persMinimum(it), n = min;
    var o = document.createElement('div'); o.id = 'wm-pers';
    o.setAttribute('style', 'position:fixed;inset:0;z-index:9999;background:rgba(0,0,0,.45);display:flex;align-items:center;justify-content:center');
    o.innerHTML = '<div style="background:#fff;border-radius:12px;padding:20px 24px;min-width:320px;max-width:90%;font:16px system-ui,sans-serif">' +
      '<div style="font-weight:700;margin-bottom:8px">' + esc(it.naam) + '</div>' +
      '<div style="margin-bottom:14px">Hoeveel wilt u bestellen? Daarna kiest u op de productpagina de personalisatie (tekst, foto, opties).</div>' +
      '<div style="display:flex;gap:10px;align-items:center;margin-bottom:16px"><button type="button" data-pers="min" class="wm-aantal-min">−</button>' +
      '<span id="wm-pers-n" style="min-width:60px;text-align:center;font-weight:700">' + n + '</span><button type="button" data-pers="plus" class="wm-aantal-plus">+</button>' +
      (min > 1 ? '<span style="color:#666">(minimaal ' + min + ')</span>' : '') + '</div>' +
      '<div style="display:flex;gap:10px;justify-content:flex-end"><button type="button" data-pers="annuleer" class="wm-zij-knop">Annuleren</button>' +
      '<button type="button" data-pers="verder" class="wm-aantal-kies">Verder naar personaliseren</button></div></div>';
    document.body.appendChild(o);
    function zetN(x) { n = Math.max(min, x); $('wm-pers-n').textContent = n; }
    o.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pers]'); if (!b) return;
      var a = b.getAttribute('data-pers');
      if (a === 'min') zetN(n - (n > 25 ? 5 : 1));
      else if (a === 'plus') zetN(n + (n >= 25 ? 5 : 1));
      else if (a === 'annuleer') o.remove();
      else if (a === 'verder') { b.disabled = true; persVertrek(it, n).catch(function () { b.disabled = false; toast('Kon de winkelwagen niet lezen; probeer opnieuw.'); }); }
    });
  }
  function persVertrek(it, aantal) {
    return haalJson('/cart.js').then(function (c) {
      var voor = {}; (c.items || []).forEach(function (x) { voor[x.key] = x.quantity; });
      var nu = Date.now(), nonce = persNonce();
      persZet(PERS_TICKET, { v: 1, nonce: nonce, handle: it.handle, start: nu, verloopt: nu + PERS_MS, terug: location.pathname, toestand: 'open', voor: voor, gewenst: aantal });
      persZet(PERS_HERVAT, { nonce: nonce, tot: nu + PERS_MS, medewerker: sessie.id, kanaal: kanaal(), bronGekozen: !!bronGekozen, staffelAan: !!staffelAan });
      (window.__wmNaar || function (u) { window.location.href = u; })('/products/' + encodeURIComponent(it.handle) + '?jullens_tablet=' + nonce);   // __wmNaar: alleen lokale test
    });
  }
  /* Bij laden: terug van de productpagina? Herstel dezelfde sessie (zonder opnieuw de code) en verwerk de winkelwagen. */
  function persTerugkeer() {
    var p; try { p = new URLSearchParams(location.search).get('jullens_tablet_terug'); } catch (e) { p = null; }
    var tk = persLees(PERS_TICKET), hv = persLees(PERS_HERVAT);
    if (!tk && !hv) return false;
    var geldig = tk && hv && tk.nonce === hv.nonce && Date.now() < hv.tot && (!p || p === tk.nonce);
    var m = geldig && MEDEWERKERS.filter(function (x) { return x.id === hv.medewerker; })[0];
    try { if (p && history.replaceState) history.replaceState(null, '', location.pathname); } catch (e) {}
    if (!m) { persWis(); return false; }
    // sessie herstellen zoals hij was (geen nieuwe bronkeuze, staffelstand behouden)
    sessie = m; staffelAan = !!hv.staffelAan; staffelVraag = false; bronGekozen = !!hv.bronGekozen; zetKanaal(hv.kanaal || null);
    laatsteActiviteit = Date.now(); toonZijbalk(); $('wm-start').hidden = true; $('wm-inhoud').hidden = false; meet();
    meld('jwm:sessie-hersteld', { medewerker: m.id, reden: 'personaliseren' });
    var persVergrendel = Date.now() - (tk.start || 0) >= JullensSlot.NA_MS;   /* v32: langer dan 5 minuten weg op de productpagina = werkplek eerst vergrendelen */
    if (slot) slot.activiteit();
    mandKeten = mandKeten.then(function () { return persVerwerk(tk); }).then(function (tekst) {
      persWis(); toast(tekst, 6000); return laadMand();
    }, function () { persWis(); toast('De winkelwagen kon niet worden gecontroleerd. Kijk de bestelling na.', 8000); return laadMand(); })
      .then(function () { openMand(); if (persVergrendel && slot && mand.aantal > 0) slot.vergrendel(); }).catch(function () {});   /* v32 */
    return true;
  }
  function persVerwerk(tk) {
    return haalJson('/cart.js').then(function (c) {
      var voor = tk.voor || {}, nieuw = [], gewijzigd = [], weg = [];
      var nu = {}; (c.items || []).forEach(function (x) { nu[x.key] = x; if (!(x.key in voor)) nieuw.push(x); else if (x.quantity !== voor[x.key]) gewijzigd.push(x); });
      Object.keys(voor).forEach(function (k) { if (!nu[k]) weg.push(k); });
      var doel = null, aantal = 0, pagina = Math.max(1, parseInt(tk.aantalPagina || 1, 10));   /* v26: productpagina voegt het productminimum toe */
      if (tk.toestand !== 'geannuleerd' && weg.length === 0) {
        if (nieuw.length === 1 && gewijzigd.length === 0 && nieuw[0].handle === tk.handle && nieuw[0].quantity === pagina) { doel = nieuw[0]; aantal = tk.gewenst; }
        else if (nieuw.length === 0 && gewijzigd.length === 1 && gewijzigd[0].handle === tk.handle && gewijzigd[0].quantity === voor[gewijzigd[0].key] + pagina) { doel = gewijzigd[0]; aantal = voor[doel.key] + tk.gewenst; }
      }
      if (doel) return post('/cart/change.js', { id: doel.key, quantity: aantal }).then(function () { return 'Toegevoegd: ' + aantal + ' × ' + doel.product_title + ' met personalisatie.'; });
      if (nieuw.length === 0 && gewijzigd.length === 0 && weg.length === 0) return tk.toestand === 'geannuleerd' ? 'Personaliseren geannuleerd – de bestelling is ongewijzigd.' : 'Er is niets toegevoegd – de bestelling is ongewijzigd.';
      // iets anders dan verwacht: alleen wat sinds vertrek veranderde terugzetten (bestaande artikelen blijven)
      var acties = nieuw.map(function (x) { return function () { return post('/cart/change.js', { id: x.key, quantity: 0 }); }; })
        .concat(gewijzigd.map(function (x) { return function () { return post('/cart/change.js', { id: x.key, quantity: voor[x.key] }); }; }));
      return acties.reduce(function (p, f) { return p.then(f); }, Promise.resolve()).then(function () {
        return weg.length ? 'Let op: de winkelwagen is veranderd terwijl u personaliseerde (' + weg.length + ' regel(s) ontbreken). Kijk de bestelling na.'
                          : 'Er ging iets mis bij het personaliseren; de winkelwagen is teruggezet zoals hij was. Probeer opnieuw.';
      });
    });
  }

/* ===== JULLENS VERGRENDELING – versie 1 – 18-10-2026 (fase 1b, besluiten Vincent/GPT 18-10-2026) =====
     Gedeeld blok: staat letterlijk gelijk in winkelmodule V32 (assets/winkelmodule.js) en tablettrechter V32
     (templates/page.tablettrechter.liquid); een test controleert dat beide kopieën gelijk zijn.
     Werking:
     - Na 5 minuten zonder aanraking, klik, toets of scroll:
       * geen lopende bestelling -> gewoon afmelden (zoals vroeger na 3 minuten);
       * lopende bestelling -> VERGRENDELEN: ondoorzichtige laag over het hele scherm (geen klantgegevens zichtbaar, niets bedienbaar),
         de volledige stand wordt
         op de server bewaard en voor dit apparaat vastgehouden; direct daarna wordt de backendsessie beëindigd (zonder nieuwe code
         werkt geen bevoegde handeling meer). Mislukt bewaren, dan blijft het scherm toch dicht en wordt het elke
         minuut opnieuw geprobeerd.
     - "Ben jij nog bezig, <naam>?"
       * Ja, ik ben <naam> -> eigen persoonlijke code, door de SERVER gecontroleerd (een lokale code ontgrendelt nooit). Zonder servercode
         is Ja niet mogelijk; dan blijft "Nee, andere medewerker" de veilige weg.
       * Nee, andere medewerker -> pas als de bestelling zeker op de server staat: bewaren als onderbroken, afmelden, "Wie helpt er?".
       * Geen reactie -> de laag blijft; er gebeurt niets automatisch. Een bestelling wordt door inactiviteit nooit verwijderd,
         geplaatst of als betaald geregistreerd.
     - uitstel(): bijvoorbeeld tijdens het plaatsen (A10) wacht de vergrendeling tot het antwoord binnen is. */
  var JullensSlot = (function () {
    var NA_MS = 5 * 60 * 1000, HERHAAL_MS = 60 * 1000, HARTSLAG_MS = 4 * 60 * 1000;
    function maak(o) {
      var klok = o.klok || function () { return Date.now(); };
      var laatst = klok(), dicht = false, bezig = false, bewaard = false, scherm = 'vraag', melding = '', bewaarTimer = null, servercode = null;
      var laag = null, laatsteHartslag = klok();
      function el(id) { return laag ? laag.querySelector('[data-js="' + id + '"]') : null; }
      function esc2(t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function naam() { var m = o.medewerker && o.medewerker(); return m && m.naam ? m.naam : 'collega'; }
      function activiteit() { if (!dicht) laatst = klok(); }
      ['pointerdown', 'mousedown', 'touchstart', 'wheel', 'input', 'keydown'].forEach(function (t) { document.addEventListener(t, activiteit, { capture: true, passive: true }); });
      /* vergrendeld: toetsen buiten de laag bereiken de pagina nooit (window-capture gaat vóór alle andere luisteraars) */
      window.addEventListener('keydown', function (e) {
        if (!dicht || (laag && laag.contains(e.target))) return;
        e.preventDefault(); e.stopImmediatePropagation();
        if (laag) { var f = laag.querySelector('input,button:not([disabled])'); if (f) f.focus(); }
      }, true);
      function stijl() {
        if (document.getElementById('jl-slot-stijl')) return;
        var st = document.createElement('style'); st.id = 'jl-slot-stijl';
        st.textContent = '#jl-slot{position:fixed;inset:0;z-index:2147483600;background:#1E2A27;color:#fff;display:flex;align-items:center;justify-content:center;font-family:inherit}' +
          '#jl-slot .jl-kaart{background:#fff;color:#1E2A27;border-radius:16px;padding:26px 28px;max-width:560px;width:92vw;box-shadow:0 10px 40px rgba(0,0,0,.4)}' +
          '#jl-slot h2{margin:0 0 10px;font-size:26px}#jl-slot p{margin:6px 0;font-size:17px}#jl-slot .jl-st{font-size:15px;color:#4A5A56;margin-top:10px}' +
          '#jl-slot .jl-fout{color:#B3261E;font-weight:700}#jl-slot .jl-knoppen{display:flex;gap:12px;flex-wrap:wrap;margin-top:16px}' +
          '#jl-slot button{font:inherit;font-size:19px;font-weight:700;border:0;border-radius:12px;padding:14px 20px;cursor:pointer;min-height:56px;flex:1 1 200px}' +
          '#jl-slot .jl-ja{background:#3A524B;color:#fff}#jl-slot .jl-nee{background:#E8ECEA;color:#1E2A27}#jl-slot button:disabled{opacity:.45;cursor:default}' +
          '#jl-slot input{font-size:26px;letter-spacing:6px;padding:10px 12px;width:100%;box-sizing:border-box;border:2px solid #3A524B;border-radius:10px;margin-top:8px}';
        document.head.appendChild(st);
      }
      function teken() {
        if (!dicht) { if (laag) { laag.remove(); laag = null; } return; }
        stijl();
        if (!laag) { laag = document.createElement('div'); laag.id = 'jl-slot'; laag.setAttribute('role', 'dialog'); laag.setAttribute('aria-modal', 'true'); document.body.appendChild(laag);
          laag.addEventListener('click', klik); laag.addEventListener('keydown', function (e) { if (e.key === 'Enter' && scherm === 'code') { e.preventDefault(); ontgrendel(); } }); }
        var st = bezig ? 'Even geduld…' : bewaard ? 'De bestelling is veilig bewaard.' : 'De bestelling wordt op de server bewaard…';
        if (scherm === 'code') {
          laag.innerHTML = '<div class="jl-kaart"><h2>' + esc2(naam()) + ', voer je code in</h2><p>Je persoonlijke code (door de server gecontroleerd).</p>' +
            '<input data-js="code" type="password" inputmode="numeric" autocomplete="off" maxlength="12" aria-label="Persoonlijke code">' +
            (melding ? '<p class="jl-fout">' + esc2(melding) + '</p>' : '') +
            '<div class="jl-knoppen"><button class="jl-ja" data-js="ontgrendel"' + (bezig ? ' disabled' : '') + '>Ontgrendelen</button><button class="jl-nee" data-js="terug"' + (bezig ? ' disabled' : '') + '>Terug</button></div></div>';
          var c = el('code'); if (c) c.focus();
          return;
        }
        var jaKan = servercode !== false;
        laag.innerHTML = '<div class="jl-kaart"><h2>Ben jij nog bezig, ' + esc2(naam()) + '?</h2>' +
          '<p>Het scherm is vergrendeld na 5 minuten zonder bediening. Er gaat niets verloren.</p>' +
          (melding ? '<p class="jl-fout">' + esc2(melding) + '</p>' : '') +
          '<div class="jl-knoppen"><button class="jl-ja" data-js="ja"' + (jaKan && !bezig ? '' : ' disabled') + '>Ja, ik ben ' + esc2(naam()) + '</button>' +
          '<button class="jl-nee" data-js="nee"' + (bezig ? ' disabled' : '') + '>Nee, andere medewerker</button></div>' +
          (!jaKan ? '<p class="jl-st">' + esc2(naam()) + ' heeft nog geen servercode. Doorgaan kan alleen met een door de server gecontroleerde code; kies daarom "Nee, andere medewerker" – de bestelling blijft bewaard.</p>' : '') +
          '<p class="jl-st" data-js="status">' + esc2(st) + '</p></div>';
      }
      function klik(e) {
        var b = e.target.closest && e.target.closest('button'); if (!b || b.disabled) return;
        var a = b.getAttribute('data-js');
        if (a === 'ja') { scherm = 'code'; melding = ''; teken(); }
        else if (a === 'terug') { scherm = 'vraag'; melding = ''; teken(); }
        else if (a === 'ontgrendel') ontgrendel();
        else if (a === 'nee') nee();
      }
      function bewaarNu() {
        if (!dicht) return Promise.resolve(false);
        clearTimeout(bewaarTimer);
        return Promise.resolve().then(function () { return o.bewaar(); }).then(function (r) {
          if (r && r.ok) { bewaard = true; if (o.log) o.log('bewaard'); }
          else { bewaard = false; if (o.log) o.log('bewaren_mislukt', r && r.fout); bewaarTimer = setTimeout(bewaarNu, HERHAAL_MS); }
          teken(); return bewaard;
        }, function (e) { bewaard = false; if (o.log) o.log('bewaren_mislukt', e && e.message); bewaarTimer = setTimeout(bewaarNu, HERHAAL_MS); teken(); return false; });
      }
      function vergrendel() {
        if (dicht) return;
        dicht = true; scherm = 'vraag'; melding = ''; bewaard = false; bezig = false;
        servercode = o.heeftServercode ? o.heeftServercode() : null;
        try { if (document.activeElement && document.activeElement.blur) document.activeElement.blur(); } catch (e) { /* niets */ }
        teken();
        if (o.log) o.log('vergrendeld');
        /* eerst bewaren (een bestelling met staffelkorting mag alleen met de nog geldige sessie worden bewaard), daarna direct de
           backendsessie beëindigen; het scherm is op dat moment al dicht. Uiterlijk na 15 s stopt de sessie hoe dan ook. */
        var gestopt = false, stopEens = function () { if (gestopt) return; gestopt = true; try { o.stopSessie(); } catch (e) { /* vervalt vanzelf op de server */ } };
        setTimeout(stopEens, 15000);
        bewaarNu().then(stopEens, stopEens);
      }
      function ontgrendel() {
        var c = el('code'), code = c ? String(c.value || '').trim() : '';
        if (!/^[0-9]{4,12}$/.test(code)) { melding = 'De code bestaat uit 4 tot 12 cijfers.'; teken(); return; }
        bezig = true; melding = ''; teken();
        Promise.resolve().then(function () { return o.ontgrendel(code); }).then(function (r) {
          bezig = false;
          if (r && r.ok) {
            dicht = false; scherm = 'vraag'; laatst = klok(); clearTimeout(bewaarTimer); teken();
            if (o.log) o.log('ontgrendeld');
            if (o.naOntgrendel) o.naOntgrendel(bewaard);
            return;
          }
          var f = r && r.fout;
          if (f === 'geen_servercode') { servercode = false; scherm = 'vraag'; melding = naam() + ' heeft nog geen servercode – kies "Nee, andere medewerker".'; }
          else if (f === 'te_veel_pogingen' || f === 'geblokkeerd') melding = 'Te veel foute codes. Wacht 15 minuten of kies "Nee, andere medewerker".';
          else if (f === 'geen_verbinding') melding = 'Geen verbinding met de server. Ontgrendelen kan alleen met een gecontroleerde code – probeer het zo opnieuw.';
          else if (r && r.melding) melding = r.melding;
          else melding = 'De code klopt niet.';
          teken();
        }, function () { bezig = false; melding = 'Geen verbinding met de server. Probeer het zo opnieuw.'; teken(); });
      }
      function nee() {
        bezig = true; melding = ''; teken();
        (bewaard ? Promise.resolve(true) : bewaarNu()).then(function (ok) {
          if (!ok) { bezig = false; melding = 'Bewaren op de server is nog niet gelukt. De bestelling blijft op dit scherm staan; probeer het zo opnieuw.'; teken(); return; }
          return Promise.resolve().then(function () { return o.nee(); }).then(function (r) {
            if (r && r.ok === false) { bezig = false; melding = r.melding || 'Afmelden lukt nog niet. Probeer het zo opnieuw.'; teken(); return; }
            clearTimeout(bewaarTimer); dicht = false; bezig = false; laatst = klok(); teken();
            if (o.log) o.log('nee');
          });
        }).catch(function (e) { bezig = false; melding = 'Er ging iets mis (' + (e && e.message) + '). De bestelling blijft bewaard; probeer het opnieuw.'; teken(); });
      }
      function tik() {
        var n = klok();
        if (dicht) return;
        if (o.uitstel && o.uitstel()) { laatst = Math.max(laatst, n - NA_MS + 2000); return; }
        var stil = n - laatst;
        if (o.waarschuw) o.waarschuw(Math.max(0, NA_MS - stil), !!(o.lopend && o.lopend()));
        if (stil >= NA_MS) { if (o.lopend && o.lopend()) vergrendel(); else if (o.afmelden) { laatst = n; o.afmelden(); } return; }
        if (o.hartslag && stil < NA_MS && n - laatsteHartslag >= HARTSLAG_MS) { laatsteHartslag = n; try { o.hartslag(); } catch (e) { /* niets */ } }
      }
      var interval = o.geenInterval ? null : setInterval(tik, 1000);
      return { tik: tik, vergrendel: vergrendel, isDicht: function () { return dicht; }, isBewaard: function () { return bewaard; },
               activiteit: function () { laatst = klok(); }, zetLaatst: function (ms) { laatst = ms; }, stop: function () { clearInterval(interval); clearTimeout(bewaarTimer); },
               _laag: function () { return laag; } };
    }
    return { maak: maak, NA_MS: NA_MS };
  })();
  /* ===== EINDE JULLENS VERGRENDELING ===== */

  /* ==========================================================
     v32 – VIJFMINUTENREGELING (fase 1b; besluiten Vincent/GPT 18-10-2026; backend v1.18.0)
     Koppeling van het gedeelde blok JullensSlot (hierboven, letterlijk gelijk aan de tablettrechter) aan de winkelmodule.
     - Lopende bestelling = aangemelde medewerker + gevulde winkelwagen.
     - Vergrendelen: winkelwagen + bron + staffel op de server bewaren (/geparkeerd/parkeer, vasthouden) – dezelfde bewaarde
       bestelling als er al aan een bewaarde bestelling werd gewerkt (nooit een tweede record). De winkelwagen blijft staan.
       De oproep uit het belscherm blijft bij deze pc zolang het scherm vergrendeld is.
     - Ja: eigen code naar /sessie/start (de server controleert; een lokale code ontgrendelt nooit), daarna claim met ontgrendeld.
     - Nee: bewaren als onderbroken (met de oproep), winkelwagen leeg, afmelden, "Wie helpt er?".
     - Markering in localStorage (alleen id, vingerafdruk van de mand, medewerker-id en tijd; geen klantgegevens): wordt de
       browser gesloten terwijl het scherm vergrendeld is, dan biedt de volgende aanmelding "Overnemen" aan in plaats van
       "Afmaken" – zo ontstaat er geen tweede bestelling naast de bewaarde.
     ========================================================== */
  var LS_LOPEND = 'jullens_lopend_v1', SS_SERVERCODE = 'jullens_mw_servercode', LOPEND_MAX_MS = 24 * 3600000;
  var pkActief = { id: null, label: '' };
  var pkOnderbrokenGezien = false;
  /* vergrendeld-vlag in dit tabblad: na opnieuw laden is een aanmelding nodig en volgt "Overnemen" (geen stille voortzetting) */
  var SS_DICHT = 'jullens_slot_dicht';
  function zetDicht(aan) { ssZet(SS_DICHT, aan ? '1' : null); }
  function wasDicht() { return ssLees(SS_DICHT) === '1'; }
  function lopendLees() {
    try { var x = JSON.parse(localStorage.getItem(LS_LOPEND) || 'null');
          if (!x || !/^pk_[0-9a-f]{16}$/.test(x.parkeerId || '') || typeof x.mandV2 !== 'string' || !(Date.now() - (x.tijd || 0) < LOPEND_MAX_MS)) return null;
          return x; } catch (e) { return null; }
  }
  function lopendZet(x) { try { if (x) localStorage.setItem(LS_LOPEND, JSON.stringify(x)); else localStorage.removeItem(LS_LOPEND); } catch (e) {} }
  /* servercode bekend? true = sessie gelukt, false = de server kent (nog) geen code voor deze medewerker, null = onbekend */
  function bvZetStatus(id, waarde) { try { sessionStorage.setItem(SS_SERVERCODE, JSON.stringify({ medewerker: id, servercode: waarde })); } catch (e) {} }
  function bvStatus() {
    if (!sessie) return null;
    if (bvToken()) return true;
    try { var x = JSON.parse(sessionStorage.getItem(SS_SERVERCODE) || 'null'); return x && x.medewerker === sessie.id ? x.servercode : null; } catch (e) { return null; }
  }
  function slotUurMin() { var d = new Date(); return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2); }
  function slotLabel() {
    var id = actiefId();
    if (id && pkActief.id === id && pkActief.label) return pkActief.label;
    return 'Niet afgerond – ' + (sessie ? sessie.naam : '') + ' ' + slotUurMin();
  }
  /* winkelwagen op de server zetten; vlaggen = { vasthouden | onderbroken, reden, overnameId } */
  function slotParkeer(vlaggen) {
    clearTimeout(mandTimer);
    if (Object.keys(wachtrij).length) verwerkWachtrij();
    var id = actiefId();
    return mandKeten.then(laadMand).then(function (c) {
      if (!c || !c.item_count) return { leeg: true };
      var body = Object.assign({ bron: kanaal() || 'winkel', klantLabel: slotLabel(), laatsteStap: 'mand', trechter: {},
        mand: { regels: pkMandRegels(c), staffel: staffelAan, staffelDoor: staffelAan && sessie ? sessie.id : null, refTotaalCent: c.total_price } }, vlaggen || {});
      if (id) { body.id = id; delete body.bron; }
      var opslaan = function () { return pkVraag('POST', '/geparkeerd/parkeer', body); };
      return opslaan().catch(function (e) {
        if (id && e.message === 'geen_claim') return pkVraag('POST', '/geparkeerd/claim', { id: id }).then(opslaan);
        throw e;
      }).then(function (r) {
        return mandHashV2(c.items).then(function (h) { return { r: r, hash: h }; }, function () { return { r: r, hash: '' }; });
      });
    });
  }
  function slotBewaar() {
    return slotParkeer({ vasthouden: true, reden: 'vergrendeld' }).then(function (x) {
      if (x.leeg) return { ok: true };
      ssZet(SS_ACTIEF, x.r.id);
      pkActief = { id: x.r.id, label: x.r.klantLabel || pkActief.label || '' };
      if (x.hash) lopendZet({ parkeerId: x.r.id, mandV2: x.hash, medewerker: sessie ? sessie.id : '', tijd: Date.now() });
      return { ok: true };
    }, function (e) { return { ok: false, fout: e && e.message }; });
  }
  /* na Nee of een medewerkerwissel: winkelwagen leeg (de bestelling staat veilig op de server) en afmelden */
  function slotNaarStart(reden, tekst) {
    return post('/cart/clear.js', {}).then(function () { return haalJson('/cart.js'); }).then(function (c2) {
      if (c2 && c2.item_count > 0) throw new Error('mand_niet_leeg');
      return laadMand();
    }).then(function () {
      ssZet(SS_ACTIEF, null); ssZet(OV_SLEUTEL, null); ssZet(OV_LIJN, null); lopendZet(null); zetDicht(false); pkActief = { id: null, label: '' };
      eindeSessie(reden);
      toast(tekst, 4500);
      return { ok: true };
    }, function () {
      return { ok: false, melding: 'De bestelling staat veilig op de server, maar de winkelwagen kon nog niet worden leeggemaakt (geen verbinding met de webshop?). Probeer het zo opnieuw.' };
    });
  }
  function slotOnderbreek(reden) {
    var ov = ovLees();
    return slotParkeer(Object.assign({ onderbroken: true, reden: reden }, ov ? { overnameId: ov.id } : {}));
  }
  function slotNee() {
    return slotOnderbreek('andere_medewerker').then(function () {
      return slotNaarStart('vergrendeld', 'Bestelling bewaard als niet afgerond – de volgende medewerker kan haar overnemen');
    }, function (e) {
      if (e && (e.message === 'in_behandeling_elders' || e.message === 'niet_meer_actief'))   /* elders verder- of afgemaakt: deze winkelwagen is een kopie */
        return slotNaarStart('vergrendeld', 'Deze bestelling wordt op een ander apparaat afgemaakt – winkelwagen hier leeggemaakt');
      return { ok: false, melding: 'Bewaren als niet afgerond lukt nog niet (' + pkFoutTekst(e) + '). De bestelling blijft hier staan; probeer het zo opnieuw.' };
    });
  }
  function slotOntgrendel(code) {
    var s = pkSleutel(), m = sessie;
    if (!s || !m) return Promise.resolve({ ok: false, fout: 'geen_verbinding' });
    return fetch(PK_API + '/sessie/start', { method: 'POST', headers: { Authorization: 'Bearer ' + s, 'Content-Type': 'application/json' },
      body: JSON.stringify({ medewerker: m.id, code: String(code) }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j || {} }; }); },
            function () { return { ok: false, j: { fout: 'geen_verbinding' } }; })
      .then(function (x) {
        if (!x.ok || !x.j.token) {
          if (x.j.fout === 'geen_servercode') bvZetStatus(m.id, false);
          return { ok: false, fout: x.j.fout || 'code_onjuist' };
        }
        try { sessionStorage.setItem(BV_SLEUTEL, JSON.stringify({ token: x.j.token, medewerker: m.id })); } catch (e) {}
        bvZetStatus(m.id, true);
        var id = actiefId();
        if (!id) return { ok: true };
        return pkVraag('POST', '/geparkeerd/claim', { id: id, ontgrendeld: true, doorgaan: true }).then(function () { return { ok: true }; }, function (e) {
          if (e && e.status === 409) return { ok: false, melding: 'Deze bestelling is intussen ' + (e.message === 'in_behandeling_elders' ? 'op ' + ((e.details && e.details.apparaatNaam) || 'een ander apparaat') + ' geopend' : 'niet meer actief') +
            '. Kies "Nee, andere medewerker"; de winkelwagen hier wordt dan leeggemaakt.' };
          return { ok: true };   /* geen verbinding: de claim blijft van dit apparaat; de hartslag verlengt hem zodra er weer verbinding is */
        });
      });
  }
  /* v32: medewerkerwissel met een gevulde winkelwagen – eerst veilig bewaren als niet afgerond (reden wissel) */
  function wisselVeilig() {
    if (!sessie) return;
    if (!(mand.aantal > 0)) { eindeSessie('wissel'); return; }
    toast('Bestelling wordt bewaard…', 2000);
    slotOnderbreek('wissel').then(function () {
      return slotNaarStart('wissel', 'Bestelling bewaard als niet afgerond – de volgende medewerker kan haar overnemen');
    }).then(function (r) { if (r && r.ok === false) toast(r.melding, 7000); }, function (e) {
      toast('Wisselen kan pas als de bestelling op de server bewaard is (' + pkFoutTekst(e) + '). Probeer het opnieuw of rond eerst af.', 7000);
    });
  }
  /* v32: na aanmelden – bevat de winkelwagen precies een bestelling die bij het vergrendelen bewaard werd (browser gesloten)? */
  function lopendControle(c) {
    var lp = lopendLees();
    if (!lp || (actiefId() === lp.parkeerId && !wasDicht())) { pkWinkelwagenVraag(c); return; }
    zetDicht(false);
    mandHashV2(c.items).then(function (h) {
      if (!h || h !== lp.mandV2) { lopendZet(null); pkWinkelwagenVraag(c); return; }
      pkVenster('<h2>Bewaarde bestelling in de winkelwagen</h2>' +
        '<p>De winkelwagen bevat precies een bestelling die bij het vergrendelen van de werkplek op de server is bewaard (' + c.item_count +
        (c.item_count === 1 ? ' artikel' : ' artikelen') + ' · ' + esc(euroCent(c.total_price)) + '). Neem haar over, dan ga je verder met de bewaarde gegevens. ' +
        'Of laat haar staan: de winkelwagen wordt leeggemaakt en de bestelling blijft bij Openstaande bestellingen.</p>' +
        '<div class="pk-knoppen"><button class="pk-hoofd" data-pk="lpover" data-id="' + lp.parkeerId + '">Overnemen</button>' +
        '<button data-pk="lpstaan" data-id="' + lp.parkeerId + '">Laten staan</button></div>');
    }, function () { pkWinkelwagenVraag(c); });
  }
  function lopendLatenStaan(id) {
    pkSluit();
    pkVraag('POST', '/geparkeerd/vrijgeven', { id: id, reden: 'laten staan na vergrendeling' }).catch(function () {}).then(function () {
      return post('/cart/clear.js', {});
    }).then(laadMand).then(function () {
      ssZet(SS_ACTIEF, null); lopendZet(null); zetKanaal(null); bronGekozen = false;
      toast('Winkelwagen leeggemaakt – de bestelling staat bij Openstaande bestellingen', 4000); pkOverzicht(true);
    }, function (e) { toast('Leegmaken mislukt: ' + pkFoutTekst(e), 4500); });
  }
  function pkOnderbrokenVenster(lijst) {
    pkVenster('<h2>Niet-afgeronde bestellingen op deze werkplek</h2>' +
      '<p>Deze bestelling' + (lijst.length === 1 ? ' is' : 'en zijn') + ' onderbroken (scherm vergrendeld of medewerkerwissel). Kies eerst wat ermee gebeurt: ' +
      'overnemen, of laten staan en een nieuwe bestelling beginnen.</p>' + lijst.map(pkRij).join('') +
      '<div class="pk-knoppen"><button data-pk="onderbrokenstaan">Laten staan – verder</button></div>');
  }

  var slot = JullensSlot.maak({
    lopend: function () { return !!sessie && mand.aantal > 0; },
    bewaar: slotBewaar,
    nee: slotNee,
    medewerker: function () { return sessie ? { naam: sessie.naam } : null; },
    heeftServercode: bvStatus,
    ontgrendel: slotOntgrendel,
    stopSessie: bvSessieStop,
    naOntgrendel: function () { laatsteActiviteit = Date.now(); toast('Welkom terug, ' + (sessie ? sessie.naam : '') + ' – de bestelling staat er nog', 3500); },
    afmelden: function () { if (sessie) eindeSessie('inactief'); },
    waarschuw: function (rest, lopend) {
      var el = $('wm-afmeld'); if (!el || !sessie) return;
      if (rest > 0 && rest <= WAARSCHUW_MS) {
        el.textContent = lopend ? 'Het scherm wordt over ' + Math.ceil(rest / 1000) + ' s vergrendeld (de bestelling blijft bewaard) – tik om door te gaan'
                                : sessie.naam + ' wordt over ' + Math.ceil(rest / 1000) + ' s afgemeld – tik om door te gaan';
        el.hidden = false;
      }
    },
    hartslag: function () { if (sessie && bvToken()) pkVraag('GET', '/sessie').catch(function () {}); },
    log: function (wat, d) {
      if (wat === 'vergrendeld') zetDicht(true); else if (wat === 'ontgrendeld' || wat === 'nee') zetDicht(false);
      meld('jwm:slot', { wat: wat, detail: d || null });
    }
  });
  window.__wmSlot = slot;   /* alleen voor de lokale tests (geen bevoegdheden) */

  /* ---------- Start ---------- */
  toonZijbalk();
  laadGpoKaart();                /* v27: Globo-lijst ophalen voor de knop "Opties" */
  bouwStart();
  laadMand().catch(function () {});
  mandKeten = mandKeten.then(wmNaAfronden).catch(function () {});   /* v19: eerst een afgeronde mand opruimen, vóór de controle na aanmelden */
  pkNaTrechter();                /* v15: terug uit de tablettrechter na "Later afronden" */
  pkNaElders();                  /* v32.1: terug uit de tablettrechter – bestelling intussen elders geopend/afgerond */
  var persHersteld = persTerugkeer();   /* v24 route (a): terug van de productpagina → zelfde sessie en bestelling */
  if (!persHersteld) staffelSyncPlan();  /* bij laden altijd UIT: eventuele staffelregels terug naar basis */

  /* ---------- Koppelvlak voor volgende fasen ---------- */
  window.JullensWinkel = {
    versie: VERSIE,
    meet: meet,
    sessie: function () {
      return sessie ? { id: sessie.id, naam: sessie.naam, rol: sessie.rol, staffel: sessie.staffel } : null;
    },
    wisselMedewerker: function () { wisselVeilig(); },   /* v32 */
    personaliseer: function (item) { if (sessie && item && item.handle) persStart(item); },   /* v24 route (a) */
    herlaadReclame: laadReclame,
    herlaadProducten: laadHoofdblokken,
    niveau: function () { return stapel.map(function (s) { return s.titel; }); },
    mand: function () { return { aantal: mand.aantal, totaal: mand.totaal, regels: mand.regels }; },
    herlaadMand: laadMand,
    mandOpen: function () { return mandOpen; },
    staffel: function () { return { aan: staffelAan, door: staffelAan && sessie ? sessie.id : null }; },
    staffelControle: staffelSyncPlan,
    orderAfgerond: function () { eindeSessie('order'); },  /* aanroepen vanaf fase 9/11 */
    kanaal: kanaal,                                         /* v15 */
    openstaand: function () { return { totaal: pkInfo.totaal, perMedewerker: pkInfo.per }; },
    bronGekozen: function () { return bronGekozen; },        /* v17 */
    laatstAfgerond: function () { return recentLijst.slice(); }
  };
})();
/* Versie 23 – 05-10-2026 – assets/winkelmodule.js – balk Laatst afgerond: ook OP REKENING als afspraak (nooit BETAALD; backend v1.7.1); vorige: Versie 22 – 05-10-2026 – assets/winkelmodule.js – balk Laatst afgerond: betaalafspraak zichtbaar (PIN OP LOCATIE / BIJ AFHALEN), nooit als BETAALD (backend v1.7.0); vorige: Versie 21 – 05-10-2026 – assets/winkelmodule.js – pc-toetsenbord: Tab in het aantal-venster verwerkt het aantal (zoals Enter), Tab blijft in het codevenster; vorige: Versie 20 – 05-10-2026 – assets/winkelmodule.js – afgeronde mand: vingerafdruk v2 inclusief personalisatie en opties (gewijzigde bestelling wordt nooit gewist); signaal pas weg na bevestigd lege mand, bij mislukken automatisch opnieuw (5 s, 15 s) en bij aanmelden, met eerlijke melding in plaats van Afmaken; vorige: Versie 19 – 05-10-2026 – assets/winkelmodule.js – na een afgeronde bestelling (signaal jullens_afgerond van tablettrechter Versie 17) wordt de mand leeggemaakt als hij nog exact die bestelling bevat; een andere of onafgemaakte mand blijft staan; vorige: Versie 18 – 05-10-2026 – assets/winkelmodule.js – op de tablet automatisch bron WINKEL zonder keuzescherm (pc: keuze TELEFONISCH – WINKEL – PAPIER blijft); Verdergaan met een bestelling die automatisch bewaard is vóór de bezorgroute (stap v88) gaat naar de tablettrechter; bij elke overdracht naar de tablettrechter staat in de sessie alleen nog de verwijzing (id), geen klantgegevens (Aanvulling 2 compacte flow, tablettrechter Versie 15); vorige: Versie 17 – 04-10-2026 – assets/winkelmodule.js – bronkeuze TELEFONISCH – WINKEL – PAPIER na aanmelden bij elke nieuwe bestelling (op de tablet TELEFONISCH/PAPIER grijs; bij hervatten de opgeslagen bron; vangnet bij Bestelling afronden) en balk "Laatst afgerond" op Wie helpt er? (laatste 5 van vandaag: tijd · ordernummer · achternaam · bedrag · BETAALD/NIET BETAALD; aantikken = na aanmelden de bestelling bekijken; backend v1.6.1 /recent/*); vorige: Versie 16 – 03-10-2026 – assets/winkelmodule.js – Bestelling afronden gaat altijd eerst naar de tablettrechter (ook zonder Telefonisch/Papier, ook op de tablet); daar wordt Afhalen/Bezorgen één keer gekozen; vorige: Versie 15 – 03-10-2026 – assets/winkelmodule.js – openstaande bestellingen (Wie helpt er?: aantallen; na aanmelden: winkelwagen Afmaken | Later afronden | Verwijderen en eigen openstaande bestellingen; Verdergaan met vergrendeling, terugzetten, controle en prijsmelding; Omzetten naar Papier op pc), knop "Papier" naast "Telefonisch" (alleen pc), backend v1.5.1; vorige: Versie 14 – 27-09-2026 – assets/winkelmodule.js – toetsenbord (pc) voor code en aantal; knop "Telefonisch" alleen op pc -> tablettrechter in telefonische modus (geen SMS); vorige: Versie 13 – 26-09-2026 – FASE 5 tegelprijs uit basisvarianten (nooit staffel-/kortingsprijs op tegel) */
/* Versie 24 – 08-10-2026 – assets/winkelmodule.js – backendcontrole code Vincent/Erica (sessie, korting alleen met sessie; backend v1.10.0) + route (a): Personaliseren/Opties via de echte productpagina met Globo (tabletmodus, assets/jullens-tablet-product.js); aantal hier gekozen; bij terugkomst zelfde sessie en bestelling, controle op precies één nieuwe regel, anders terugzetten; vorige: Versie 23 – 05-10-2026 */
/* Versie 25 – 08-10-2026 – assets/winkelmodule.js – rustige tabletfoto's (_tablet, Shopify Bestanden, verkleind via CDN) op 9 hoofdtegels; overige tegels houden de webshopfoto; vorige: Versie 24 – 08-10-2026 */
/* Versie 26 – 08-10-2026 – assets/winkelmodule.js – terugkomst: productpagina voegt het productminimum toe (aantalPagina uit het ticket, browserproef 08-10); Warme produkten = hartige_produkten_tablet; vorige: Versie 25 – 08-10-2026 */
/* Versie 27 – 10-10-2026 – assets/winkelmodule.js – Globo-lijst (productOptionSetMap) eenmalig uit een productpagina lezen; knop "Opties (tekst, voorgesneden …)" verscheen in V26 nergens omdat Globo die lijst niet op de winkelmodulepagina zet; verder gelijk aan Versie 26 */
/* Versie 28 – 10-10-2026 – assets/winkelmodule.js – producten met een altijd verplicht Globo-veld (schildje-tekst, foto marsepeintaart vierkant met foto) alleen via "Opties" (geen directe +/- of Kies maat); infotekst persoonlijke producten verwijst naar "Personaliseren"; verder gelijk aan Versie 27 */
/* Versie 29 – 12-10-2026 – assets/winkelmodule.js – telefonische overname vanuit het belscherm (backend v1.12.0, tablettrechter Versie 28): op een pc haalt de aangemelde winkelmodule een geselecteerde oproep één keer op (alleen bij lege winkelwagen en geen lopende bestelling), zet Telefonisch aan met nummer en lijn; vrijgeven bij uitloggen/wissel/inactief/Telefonisch uit/papier; bewaren neemt de oproep mee naar de bewaarde bestelling (backend v1.12.1); melding geen servercode; backendsessie op een pc voor iedere medewerker (overname gebonden aan de medewerker). Verder gelijk aan Versie 28. */
/* Versie 30 – 12-10-2026 – assets/winkelmodule.js – voorstel Vincent: oproep NIET automatisch overnemen; balk met nummer, naam en lijn + knop "Oproep overnemen" (alleen precies die oproep, backend v1.12.2) en "Niet nu"; knop alleen aan bij lege winkelwagen, geen hervatte bestelling en geen papier. Verder gelijk aan Versie 29. */
/* Versie 32.5 – 23-10-2026 – assets/winkelmodule.js – herstel na controle ChatGPT (23-10 20:16, akkoord Vincent 20:24): (1) Enter kiest alleen uit resultaten van de huidige zoektekst, anders eerst zoeken en daarna kiezen; (2) onvolledige productlijst na laadfout wordt na 15 s bij de volgende zoekactie aangevuld (geslaagde groepen uit de cache), mislukte hoofdgroepen = duidelijke foutmelding met 'Opnieuw proberen', en bij gedeeltelijke resultaten een zichtbare waarschuwing; (3) Terug is actief en sluit het zoekvenster ook vanaf het hoofdscherm. Tikfouttolerantie blijft (meer letters = meestal minder suggesties). Verder gelijk aan Versie 32.4. */
/* Versie 32.4 – 23-10-2026 – assets/winkelmodule.js – productzoeken (opdracht Vincent 23-10-2026): vergrootglas 'Product zoeken' direct onder 'Bestelling'; zoekvenster over de productgroepen met suggesties tijdens het typen (deel van de naam, hoofdletter-/accentongevoelig, één letter tikfout toegestaan); veel treffers = lijst met fotootje/naam/prijs, 8 of minder = tegels met grote foto; product kiezen = naar de productgroep waar het staat (product gemarkeerd), Terug werkt gewoon; €0,00-producten niet; winkelwagen ongemoeid. Gebouwd op de live Versie 32.3 (niet op de nooit geplaatste 33/34). */
/* Versie 32.3 – 18-10-2026 – assets/winkelmodule.js – controle werkvloer 18-10 laat: technische foutcodes (niet_meer_actief, geen_claim, plaatsen_bezig, Failed to fetch …) als gewone Nederlandse zin; onbekende code met 'meld dit aan Vincent'. Ook (werkdag-simulatie): lege winkelwagen bij afmelden/wissel of aanmelden = verwijzing naar een hervatte bewaarde bestelling loslaten (claim vrijgeven, bewijs wissen), zodat een volgende bestelling nooit als die bewaarde bestelling wordt geplaatst. Verder gelijk aan Versie 32.2. */
/* Versie 32.2 – 18-10-2026 – assets/winkelmodule.js – correctie (controle 18-10 avond): kanaal niet meer telefonisch (Winkelwagen leegmaken, Papier, afmelden) = gekoppelde oproep vrijgeven; voorheen bleef hij in het tabblad staan en zocht de tablettrechter bij de volgende telefonische bestelling op het oude nummer (bestond al in V30). Verder gelijk aan Versie 32.1. */
/* Versie 32.1 – 18-10-2026 – assets/winkelmodule.js – correctie na beoordeling GPT (tablettrechter Versie 32.1): terug uit de tablettrechter met ?elders=<id> (bewaarde bestelling intussen door een collega geopend, afgerond of verwijderd) – winkelwagen alleen leegmaken als de server dat bevestigt en de winkelwagen precies de gemarkeerde mand is; anders uitleg en niets wijzigen. Vorige: Versie 32 – 18-10-2026 */
/* Versie 32 – 18-10-2026 – assets/winkelmodule.js – fase 1b vijfminutenregeling (besluiten Vincent/GPT 18-10-2026, backend v1.18.0): na 5 minuten zonder bediening afmelden (lege winkelwagen) of VERGRENDELEN (lopende bestelling: volledig scherm dicht, bestelling op de server bewaard en vastgehouden, backendsessie gestopt); Ja = eigen code door de server gecontroleerd (zonder servercode niet mogelijk), Nee = bewaren als onderbroken + afmelden; medewerkerwissel bewaart eerst; niet-afgeronde bestellingen van deze werkplek na aanmelden; markering na sluiten van de browser (geen dubbele bestelling); sessiekop bij /geparkeerd; vervangt de 3-minutenafmelding; vorige: Versie 30 – 12-10-2026 */
